// German translations

export default {
  settings: {
    title: "Systemeinstellungen",
    description: "Verwalten Sie alle Systemeinstellungen zentral, effizient und benutzerfreundlich",
    refresh: "Daten aktualisieren",
    selectSection: "Wählen Sie einen Bereich aus",
    selectSectionDescription: "Klicken Sie auf eine der Schaltflächen oben, um den Inhalt des gewünschten Bereichs anzuzeigen",
    general: "Allgemeine Einstellungen",
    generalDesc: "Unternehmenseinstellungen und Arbeitszeiten",
    theme: {
      sidebarOrder: {
        title: "Seitenleisten-Reihenfolge anpassen",
        description: "Ziehen Sie Elemente, um sie von wichtig nach weniger wichtig zu sortieren",
        tutorial: "Anleitung",
        reset: "Zurücksetzen",
        howToSort: "So sortieren Sie Seitenleistenelemente:",
        step1: "Klicken und halten Sie das Greif-Symbol (⋮⋮) bei einem Element",
        step2: "Ziehen Sie es nach oben oder unten an die gewünschte Position",
        step3: "Loslassen zum Ablegen. Die Reihenfolge wird automatisch gespeichert!",
        example: "Beispiel:",
        moveUp: "Nach oben",
        moveDown: "Nach unten",
        orderSavedAuto: "Reihenfolge automatisch gespeichert",
        savedSuccess: "Seitenleisten-Reihenfolge erfolgreich gespeichert!",
        resetSuccess: "Seitenleisten-Reihenfolge auf Standard zurückgesetzt!",
        resetConfirmTitle: "Seitenleisten-Reihenfolge zurücksetzen?",
        resetConfirmMessage: "Möchten Sie die Seitenleisten-Reihenfolge wirklich auf den Standard zurücksetzen? Diese Aktion kann nicht rückgängig gemacht werden.",
        cancel: "Abbrechen"
      }
    },
    themeDesc: "Farben und Erscheinungsbild anpassen",
    location: "Standort",
    locationDesc: "Unternehmensstandorte verwalten",
    departments: "Unternehmensabteilungen",
    departmentsDesc: "Unternehmensabteilungen definieren",
    deduction: "Verspätungseinstellungen",
    deductionDesc: "Regeln für Verspätungsabzüge",
    holidays: "Gesetzliche Feiertage",
    holidaysDesc: "Firmenkalender für gesetzliche Feiertage verwalten",
    ai: "KI-Einstellungen",
    aiDesc: "KI-Modelleinstellungen",
    language: "Spracheinstellungen",
    languageDesc: "Oberflächensprache wählen",
    company: "Unternehmensinformationen",
    companyDesc: "Unternehmensinformationen anzeigen und bearbeiten",
    help: {
      timezone: "Wird für Anwesenheit, Gehalt und Benachrichtigungen verwendet. Wählen Sie die Zeitzone des tatsächlichen Standorts.",
      workStart: "Standard-Arbeitsbeginn der Organisation. Bei zugewiesener Schicht gilt deren Beginn.",
      workEnd: "Standard-Arbeitsende der Organisation. Eine zugewiesene Schicht hat Vorrang.",
      gracePeriod: "Minuten nach Schichtbeginn, bevor jemand als verspätet gilt. Hinweis: Bei zugewiesener Schicht gilt zuerst deren Kulanzzeit.",
      workDays: "Wochentage, die als offizielle Arbeitstage für Anwesenheit, Abwesenheit und Gehalt zählen.",
      annualLeaveDays: "Jährliche Urlaubstage pro Mitarbeiter.",
      sickLeaveDays: "Erlaubte Krankheitstage pro Jahr.",
      leaveSettings: "Jahres- und Krankheitsurlaub sowie ob ungenutzte Tage ins nächste Jahr übertragen werden.",
      carryForward: "Nicht genutzten Jahresurlaub ins nächste Jahr übertragen? Wenn aus, verfällt der Rest am Jahresende.",
      maxCarryForward: "Maximale Tage, die bei aktivem Übertrag ins nächste Jahr übernommen werden dürfen.",
      overtimeEnabled: "Überstundenvergütung nach offiziellen Schichtzeiten aktivieren.",
      overtimeMultiplier: "Überstundenlohn: eine Stunde, zwei Stunden oder mehr.",
      overtimeMinimumHours: "Mindest-Überstunden in ganzen Stunden, bevor die Vergütung beginnt.",
      overtimeCalculationMethod: "Aggregation der Überstunden: täglich, wöchentlich oder monatlich.",
      attendanceExempt: "Bestimmte Arbeitsort-Typen vom Ein-/Auschecken ausnehmen (z. B. Zustellung oder Remote).",
      absencePenalty: "Gehaltstage, die bei unentschuldigter Abwesenheit abgezogen werden.",
      shifts: "Eine Schicht legt Arbeitszeiten und Kulanz für zugewiesene Mitarbeiter fest und überschreibt Organisationsdefaults.",
      shiftGracePeriod: "Kulanzzeit nur für diese Schicht. Danach gilt der Status „Verspätet“. Geldabzüge werden separat unter Verspätungseinstellungen definiert.",
      latePenaltyEnabled: "Automatische Verspätungsabzüge anhand der Regeln unten. „Verspätet“ und Geldabzug sind nicht dasselbe.",
      latePenaltyRules: "Jede Regel verknüpft Verspätungsminuten (ab Schichtbeginn) mit Abzugsart: Viertel-/Halb-/Ganztag oder Betrag.",
      delayMinutes: "Minuten ab Schichtbeginn, ab denen diese Regel gilt.",
      penaltyType: "Abzugsart: Anteil des Tagesgehalts oder individueller Betrag.",
      autoCheckoutEnabled: "Automatisches Auschecken, wenn jemand nach Schichtende vergisst auszustempeln.",
      autoCheckoutGraceHours: "Stunden nach Schichtende, bevor Auto-Checkout greift.",
      autoCheckoutCountOvertime: "Ob Stunden zwischen Schichtende und Auto-Checkout als Überstunden zählen.",
      autoCheckoutDeductionPolicy: "Abzug, wenn das System automatisch auscheckt, weil jemand das Ausstempeln vergessen hat. Filialen können folgen oder eigene Regeln setzen.",
      checkInSelfieMode: "Ob das Check-in-Selfie aus, optional oder Pflicht für die gewählten Arbeitsarten ist.",
      checkInSelfieApplyTo: "Für welche Arbeitsarten die Selfie-Richtlinie gilt (Büro, Remote, Hybrid, Lieferung).",
      sectionDeduction: "Regeln für Verspätungsstrafen festlegen (z. B. nach 30 Minuten = Vierteltag).",
      sectionHolidays: "Gesetzliche Feiertage hinzufügen, damit diese Tage nicht als Abwesenheit zählen.",
      sectionLanguage: "Oberflächensprache ändern (Arabisch / Englisch / Deutsch).",
      sectionCompany: "Firmenprofil, Arbeitszeiten, Schichten, Urlaub und Überstunden.",
    },
    generalSettings: {
      title: "Allgemeine Einstellungen",
      description: "Verwalten Sie die Unternehmenseinstellungen sowie die offiziellen Arbeits- und Pausenzeiten",
      workDays: "Arbeitstage",
      infoTitle: "Über die Einstellungen",
      infoDescription: "Über diese Seite können Sie alle allgemeinen Einstellungen der Organisation verwalten, einschließlich Arbeitszeiten, Pausen und wöchentlicher Arbeitstage.",
      generalInfo: "Allgemeine Informationen",
      companyName: "Unternehmensname",
      companyNamePlaceholder: "Unternehmensnamen eingeben",
      timezone: "Zeitzone",
      timezonePlaceholder: "Zeitzone auswählen",
      gracePeriod: "Karenzzeit (Minuten)",
      gracePeriodPlaceholder: "Beispiel: 30",
      minPresentHours: "Mindestarbeitsstunden",
      minPresentHoursPlaceholder: "Beispiel: 4",
      overtimeRate: "Überstundensatz",
      overtimeRatePlaceholder: "Beispiel: 1,5",
      dailyWorkingHours: "Tägliche Arbeitszeit",
      attendanceAdjustment: "Automatischen Abzug bei Verspätung und Überstundenzuschlag aktivieren",
      remoteDeduction: "Verspätungsabzug für Remote-Mitarbeiter aktivieren",
      workHours: "Arbeitszeitmodell",
      startTime: "Beginn",
      endTime: "Ende",
      workDaysLabel: "Arbeitstage",
      selectAtLeastOneWorkDay: "Bitte wählen Sie mindestens einen Arbeitstag aus",
      breaks: "Tägliche Pausenzeiten festlegen",
      addBreak: "Pause hinzufügen",
      breakNumber: "Pause",
      from: "Von",
      to: "Bis",
      startTimePlaceholder: "Startzeit",
      endTimePlaceholder: "Endzeit",
      workTimeRangeRequired: "Bitte Arbeitsbeginn und Arbeitsende festlegen",
      workTimeRangeInvalidFormat: "Ungültiges Zeitformat (HH:mm)",
      workTimeRangeSame: "Arbeitsbeginn und Arbeitsende dürfen nicht identisch sein",
      documentManagement: "Dokumentenverwaltung",
      documentDescription: "Diese Dokumente werden an alle Mitarbeiter gesendet",
      uploadNewDocument: "Neues Dokument hochladen",
      uploadedDocuments: "Hochgeladene Dokumente",
      noDocuments: "Keine Dokumente hochgeladen",
      size: "Größe",
      uploadDate: "Hochladedatum",
      delete: "Löschen",
      uploading: "Wird hochgeladen...",
      uploadDocument: "Dokument hochladen",
      refreshData: "Daten aktualisieren",
      saveChanges: "Änderungen speichern",
      editMode: "Bearbeitungsmodus",
      loading: "Wird geladen...",
      hours: "Stunden",
      minutes: "Minute",
      hoursAndMinutes: "Stunden und",
      tokenNotFound: "Authentifizierungstoken nicht gefunden",
      loadFailed: "Fehler beim Laden der Arbeitszeiteinstellungen",
      settingsNotFound: "Arbeitszeiteinstellungen nicht gefunden",
      settingsLoaded: "Einstellungen erfolgreich geladen",
      updateFailed: "Fehler beim Aktualisieren der Arbeitszeiteinstellungen",
      settingsSaved: "Einstellungen erfolgreich gespeichert",
      filesLoadFailed: "Fehler beim Laden der Dokumentliste",
      filesLoaded: "Dokumentliste erfolgreich geladen",
      selectFile: "Bitte wählen Sie eine Datei zum Hochladen aus",
      uploadFailed: "Fehler beim Hochladen des Dokuments",
      uploadSuccess: "Dokument erfolgreich hochgeladen",
      deleteFailed: "Fehler beim Löschen des Dokuments",
      deleteSuccess: "Dokument erfolgreich gelöscht"
    },

    shifts: {
      title: "Schichten",
      description: "Definieren Sie mehrere Schichten und weisen Sie Mitarbeitern eine Schicht zu.",
      orgWide: "Unternehmensweit",
      branchDescription: "Definieren Sie Schichten für diese Filiale. Mitarbeiter können Filial- oder Firmenschichten zugewiesen werden.",
      branchInheritDescription: "Diese Filiale übernimmt Firmenschichten (nur Vorschau). Wählen Sie „Filialschichten anpassen“, um eigene Schichten hinzuzufügen.",
      add: "Schicht hinzufügen",
      edit: "Schicht bearbeiten",
      name: "Schichtname",
      namePlaceholder: "z. B. Frühschicht",
      nameRequired: "Schichtname erforderlich (mind. 2 Zeichen)",
      workStart: "Schichtbeginn",
      workEnd: "Schichtende",
      gracePeriod: "Kulanzzeit (Minuten)",
      gracePeriodShort: "Kulanz {minutes} Min.",
      active: "Aktiv",
      inactive: "Inaktiv",
      loading: "Schichten werden geladen...",
      empty: "Noch keine Schichten. Fügen Sie Schichten hinzu, wenn es mehrere Arbeitszeiten gibt.",
      loadFailed: "Schichten konnten nicht geladen werden",
      createSuccess: "Schicht erfolgreich erstellt",
      updateSuccess: "Schicht erfolgreich aktualisiert",
      saveFailed: "Schicht konnte nicht gespeichert werden",
      deleteConfirm: "Schicht \"{name}\" löschen?",
      deleteSuccess: "Schicht erfolgreich gelöscht",
      deleteFailed: "Schicht konnte nicht gelöscht werden",
      deactivated: "Schicht deaktiviert, da Mitarbeiter zugewiesen sind",
      employeesCount: "{count} Mitarbeiter",
    },
    companyInformation: {
      title: "Unternehmensinformationen",
      description: "Grundlegende Unternehmensinformationen anzeigen und bearbeiten",
      noData: "Keine Unternehmensdaten verfügbar",
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      basicInfo: "Grundinformationen",
      companyName: "Firmenname",
      companyNamePlaceholder: "z. B. Teamin",
      companyCode: "Firmencode",
      descriptionLabel: "Beschreibung",
      descriptionPlaceholder: "z. B. Unternehmen für Anwesenheit und Personalwesen",
      industry: "Branche",
      industryPlaceholder: "z. B. Informationstechnologie",
      contactInfo: "Kontaktinformationen",
      email: "E-Mail",
      emailPlaceholder: "z. B. info@company.com",
      phone: "Telefon",
      phonePlaceholder: "z. B. 1012345678",
      website: "Website",
      websitePlaceholder: "z. B. https://example.com",
      address: "Adresse",
      street: "Straße",
      streetPlaceholder: "z. B. Nilstraße 123",
      city: "Stadt",
      cityPlaceholder: "z. B. Kairo",
      state: "Bundesland/Region",
      statePlaceholder: "z. B. Giza",
      country: "Land",
      countryPlaceholder: "z. B. Ägypten",
      postalCode: "Postleitzahl",
      postalCodePlaceholder: "z. B. 11511",
      gracePeriodPlaceholder: "z. B. 15",
      dateFormatPlaceholder: "z. B. DD-MM-YYYY",
      annualLeaveDaysPlaceholder: "z. B. 21",
      sickLeaveDaysPlaceholder: "z. B. 30",
      maxCarryForwardPlaceholder: "z. B. 7",
      absencePenaltyDaysPlaceholder: "z. B. 1",
      latitudePlaceholder: "z. B. 30.0444",
      longitudePlaceholder: "z. B. 31.2357",
      radiusPlaceholder: "z. B. 150",
      organizationSettings: "Organisationseinstellungen",
      timezone: "Zeitzone",
      selectTimezone: "Zeitzone auswählen",
      workStart: "Arbeitsbeginn",
      workEnd: "Arbeitsende",
      gracePeriod: "Karenzzeit",
      inMinutes: "in Minuten",
      minutes: "Minuten",
      workDays: "Arbeitstage",
      displayFormat: "Anzeigeformat",
      dateFormat: "Datumsformat",
      leaveSettings: "Urlaubseinstellungen",
      annualLeaveDays: "Jahresurlaubstage",
      sickLeaveDays: "Krankheitstage",
      carryForward: "Übertrag erlauben",
      maxCarryForward: "Max. Übertragstage",
      overtimeSettings: "Überstundeneinstellungen",
      enabled: "Aktiviert",
      multiplier: "Überstunde",
      minimumHours: "Mindeststunden",
      overtimeHoursNone: "Kein Minimum",
      overtimeHoursOne: "1 Stunde",
      overtimeHoursTwo: "2 Stunden",
      overtimeHoursFew: "{n} Stunden",
      overtimeHoursMany: "{n} Stunden",
      calculationMethod: "Berechnungsmethode",
      daily: "Täglich",
      weekly: "Wöchentlich",
      monthly: "Monatlich",
      yes: "Ja",
      no: "Nein",
      on: "An",
      off: "Aus",
      companyLocations: "Unternehmensstandorte",
      companyLocationsDescription: "Unternehmensstandorte verwalten und auf der Karte anzeigen",
      clickMapToSelect: "Auf die Karte klicken, um den Standort auszuwählen",
      selectedLocation: "Ausgewählter Standort",
      companyLocation: "Unternehmensstandort",
      locationName: "Standortname",
      locationNamePlaceholder: "z. B. Hauptbüro",
      addressPlaceholder: "z. B. Nilstraße 123, Kairo",
      latitude: "Breitengrad",
      longitude: "Längengrad",
      radiusMeters: "Radius (Meter)",
      noLocationSet: "Kein Standort festgelegt",
      getLocationFailed: "Standort konnte nicht ermittelt werden",
      getMyCurrentLocation: "Meinen aktuellen Standort abrufen",
      clickMapOrEnterManually: "Auf die Karte klicken oder manuell eingeben",
      nameRequired: "Firmenname ist erforderlich",
      phoneInvalid: "Ungültige Telefonnummer",
      emailInvalid: "Ungültiges E-Mail-Format",
      websiteInvalid: "Ungültige Website-URL",
      updateSuccess: "Unternehmensinformationen erfolgreich aktualisiert",
      totalDeductionOnAbsence: "Gesamtabzug bei Abwesenheit: {n} Gehalts-{unit}",
      totalSalaryDeductionOnAbsence: "Gesamter Gehaltsabzug bei Abwesenheit",
      sunday: "Sonntag",
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag",
      attendanceExemptTitle: "Von Ein-/Auschecken befreit",
      attendanceExemptHint: "Wählen Sie Arbeitsort-Typen, die nicht ein- oder auschecken müssen. Abgleich mit dem Feld \"Arbeitsort\" des Mitarbeiters.",
      attendanceExemptEnabled: "Befreiung aktivieren",
      attendanceExemptWorkLocations: "Befreite Arbeitsort-Typen",
      attendanceExemptWorkLocationsHint: "Ein Mitarbeiter ist nur befreit, wenn sein Arbeitsort mit einem ausgewählten Typ übereinstimmt.",
      attendanceExemptSelectAtLeastOne: "Aktivieren Sie die Befreiung und wählen Sie mindestens einen Typ aus.",
      selectAtLeastOneWorkDay: "Bitte wählen Sie mindestens einen Arbeitstag aus.",
      attendanceExemptNoneSelected: "Keine Typen ausgewählt",
      workLocationOffice: "Büro",
      workLocationRemote: "Fernarbeit",
      workLocationHybrid: "Hybrid",
      workLocationDelivery: "Auftragszustellung",
      absencePenaltyTitle: "Einstellungen für Abwesenheitsstrafen",
      absencePenaltyEnabled: "Aktiviert",
      absencePenaltyDaysLabel: "Abgezogene Gehaltstage (gesamt)",
      absencePenaltyDaysHint: "Dies ist die Gesamtzahl der Gehaltstage, die bei unentschuldigtem Fehlen ohne genehmigten Urlaub abgezogen werden. Beispiel: Bei Eingabe von 2 werden zwei Gehaltstage abgezogen. Bei Deaktivierung wird nur ein Tag abgezogen.",
      absencePenaltyDaysDisabledHint: "Bei Deaktivierung: Es wird nur ein Gehaltstag abgezogen (der Fehltag).",
      absencePenaltyNotifyAdmin: "Vorgesetzten benachrichtigen",
      absencePenaltyNotifyEmployee: "Mitarbeiter benachrichtigen",
      day: "Tag",
      days: "Tage"
    },
    themeSettings: {
      title: "Design-Einstellungen",
      description: "Wählen Sie Ihr bevorzugtes Farbschema und Design",
      saveChanges: "Änderungen speichern",
      colorTheme: "Farbschema",
      unsavedChange: "Nicht gespeicherte Änderung",
      current: "Aktuell",
      preview: "Vorschau des ausgewählten Designs",
      primaryButton: "Primärer Button",
      secondaryButton: "Sekundärer Button",
      saved: "Einstellungen erfolgreich gespeichert!"
    },
    locationSettings: {
      title: "Legen Sie die Unternehmensadresse auf der Karte fest und definieren Sie dann den Bereich, in dem sich Mitarbeiter einchecken können.",
      loading: "Wird geladen...",
      searchLocation: "Standort suchen",
      searchPlaceholder: "Standort suchen (z. B. Kairo, Ägypten)",
      search: "Suchen",
      searching: "Suche läuft...",
      getMyLocation: "Meinen Standort abrufen",
      gettingLocation: "Standort wird abgerufen...",
      retry: "Erneut versuchen",
      latitude: "Breitengrad",
      latitudePlaceholder: "Breitengrad (z. B. 30.0444)",
      longitude: "Längengrad",
      longitudePlaceholder: "Längengrad (z. B. 31.2357)",
      setLocation: "Standort festlegen",
      selectedCoordinates: "Ausgewählte Koordinaten",
      radius: "Radius",
      meters: "Meter",
      replaceCurrent: "Aktuellen Standort ersetzen",
      addNew: "Neuen Standort hinzufügen",
      deleteSelected: "Ausgewählten Standort löschen",
      location: "Standort",
      updateRadius: "Radius aktualisieren (in Metern)",
      radiusPlaceholder: "Neuen Radius eingeben",
      updateZone: "Zone aktualisieren",
      delete: "Löschen",
      browserNotSupported: "Browser unterstützt Geolokalisierung nicht.",
      permissionDenied: "Zugriff auf den Standort wurde verweigert. Bitte aktivieren Sie den Standortzugriff in den Browsereinstellungen.",
      locationUnavailable: "Standortinformationen nicht verfügbar. Bitte versuchen Sie es später erneut.",
      locationTimeout: "Zeitüberschreitung bei der Standortanfrage. Bitte versuchen Sie es erneut.",
      locationError: "Beim Abrufen Ihres Standorts ist ein Fehler aufgetreten.",
      permissionCheckError: "Standortberechtigungen konnten nicht überprüft werden. Bitte versuchen Sie es erneut.",
      searchRequired: "Bitte geben Sie einen Ortsnamen zur Suche ein",
      locationNotFound: "Standort nicht gefunden. Bitte versuchen Sie es mit einem anderen Namen.",
      searchError: "Fehler bei der Standortsuche. Bitte versuchen Sie es erneut.",
      selectLocationFirst: "Bitte wählen Sie zuerst einen Standort auf der Karte aus",
      selectOrConfirm: "Bitte wählen Sie einen Standort auf der Karte aus oder stellen Sie sicher, dass ein zu ersetzender Standort vorhanden ist",
      locationUpdated: "Standort erfolgreich aktualisiert",
      updateFailed: "Standort konnte nicht aktualisiert werden",
      updateError: "Fehler beim Aktualisieren des Standorts",
      radiusRequired: "Bitte geben Sie einen gültigen Radius ein",
      radiusUpdated: "Radius erfolgreich aktualisiert",
      radiusUpdateFailed: "Radius konnte nicht aktualisiert werden",
      radiusUpdateError: "Fehler beim Aktualisieren des Radius",
      locationAdded: "Neuer Standort erfolgreich hinzugefügt",
      locationAddFailed: "Standort konnte nicht hinzugefügt werden",
      locationAddError: "Fehler beim Hinzufügen des Standorts",
      deleteConfirm: "Sind Sie sicher, dass Sie diesen Standort löschen möchten?",
      locationDeleted: "Standort erfolgreich gelöscht",
      locationDeleteFailed: "Standort konnte nicht gelöscht werden",
      locationDeleteError: "Fehler beim Löschen des Standorts",
      invalidCoordinates: "Bitte geben Sie gültige Breiten- und Längengrade ein",
      invalidLatitude: "Breitengrad muss zwischen -90 und 90 liegen",
      invalidLongitude: "Längengrad muss zwischen -180 und 180 liegen",
      fetchFailed: "Standorte konnten nicht abgerufen werden",
      selectedLocation: "Ausgewählter Standort:"
    },
    deductionSettings: {
      title: "Verspätungseinstellungen",
      description: "Verwalten Sie die Regeln für Verspätungsabzüge für Mitarbeiter",
      rulesCount: "Regeln definiert",
      howItWorks: "Wie funktionieren die Verspätungsregeln?",
      howItWorksDesc: "Abzugsregeln werden basierend auf der Dauer der Verspätung angewendet. Wenn die Verspätung beispielsweise zwischen 30 und 60 Minuten beträgt, wird 0,5 des Tagesgehalts abgezogen.",
      rules: "Verspätungsregeln",
      addNewRule: "Neue Regel hinzufügen",
      minMinutes: "Minimum (Minuten)",
      maxMinutes: "Maximum (Minuten)",
      deductionRate: "Abzugssatz",
      actions: "Aktionen",
      noRules: "Noch keine Regeln hinzugefügt",
      min: "Min.",
      max: "Max.",
      fractionPlaceholder: "Abzugssatz",
      note: "Hinweis: Stellen Sie sicher, dass das Minimum in allen Regeln kleiner als das Maximum ist.",
      refreshData: "Daten aktualisieren",
      saveChanges: "Änderungen speichern",
      editMode: "Bearbeitungsmodus",
      loading: "Wird geladen...",
      tokenNotFound: "Authentifizierungstoken nicht gefunden",
      loadFailed: "Verspätungseinstellungen konnten nicht geladen werden",
      settingsNotFound: "Verspätungseinstellungen nicht gefunden",
      loaded: "Verspätungseinstellungen erfolgreich geladen",
      minMustBeLess: "Minimum muss kleiner als Maximum sein",
      allFieldsRequired: "Bitte füllen Sie alle Felder aus (Minimum, Maximum, Abzug)",
      ruleError: "Regel",
      updateFailed: "Verspätungseinstellungen konnten nicht aktualisiert werden",
      saved: "Verspätungseinstellungen erfolgreich gespeichert",
      enableLateSettings: "Verspätungseinstellungen aktivieren",
      enableLateSettingsDesc: "Strafsystem aktivieren oder deaktivieren",
      enabled: "Aktiviert",
      disabled: "Deaktiviert",
      penaltyRules: "Strafregeln",
      addRule: "Regel hinzufügen",
      addFirstRule: "Erste Regel hinzufügen",
      availablePenaltyTypes: "Verfügbare Straftypen:",
      autoPenaltyTypes: "Viertel- / Halb- / Ganzer Tag:",
      autoPenaltyTypesDesc: "Wird automatisch anhand der Arbeitsstunden berechnet — kein Betrag nötig",
      customPenaltyType: "Benutzerdefiniert:",
      customPenaltyTypeDesc: "Sie können einen Strafbetrag, Straftage oder beides festlegen",
      noRulesDefined: "Keine Regeln definiert",
      rule: "Regel",
      minute: "Minute",
      day: "Tag",
      delayMinutes: "Verspätungsminuten",
      penaltyType: "Straftyp",
      selectPenaltyType: "Straftyp auswählen",
      none: "Keine",
      quarterDay: "Vierteltag",
      halfDay: "Halber Tag",
      fullDay: "Ganzer Tag",
      custom: "Benutzerdefiniert",
      quarterDayAuto: "Vierteltag (automatisch)",
      halfDayAuto: "Halber Tag (automatisch)",
      fullDayAuto: "Ganzer Tag (automatisch)",
      customSpecify: "Benutzerdefiniert (Betrag oder Tage)",
      autoCalculatedHint: "Diese Strafe wird automatisch anhand der Arbeitsstunden berechnet",
      penaltyAmount: "Strafbetrag",
      penaltyDays: "Straftage",
      optional: "(optional)",
      example15: "z. B. 15",
      example200: "z. B. 200",
      example05: "z. B. 0,5",
      leaveEmptyUseDays: "Sie können dieses Feld leer lassen, wenn Sie nur Straftage verwenden",
      leaveEmptyUseAmount: "Sie können dieses Feld leer lassen, wenn Sie nur den Strafbetrag verwenden"
    },
    autoCheckout: {
      title: "Einstellungen für automatisches Auschecken",
      description: "Steuern Sie, wann Mitarbeiter nach Schichtende automatisch ausgecheckt werden, wenn sie das Auschecken vergessen",
      loading: "Einstellungen werden geladen...",
      refresh: "Aktualisieren",
      edit: "Bearbeiten",
      save: "Speichern",
      saving: "Wird gespeichert...",
      cancel: "Abbrechen",
      enabled: "Automatisches Auschecken aktivieren",
      enabledHint: "Wenn aktiviert, werden Mitarbeiter nach einer festgelegten Zeit nach Schichtende automatisch ausgecheckt",
      on: "An",
      off: "Aus",
      graceHours: "Stunden nach Schichtende",
      graceHoursHint: "Stunden nach Arbeitsende vor dem automatischen Auschecken (0 bis 24)",
      graceHoursInvalid: "Stunden müssen zwischen 0 und 24 liegen",
      hours: "Stunden",
      countOvertime: "Überstunden zählen",
      countOvertimeHint: "Wenn aktiviert, kann Zeit nach Schichtende als Überstunden gezählt werden",
      notifyEmployee: "Mitarbeiter benachrichtigen",
      notifyEmployeeHint: "Benachrichtigung an den Mitarbeiter bei automatischem Auschecken",
      notifyAdmin: "Admin benachrichtigen",
      notifyAdminHint: "Benachrichtigung an Admins bei automatischem Auschecken",
      loadFailed: "Laden der Einstellungen fehlgeschlagen",
      settingsNotFound: "Einstellungen nicht gefunden",
      saved: "Einstellungen erfolgreich gespeichert",
      saveFailed: "Speichern der Einstellungen fehlgeschlagen",
      deductionTitle: "Abzug bei vergessenem Checkout",
      deductionHint: "Legen Sie fest, ob ein vergessenes Auschecken vom Gehalt abgezogen wird und in welcher Höhe.",
      policyFree: "Kein Abzug",
      policyQuarterDay: "Vierteltag",
      policyHalfDay: "Halber Tag",
      policyFixedAmount: "Fester Betrag",
      fixedAmount: "Fester Betrag",
      fixedAmountHint: "Abzugsbetrag in der Gehaltswährung",
      fixedAmountInvalid: "Geben Sie einen positiven Betrag mit höchstens 2 Dezimalstellen ein"
    },
    checkInSelfie: {
      title: "Check-in-Selfie-Einstellungen",
      description: "Unternehmensstandard für Selfies beim Check-in. Filialen können dies übernehmen oder eigene Regeln setzen.",
      loading: "Check-in-Selfie-Einstellungen werden geladen...",
      refresh: "Aktualisieren",
      edit: "Bearbeiten",
      save: "Speichern",
      saving: "Wird gespeichert...",
      cancel: "Abbrechen",
      mode: "Selfie-Modus",
      modeHint: "Wählen Sie deaktiviert, optional oder erforderlich",
      modes: {
        off: "Aus",
        optional: "Optional",
        required: "Erforderlich",
      },
      modeHints: {
        off: "Kein Selfie beim Check-in anfordern",
        optional: "Selfie anzeigen, Überspringen erlauben",
        required: "Mitarbeiter muss ein Selfie machen, um einzuchecken",
      },
      applyTo: "Für Arbeitsarten",
      applyToHint: "Die Richtlinie gilt nur für ausgewählte Arbeitsarten",
      applyToRequired: "Mindestens eine Arbeitsart auswählen",
      modeInvalid: "Ungültiger Selfie-Modus",
      workTypes: {
        office: "Büro",
        remote: "Remote",
        hybrid: "Hybrid",
        delivery: "Lieferung",
      },
      loadFailed: "Laden der Check-in-Selfie-Einstellungen fehlgeschlagen",
      settingsNotFound: "Check-in-Selfie-Einstellungen nicht gefunden",
      saved: "Check-in-Selfie-Einstellungen erfolgreich gespeichert",
      saveFailed: "Speichern der Check-in-Selfie-Einstellungen fehlgeschlagen",
    },
    aiSettings: {
      title: "KI-Einstellungen",
      description: "Verwalten Sie KI-Modell-API-Schlüssel einfach und sicher",
      setApiKey: "API-Schlüssel festlegen",
      newApiKey: "Neuer API-Schlüssel",
      newApiKeyPlaceholder: "Neuen API-Schlüssel eingeben",
      createApiKey: "API-Schlüssel erstellen",
      noApiKeys: "Keine API-Schlüssel verfügbar",
      fetchFailed: "API-Schlüssel konnten nicht abgerufen werden",
      fetchError: "Fehler beim Abrufen der API-Schlüssel",
      onlyOneKey: "Sie können nur einen API-Schlüssel erstellen",
      createFailed: "API-Schlüssel konnte nicht erstellt werden",
      createError: "Fehler beim Erstellen des API-Schlüssels",
      updateFailed: "API-Schlüssel konnte nicht aktualisiert werden",
      updateError: "Fehler beim Aktualisieren des API-Schlüssels",
      deleteFailed: "API-Schlüssel konnte nicht gelöscht werden",
      deleteError: "Fehler beim Löschen des API-Schlüssels",
      loading: "Wird geladen..."
    },
    holidaysSettings: {
      title: "Gesetzliche Feiertage",
      description: "Verwalten und konfigurieren Sie gesetzliche Feiertage",
      fetchFailed: "Feiertage konnten nicht geladen werden",
      updateSuccess: "Feiertag erfolgreich aktualisiert",
      updateFailed: "Feiertag konnte nicht aktualisiert werden",
      deleteConfirm: "Sind Sie sicher, dass Sie diesen Feiertag löschen möchten?",
      deleteSuccess: "Feiertag erfolgreich gelöscht",
      deleteFailed: "Feiertag konnte nicht gelöscht werden"
    },
    createdBy: "Erstellt von",
    created: "Erstellt",
    lastUpdated: "Zuletzt aktualisiert",
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    create: "Erstellen",
    createDepartment: "Abteilung erstellen",
    newDepartmentName: "Name der neuen Abteilung",
    departmentBadge: "Abteilung"
  },
  languageSelector: {
    title: "Spracheinstellungen",
    description: "Wählen Sie die Oberflächensprache",
    arabic: "العربية",
    english: "English",
    save: "Änderungen speichern",
    unsaved: "Nicht gespeicherte Änderung",
    german: "Deutsch"
  },
  dashboard: {
    title: "Dashboard",
    description: "Übersicht über Ihre Informationen",
    seeMore: "Mehr anzeigen",
    seeLess: "Weniger anzeigen",
    tabs: {
      employee: "Für Mitarbeiter",
      profile: "Mein Profil",
      manager: "Für Vorgesetzte"
    },
    errors: {
      tokenNotFound: "Token nicht gefunden",
      fetchFailed: "Dashboard-Daten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
      retry: "Erneut versuchen"
    },
    loading: {
      loadingData: "Daten werden geladen...",
      loadingPayroll: "Gehaltsdaten werden geladen...",
      loadingEmployees: "Mitarbeiterdaten werden geladen..."
    },
    leaveBalance: {
      sickLeave: "Krankheitsurlaub",
      annualLeave: "Jahresurlaub",
      workFromHome: "Homeoffice",
      days: "Tage",
      used: "Genutzt",
      total: "Gesamt",
      thisMonth: "Diesen Monat"
    },
    empty: {
      noDashboardTitle: "Keine Daten verfügbar",
      noDashboardMessage: "Derzeit sind keine Dashboard-Daten verfügbar. Bitte versuchen Sie es später erneut oder kontaktieren Sie die Verwaltung.",
      noEmployeeTitle: "Keine Daten",
      noEmployeeMessage: "Keine Mitarbeiterdaten zur Anzeige verfügbar."
    },
    roles: {
      admin: "Administrator",
      manager: "Manager",
      employee: "Mitarbeiter",
      hr: "Personalwesen",
      accountant: "Buchhalter"
    },
    employeeInfo: {
      directManager: "Direkter Vorgesetzter",
      department: "Abteilung",
      branch: "Filiale",
      workLocation: "Aktueller Arbeitsort"
    },
    manager: {
      totalEmployees: "Mitarbeiter gesamt",
      workFromHome: "Homeoffice",
      outsideOffice: "Außerhalb des Büros",
      pendingRequests: "Ausstehende Genehmigungen",
      pendingRequestsCount: "ausstehende Mitarbeiter",
      expiringDocuments: "Erinnerung: Dokumente laufen bald ab",
      expiringDocumentsDesc: "Dokumente, die innerhalb von 30 Tagen ablaufen",
      expiresIn: "Läuft ab am",
      days: "Tage",
      quickShortcuts: "Ausstehende Anfragen",
      quickShortcutsDesc: "Anfragen, die geprüft werden müssen",
      underReview: "In Prüfung",
      viewAllRequests: "Alle Anfragen anzeigen",
      noPendingRequests: "Keine ausstehenden Anfragen",
      contract: "Arbeitsvertrag",
      visa: "Arbeitsvisum",
      present: "Pünktlich anwesend",
      late: "Verspätet",
      absent: "Abwesend",
      attendanceRate: "Anwesenheitsquote",
      totalAttendance: "Gesamtanwesenheit",
      activeEmployees: "Aktive Mitarbeiter",
      pendingEmployees: "Mitarbeiter in Wartestellung",
      inactiveEmployees: "Inaktive Mitarbeiter",
      seeMore: "Mehr anzeigen",
      seeLess: "Weniger anzeigen",
      cardDetailsEmpty: "Keine Mitarbeiter in dieser Kategorie",
      cardDetailsLoading: "Daten werden geladen...",
      cardDetailsClose: "Schließen",
      cardDetailsName: "Name",
      cardDetailsDepartment: "Abteilung",
      cardDetailsPosition: "Position",
      cardDetailsStatus: "Status",
      cardDetailsCheckIn: "Einstempelzeit",
      cardDetailsEmail: "E-Mail",
      cardDetailsPhone: "Telefon",
      cardDetailsCount: "{count} Mitarbeiter",
      cardDetailsLeaveCount: "{count} Anträge",
      cardDetailsLeaveEmpty: "Keine ausstehenden Urlaubsanträge",
      cardDetailsLeaveType: "Urlaubsart",
      cardDetailsLeaveDates: "Zeitraum",
      cardDetailsLeaveDays: "Tage",
      viewPendingLeavesPage: "Seite der ausstehenden Anträge",
      pendingLeavesViewOnlyHint: "Nur Ansicht — hier keine Genehmigung oder Ablehnung. Klicken Sie auf eine Zeile oder die Schaltfläche, um die Seite der ausstehenden Anträge zu öffnen.",
      leaveCategory: {
        annual: "Jahresurlaub",
        sick: "Krankheit",
        workFromHome: "Homeoffice",
        emergency: "Notfall",
        maternity: "Mutterschaft"
      },
      inactiveEmployeesHint: "Hier erscheinen nur inaktive Mitarbeiter: deaktivierte, «in Ausbildung», sowie jeder Status außer «aktiv».",
      help: {
        totalEmployees: "Gesamtzahl der im System registrierten Mitarbeiter, unabhängig von Status oder heutiger Anwesenheit.",
        workFromHome: "Remote-Mitarbeiter, die heute eingestempelt haben.",
        outsideOffice: "Hybrid- und Liefermitarbeiter, die heute außerhalb der Bürozone eingestempelt haben.",
        pendingRequests: "Urlaubsanträge, die noch auf die Freigabe durch Manager oder Admin warten.",
        present: "Mitarbeiter, die heute pünktlich (innerhalb der Kulanzzeit) eingestempelt haben.",
        late: "Mitarbeiter, die heute nach Ablauf der Kulanzzeit eingestempelt haben.",
        absent: "Mitarbeiter ohne heutigen Check-in, die als abwesend gelten.",
        attendanceRate: "Anteil der heute Anwesenden und Verspäteten an allen aktiven Mitarbeitern.",
        totalAttendance: "Summe der heutigen Anwesenheitsdatensätze (anwesend + verspätet + abwesend).",
        activeEmployees: "Mitarbeiter mit Status «aktiv» im System, unabhängig vom heutigen Check-in.",
        pendingEmployees: "Mitarbeiter, die auf Beitrittsfreigabe oder Kontoaktivierung warten.",
        inactiveEmployees: "Inaktive Mitarbeiter: deaktiviert, «in Ausbildung» oder jeder Status außer «aktiv»."
      }
    },
    profile: {
      editMyInfo: "Meine Informationen bearbeiten",
      edit: "Profil bearbeiten",
      save: "Speichern",
      saving: "Wird gespeichert...",
      cancel: "Abbrechen",
      updateSuccess: "Profil erfolgreich aktualisiert",
      email: "E-Mail",
      emailPlaceholder: "E-Mail eingeben",
      phone: "Telefonnummer",
      phonePlaceholder: "Telefonnummer eingeben",
      employeeId: "Mitarbeiter-ID",
      joinDate: "Eintrittsdatum",
      directManager: "Direkter Vorgesetzter",
      department: "Abteilung",
      workLocation: "Arbeitsort",
      additionalInfo: "Zusätzliche Informationen",
      address: "Adresse",
      addressPlaceholder: "Adresse eingeben",
      nationalID: "Personalausweisnummer",
      gender: "Geschlecht",
      education: "Bildung",
      educationPlaceholder: "Bildungsabschluss eingeben",
      skills: "Qualifikationen",
      accountStatus: "Kontostatus",
      active: "Aktiv",
      attendanceSummary: "Anwesenheitsübersicht",
      totalDeductions: "Gesamtabzüge",
      allowances: "Zulagen",
      allowancesAssigned: "Ihnen zugewiesene Zulagen",
      emergencyContact: "Notfallkontakt",
      relation: "Beziehung",
      bank: "Bank",
      errors: {
        noEmployeeId: "Mitarbeiter-ID nicht gefunden",
        noChanges: "Keine Änderungen zum Speichern",
        updateFailed: "Profil konnte nicht aktualisiert werden"
      }
    },
    common: {
      notSpecified: "Nicht angegeben",
      unknown: "Unbekannt",
      document: "Dokument",
      leave: "Urlaub"
    },
    activeEmployees: {
      title: "Aktive Mitarbeiter",
      description: "Heute eingecheckte Mitarbeiter",
      presentCount: "{count} pünktlich anwesend",
      remoteCount: "{count} remote",
      attendanceRate: "{percent}% Anwesenheitsrate",
      loading: "Mitarbeiter werden geladen...",
      fetchError: "Fehler beim Abrufen der aktiven Mitarbeiter",
      empty: "Derzeit keine aktiven Mitarbeiter",
      arrivalTime: "Ankunftszeit:",
      location: "Standort:",
      call: "Anrufen",
      email: "E-Mail",
      sendEmail: "E-Mail senden",
      viewFullDetails: "Vollständige Details anzeigen",
      emailLabel: "E-Mail",
      phoneLabel: "Telefonnummer",
      locationLabel: "Standort",
      baseSalary: "Grundgehalt",
      joinDate: "Eintrittsdatum",
      status: "Status",
      unavailable: "Nicht verfügbar",
      detailsLoadFailed: "Details konnten nicht geladen werden",
      noEmail: "Keine E-Mail-Adresse",
      noPhone: "Keine Telefonnummer",
      mainOffice: "Hauptbüro",
      present: "Pünktlich anwesend",
      inMeeting: "Im Meeting",
      remote: "Remote",
      active: "Aktiv"
    },
    lastRequests: {
      title: "Letzte Anfragen",
      description: "Alle Ihre Urlaubsanträge anzeigen",
      all: "Alle",
      pending: "In Prüfung",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
      newest: "Neueste",
      oldest: "Älteste",
      noMatching: "Keine Anfragen entsprechen dem Filter",
      reason: "Grund:",
      rejectionReason: "Ablehnungsgrund:",
      date: "Datum:",
      duration: "Dauer:",
      status: "Status:",
      statsTitle: "Anfragestatistik",
      statsDescription: "Überblick über den Status der Urlaubsanträge",
      employeeIdMissing: "Mitarbeiter-ID ist nicht verfügbar",
      noRequests: "Keine Anfragen verfügbar",
      fetchError: "Fehler beim Laden der Anfragen",
      unknown: "Unbekannt",
      chartCount: "Anzahl"
    },
    notifications: {
      title: "Benachrichtigungen",
      unreadSummary: "Sie haben {unread} ungelesene Benachrichtigung(en) von {total}",
      markAllRead: "Alle als gelesen markieren",
      deleteAll: "Alle löschen",
      decreasePerPageAria: "Benachrichtigungen pro Seite verringern",
      increasePerPageAria: "Benachrichtigungen pro Seite erhöhen",
      perPageAria: "Benachrichtigungen pro Seite",
      perPageLabel: "Benachrichtigungen pro Seite",
      loading: "Benachrichtigungen werden geladen...",
      noNotifications: "Keine Benachrichtigungen",
      notificationAria: "Benachrichtigung: {title}",
      untitled: "Benachrichtigung ohne Titel",
      unreadAria: "Ungelesene Benachrichtigung",
      noMessage: "Kein Benachrichtigungstext",
      loadMoreAria: "Weitere Benachrichtigungen laden",
      loadMore: "Weitere Benachrichtigungen anzeigen",
      fetchFailed: "Benachrichtigungen konnten nicht abgerufen werden",
      fetchError: "Beim Abrufen der Benachrichtigungen ist ein Fehler aufgetreten",
      markReadFailed: "Benachrichtigungsstatus konnte nicht aktualisiert werden",
      markAllReadFailed: "Status der Benachrichtigungen konnte nicht aktualisiert werden",
      deleteFailed: "Benachrichtigung konnte nicht gelöscht werden",
      deleteAllFailed: "Alle Benachrichtigungen konnten nicht gelöscht werden"
    }
  },
  employees: {
    title: "Mitarbeiterverwaltung",
    description: "Mitarbeiterinformationen verwalten",
    list: "Mitarbeiterliste",
    manageAndView: "Mitarbeiterdaten verwalten und einsehen",
    searchPlaceholder: "Nach Mitarbeiter suchen...",
    filter: {
      all: "Alle",
      admins: "Administratoren",
      teamLeaders: "Teamleiter",
      employees: "Mitarbeiter"
    },
    noEmployees: "Keine Mitarbeiter",
    noSearchResults: "Keine Suchergebnisse",
    addFirstEmployee: "Ersten Mitarbeiter hinzufügen",
    unassignedShifts: {
      urgent: "Dringend — sofort handeln",
      bannerOne: "1 Mitarbeiter ohne Schicht — jetzt zuweisen",
      bannerMany: "{count} Mitarbeiter ohne Schicht — jetzt zuweisen",
      bannerHint: "Ohne Schicht können Erinnerungen und Abwesenheiten ungenau sein. Tippen Sie zum sofortigen Zuweisen.",
      viewCta: "Jetzt zuweisen",
      bannerCta: "Jetzt zuweisen",
      panelTitle: "Mitarbeiter ohne Schicht",
      panelHint: "Tippen Sie auf einen Mitarbeiter, um eine Schicht zuzuweisen. Dies ist für Anwesenheit und Gehalt wichtig.",
      branchLabel: "Filiale: {branch}",
      noBranch: "Keine Filiale",
      missingShift: "Keine Schicht",
      backToList: "← Zurück zur Liste",
      assignHint: "Wählen Sie die passende Schicht und speichern Sie. Zuweisung nur durch Admin / Teamleiter.",
      assignCta: "Schicht zuweisen",
      selectShiftRequired: "Bitte vor dem Speichern eine Schicht wählen",
      assignSuccess: "Schicht erfolgreich zugewiesen",
      assignFailed: "Schichtzuweisung fehlgeschlagen",
      loadShiftsFailed: "Schichten konnten nicht geladen werden",
      noShiftsAvailable: "Keine Schichten verfügbar. Legen Sie zuerst Schichten in den Firmen- oder Filialeinstellungen an."
    },
    pendingApproval: "Keine Mitarbeiter mit ausstehender Genehmigung",
    pendingApprovalTitle: "Mitarbeiter mit ausstehender Genehmigung",
    pendingApprovalDescription: "Sie benötigen die Freigabe durch die Geschäftsleitung, um dem System beizutreten.",
    loading: "Wird geladen...",
    updating: "Wird aktualisiert...",
    updateList: "Liste aktualisieren",
    hide: "Ausblenden",
    show: "Anzeigen",
    noDataForMonth: "Keine Mitarbeiterdaten verfügbar für",
    sortOptions: {
      none: "Keine Sortierung",
      topSalary: "Höchstes Gehalt",
      topBonuses: "Höchste Boni",
      topDeductions: "Höchste Abzüge",
      oldestStartDate: "Ältestes Eintrittsdatum"
    },
    perPage: "pro Seite",
    pageOf: "Seite",
    of: "von",
    previous: "Zurück",
    next: "Weiter",
    enterPerPage: "Anzahl pro Seite eingeben",
    apply: "Anwenden",
    invalidNumber: "Bitte geben Sie eine gültige Zahl größer als 0 ein",
    noMatchSearch: "Keine Mitarbeiter gefunden, die",
    tryModifySearch: "Versuchen Sie, den Suchbegriff zu ändern",
    startAddingEmployee: "Beginnen Sie, indem Sie den ersten Mitarbeiter zum System hinzufügen, um Mitarbeiter zu verwalten und Gehälter zu verfolgen.",
    confirmDeleteEmployee: "Möchten Sie den Mitarbeiter wirklich löschen: {name}?\n\nDiese Aktion kann nicht rückgängig gemacht werden.",
    deleteEmployeeSuccess: "Mitarbeiter erfolgreich gelöscht",
    deleteEmployeeError: "Beim Löschen des Mitarbeiters ist ein Fehler aufgetreten",
    fetchEmployeesError: "Beim Abrufen der Mitarbeiterdaten ist ein Fehler aufgetreten",
    promoteSuccess: "Mitarbeiter erfolgreich zum Administrator befördert",
    promoteError: "Beim Befördern des Mitarbeiters zum Administrator ist ein Fehler aufgetreten",
    demoteSuccess: "Mitarbeiter erfolgreich zum normalen Mitarbeiter zurückgestuft",
    demoteError: "Beim Zurückstufen des Mitarbeiters ist ein Fehler aufgetreten",
    promoteToAdmin: "Zum Admin befördern",
    demoteToEmployee: "Zum Mitarbeiter zurückstufen",
    deleteEmployeeTitle: "Mitarbeiter löschen",
    showEmployeeNumber: "Mitarbeiternummer anzeigen",
    employeeFallback: "Mitarbeiter",
    whatsappCustomPlaceholder: "Leer lassen für die Standardvorlage oder eine eigene Nachricht schreiben...",
    employeeInfo: "Mitarbeiterinformationen",
    selectEmployeeAndMessage: "Bitte wählen Sie einen Mitarbeiter und schreiben Sie eine Nachricht",
    whatsapp: {
      messageType: "Nachrichtentyp",
      salarySlip: "Gehaltsabrechnung",
      leaveBalance: "Urlaubsguthaben",
      notification: "Benachrichtigung",
      customMessage: "Benutzerdefinierte Nachricht",
      templatePreview: "Vorlagenvorschau",
      editMessageOptional: "Nachricht bearbeiten (optional)",
      nameLabel: "Name:",
      phoneLabel: "Telefon:",
      positionLabel: "Position:",
      departmentLabel: "Abteilung:",
      sending: "Nachricht wird gesendet...",
      sendFailed: "Nachricht konnte nicht gesendet werden",
      reasonPrefix: "Grund:",
      sendingBtn: "Wird gesendet...",
      sentSuccess: "Erfolgreich gesendet",
      sendMessage: "Nachricht senden",
      to: "An:",
      chooseMessageType: "Nachrichtentyp wählen",
      salarySlipDesc: "Monatliche Gehaltsdetails senden",
      leaveBalanceDesc: "Aktuelles Urlaubsguthaben senden",
      notificationTitle: "Wichtige Mitteilung",
      notificationDesc: "Allgemeine Mitteilung oder Hinweis senden",
      customMessageDesc: "Freie individuelle Nachricht schreiben",
      templateSalary: "📊 *Gehaltsabrechnung für {month}*\nSehr geehrte/r: *{name}*\nPosition: {position}\nAbteilung: {department}\n💰 *Gehaltsdetails:*\n• Grundgehalt: {baseSalary}\n• Zulagen: {allowances}\n• Abzüge: {deductions}\n💸 *Gesamtgehalt: {netSalary}*\nFälligkeitsdatum: {date}\nVielen Dank für Ihre Bemühungen 🙏",
      templateLeave: "🏖️ *Aktualisierung des Urlaubsguthabens*\nSehr geehrte/r: *{name}*\n📊 *Details zum Urlaubsguthaben:*\n• Verfügbares Guthaben: {leaveBalance} Tage\n• Verbrauchte Tage: {usedDays} Tage\n• Jährliche Gesamttage: 30 Tage\nAktualisiert: {date}\nFür Urlaubsanträge wenden Sie sich bitte an die Personalabteilung.\nSchönen Urlaub! 🌟",
      templateNotification: "🔔 *Wichtige Mitteilung*\nSehr geehrte/r: *{name}*\nPosition: {position}\nAbteilung: {department}\nBitte beachten Sie, dass...[Mitteilung hier schreiben]\nDatum: {date}\nVielen Dank für Ihre Aufmerksamkeit.",
      templateCustom: "Guten Tag\nSehr geehrte/r: *{name}*\n[Schreiben Sie Ihre Nachricht hier]\nMit freundlichen Grüßen, Personalabteilung  {date}"
    },
    directoryTitle: "Mitarbeiterverzeichnis",
    directoryDescription: "Durchsuchen Sie Kontaktdaten und berufliche Informationen Ihrer Kollegen",
    totalEmployees: "Mitarbeiter insgesamt",
    activeEmployees: "Aktive Mitarbeiter",
    teamLeaders: "Teamleiter",
    departmentsCount: "Abteilungen",
    displayedResults: "Angezeigte Ergebnisse",
    ofEmployees: "von {total} Mitarbeitern",
    resultsCount: "({count} Ergebnisse)",
    searchDirectoryPlaceholder: "Suche nach Name, Abteilung, Fähigkeiten...",
    allStatuses: "Alle Status",
    departmentLabel: "Abteilung:",
    emailLabel: "E-Mail:",
    phoneLabel: "Telefon:",
    locationLabel: "Standort:",
    hireDateLabel: "Einstellungsdatum:",
    educationLabel: "Ausbildung:",
    skillsLabel: "Fähigkeiten:",
    projectsLabel: "Projekte:",
    yearsExperience: "{n} Jahre Erfahrung",
    moreSkills: "+{n} weitere",
    noResultsTitle: "Keine Ergebnisse",
    noResultsHint: "Keine Mitarbeiter entsprechen der aktuellen Suche. Ändern Sie Suchbegriff oder Filter.",
    rejectEmployeeTitle: "Mitarbeiter ablehnen",
    rejectEmployeeHint: "Bitte geben Sie den Ablehnungsgrund für {name} ein",
    rejectReasonPlaceholder: "Ablehnungsgrund (10–500 Zeichen)...",
    confirmReject: "Ablehnung bestätigen",
    privacyNoteTitle: "Hinweis zum Datenschutz",
    privacyNoteBody: "Das Mitarbeiterverzeichnis zeigt Kontaktdaten und grundlegende berufliche Informationen. Sensible Finanzdaten sind gemäß Datenschutzrichtlinien geschützt.",
    unauthorizedPage: "Sie sind nicht berechtigt, diese Seite zu verwenden",
    adminCheckFailed: "Admin-Berechtigungen konnten nicht überprüft werden",
    rejectFailed: "Mitarbeiter konnte nicht abgelehnt werden",
    rejectError: "Beim Ablehnen des Mitarbeiters ist ein Fehler aufgetreten",
    tableHeaders: {
      employeeId: "Mitarbeiter-ID",
      name: "Name",
      email: "E-Mail",
      position: "Position",
      department: "Abteilung",
      branch: "Filiale",
      actions: "Aktionen"
    },
    details: {
      loading: "Mitarbeiterdaten werden geladen...",
      notFound: "Mitarbeiterdaten nicht gefunden",
      notFoundDesc: "Bitte überprüfen Sie die Mitarbeiter-ID oder versuchen Sie es erneut",
      backToEmployees: "Zurück zur Mitarbeiterliste",
      overview: "Übersicht",
      notSpecified: "Nicht angegeben",
      teamLeader: "Teamleiter",
      edit: "Bearbeiten",
      cancel: "Abbrechen",
      save: "Speichern",
      saving: "Wird gespeichert...",
      quickActions: "Schnellaktionen",
      quickActionsMenu: "Menü für Schnellaktionen",
      email: "E-Mail",
      phone: "Telefon",
      workLocation: "Arbeitsort",
      role: "Rolle",
      joinDate: "Eintrittsdatum",
      contractDurationMonths: "Vertragsdauer",
      contractMonthsUnit: "{count} Monate",
      contractStartDate: "Vertragsbeginn",
      contractEndDate: "Vertragsende",
      renewContract: "Vertrag verlängern",
      renewResidence: "Aufenthalt verlängern",
      renewContractTitle: "Mitarbeitervertrag verlängern",
      renewResidenceTitle: "Aufenthaltsdauer verlängern",
      renewDurationMonths: "Neue Dauer (Monate)",
      renewDurationPlaceholder: "z. B. 12",
      renewDurationHint: "Das neue Enddatum wird ab heute anhand der eingegebenen Monate berechnet.",
      renewConfirm: "Verlängerung bestätigen",
      renewing: "Wird verlängert...",
      contractRenewed: "Vertrag erfolgreich verlängert",
      residenceRenewed: "Aufenthalt erfolgreich verlängert",
      renewFailed: "Verlängerung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      directManager: "Direkter Vorgesetzter",
      approvalStatus: "Genehmigungsstatus",
      status: "Status",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
      pending: "Ausstehend",
      notSet: "Nicht festgelegt",
      active: "Aktiv",
      inactive: "Inaktiv",
      onLeave: "Im Urlaub",
      underTraining: "In der Einarbeitung",
      serviceEnded: "Dienst beendet",
      assignTeamLeader: "Teamleiter zuweisen",
      editTeamLeader: "Teamleiter bearbeiten",
      employeeRole: "Mitarbeiter",
      assignPermissionApprover: "Genehmiger für Berechtigungen zuweisen",
      permissionApproverHint: "Wählen Sie, wer die Berechtigungsanträge dieses Mitarbeiters erhält. Standard: Abteilungs-Teamleiter, falls verfügbar, andernfalls Administrator.",
      useDefaultApprover: "Standard (Teamleiter / Administrator)",
      addBonus: "Bonus hinzufügen",
      addDeduction: "Abzug hinzufügen",
      convertToEmployee: "In regulären Mitarbeiter umwandeln",
      converting: "Wird umgewandelt...",
      addAllowance: "Zulage hinzufügen",
      addTax: "Steuer hinzufügen",
      addInsurance: "Versicherung hinzufügen",
      errors: {
        fetchFailed: "Mitarbeiterdaten konnten nicht abgerufen werden",
        fetchError: "Beim Abrufen der Mitarbeiterdaten ist ein Fehler aufgetreten",
        fetchDepartmentsFailed: "Abteilungen konnten nicht abgerufen werden",
        fetchDepartmentsError: "Beim Abrufen der Abteilungen ist ein Fehler aufgetreten",
        selectDepartment: "Bitte wählen Sie mindestens eine Abteilung aus",
        noUserId: "Keine Benutzer-ID für Mitarbeiter gefunden",
        assignFailed: "Teamleiter konnte nicht zugewiesen werden",
        assignError: "Bei der Zuweisung des Teamleiters ist ein Fehler aufgetreten",
        convertFailed: "Teamleiter konnte nicht umgewandelt werden",
        convertError: "Bei der Umwandlung des Teamleiters ist ein Fehler aufgetreten",
        taxNameRequired: "Bitte geben Sie einen Abzugsnamen ein",
        taxAmountRequired: "Bitte geben Sie einen gültigen Betrag größer als null ein",
        taxAddFailed: "Steuer konnte nicht hinzugefügt werden",
        taxAddError: "Beim Hinzufügen der Steuer ist ein Fehler aufgetreten",
        insuranceNameRequired: "Bitte geben Sie einen Abzugsnamen ein",
        insuranceAmountRequired: "Bitte geben Sie einen gültigen Betrag größer als null ein",
        insuranceAddFailed: "Versicherung konnte nicht hinzugefügt werden",
        insuranceAddError: "Beim Hinzufügen der Versicherung ist ein Fehler aufgetreten",
        bonusFieldsRequired: "Bitte füllen Sie alle erforderlichen Felder aus",
        bonusAmountRequired: "Betrag muss größer als null sein",
        bonusAddFailed: "Bonus konnte nicht hinzugefügt werden",
        bonusAddError: "Beim Hinzufügen des Bonus ist ein Fehler aufgetreten",
        bonusDeleteConfirm: "Sind Sie sicher, dass Sie diesen Bonus löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        bonusDeleteFailed: "Bonus konnte nicht gelöscht werden",
        bonusDeleteError: "Beim Löschen des Bonus ist ein Fehler aufgetreten",
        deductionFieldsRequired: "Bitte füllen Sie alle erforderlichen Felder aus",
        deductionAmountRequired: "Betrag muss größer als null sein",
        deductionAddFailed: "Abzug konnte nicht hinzugefügt werden",
        deductionAddError: "Beim Hinzufügen des Abzugs ist ein Fehler aufgetreten",
        deductionDeleteConfirm: "Sind Sie sicher, dass Sie diesen Abzug löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        deductionDeleteFailed: "Abzug konnte nicht gelöscht werden",
        deductionDeleteError: "Beim Löschen des Abzugs ist ein Fehler aufgetreten",
        allowanceFieldsRequired: "Bitte füllen Sie alle erforderlichen Felder aus",
        allowanceEndDateRequired: "Bitte geben Sie ein Enddatum ein oder aktivieren Sie die Option \"Dauerhaft\"",
        allowanceSaveFailed: "Beim Speichern der Zulage ist ein Fehler aufgetreten",
        allowanceIdInvalid: "Ungültige Zulagen-ID",
        bonusIdInvalid: "Ungültige Bonus-ID",
        deductionIdInvalid: "Ungültige Abzugs-ID",
        convertToAdminFailed: "Mitarbeiter konnte nicht zum Admin umgewandelt werden",
        permissionApproverLoadFailed: "Einstellungen des Genehmigers konnten nicht geladen werden",
        permissionApproverUpdateFailed: "Genehmiger konnte nicht aktualisiert werden",
        updateFailed: "Aktualisierung fehlgeschlagen",
        allowanceDeleteConfirm: "Möchten Sie diese Zulage wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
      },
      success: {
        permissionApproverUpdated: "Genehmiger aktualisiert",
        convertToAdmin: "Mitarbeiter erfolgreich zum Admin umgewandelt",
        assignTeamLeader: "Mitarbeiter erfolgreich als Teamleiter zugewiesen",
        convertToEmployee: "Teamleiter erfolgreich in regulären Mitarbeiter umgewandelt",
        taxAdded: "Steuer erfolgreich hinzugefügt",
        insuranceAdded: "Versicherung erfolgreich hinzugefügt",
        bonusAdded: "Bonus erfolgreich hinzugefügt",
        bonusDeleted: "Bonus erfolgreich gelöscht",
        deductionAdded: "Abzug erfolgreich hinzugefügt",
        deductionDeleted: "Abzug erfolgreich gelöscht",
        allowanceUpdated: "Zulage erfolgreich aktualisiert",
        allowanceAdded: "Zulage erfolgreich hinzugefügt"
      },
      confirmations: {
        convertRoleToEmployee: "Möchten Sie {role} wirklich zum Mitarbeiter umwandeln?",
        convertToAdmin: "Möchten Sie diesen Mitarbeiter wirklich zum Admin umwandeln?",
        convertToEmployee: "Sind Sie sicher, dass Sie den Teamleiter in einen regulären Mitarbeiter umwandeln möchten?"
      },
      deductions: {
        socialInsurance: "Sozialversicherung",
        insurance: "Versicherung",
        tax: "Steuer",
        taxes: "Steuern",
        loans: "Darlehen",
        absence: "Abwesenheit"
      },
      fullDetails: "Vollständige Mitarbeiterdetails",
      personalInfo: "Persönliche Informationen",
      jobInfo: "Berufliche Informationen",
      datesAndContact: "Daten & Kontakt",
      employeeNumber: "Mitarbeiternummer",
      nationalID: "Personalausweisnummer",
      gender: "Geschlecht",
      male: "Männlich",
      female: "Weiblich",
      birthDate: "Geburtsdatum",
      maritalStatus: "Familienstand",
      address: "Adresse",
      emergencyContact: "Notfallkontakt",
      department: "Abteilung",
      position: "Position",
      yes: "Ja",
      no: "Nein",
      periodOfStay: "Aufenthaltsdauer (Tage)",
      startDate: "Startdatum",
      endDate: "Enddatum",
      contractDurationMonths: "Vertragsdauer",
      contractMonthsUnit: "{count} Monate",
      residenceExpiry: "Ablauf des Aufenthalts",
      leaveBalance: "Urlaubsguthaben",
      sickLeaveLabel: "Krankheitsurlaub",
      annualLeaveLabel: "Jahresurlaub",
      unpaidLeaveLabel: "Unbezahlter Urlaub",
      workFromHomeLabel: "Homeoffice",
      monthlyWorkFromHomeLabel: "Homeoffice (monatlich)",
      yearLabel: "Jahr",
      day: "Tag",
      days: "Tage",
      createdAt: "Erstellt am",
      experience: "Erfahrung",
      documents: "Dokumente",
      documentN: "Dokument",
      size: "Größe",
      type: "Typ",
      viewDocument: "Dokument ansehen",
      customAllowances: "Individuelle Zulagen",
      amount: "Betrag",
      permanent: "Dauerhaft",
      delete: "Löschen",
      deleting: "Löschen...",
      accountInfo: "Kontoinformationen",
      lastDevice: "Letztes Gerät",
      brand: "Marke",
      deviceTypeLabel: "Gerätetyp",
      system: "System",
      deviceRequests: "Geräteanfragen",
      requestsCount: "Anfragen",
      loadingDeviceRequests: "Geräteanfragen werden geladen...",
      noDeviceRequests: "Derzeit keine Geräteanfragen",
      unknown: "Unbekannt",
      pendingReview: "In Prüfung",
      deviceBrand: "Marke",
      deviceName: "Gerätename",
      deviceModel: "Modell",
      deviceId: "Geräte-ID",
      operatingSystem: "Betriebssystem",
      carrier: "Netzbetreiber",
      requestDate: "Anfragedatum",
      approve: "Genehmigen",
      reject: "Ablehnen",
      unavailable: "Nicht verfügbar",
      minutes: "Minuten",
      hours: "Stunden",
      minute: "Minute",
      hour: "Stunde",
      convertToAdmin: "Zum Admin umwandeln",
      convertingToAdmin: "Wird umgewandelt...",
      allowanceDeleted: "Zulage erfolgreich gelöscht",
      employeeUpdated: "Mitarbeiterdaten erfolgreich aktualisiert",
      rejectReasonPrompt: "Bitte Ablehnungsgrund eingeben:",
      userEmail: "Benutzer-E-Mail",
      noAllowances: "Keine Zulagen",
      unselectAll: "Alles abwählen",
      assigning: "Wird zugewiesen...",
      editAllowance: "Zulage bearbeiten",
      addNewAllowance: "Neue Zulage hinzufügen",
      addInsuranceForEmployee: "Versicherung für Mitarbeiter hinzufügen",
      editEmployees: "Mitarbeiter bearbeiten",
      editDepartments: "Abteilungen bearbeiten",
      editBranches: "Filialen bearbeiten",
      editTasks: "Aufgaben bearbeiten",
      editClients: "Kunden bearbeiten",
      editCategories: "Kategorien bearbeiten",
      editEquipment: "Vermögen bearbeiten",
      editTools: "Werkzeuge bearbeiten",
      editPositions: "Positionen bearbeiten",
      permissionLabels: {
        salaryFinance: "Gehälter & Finanzen",
        salary: "Gehälter",
        payroll: "Gehaltsabrechnungen",
        transactions: "Finanztransaktionen",
        employees: "Mitarbeiter",
        viewEmployees: "Mitarbeiter anzeigen",
        createEmployees: "Mitarbeiter hinzufügen",
        deleteEmployees: "Mitarbeiter löschen",
        approveEmployees: "Mitarbeiter genehmigen",
        attendanceGroup: "Anwesenheit",
        checkIn: "Anwesenheit erfassen",
        attendance: "Anwesenheit",
        dailyAttendance: "Tägliche Anwesenheit",
        departmentsBranches: "Abteilungen & Filialen",
        viewDepartments: "Abteilungen anzeigen",
        viewBranches: "Filialen anzeigen",
        tasks: "Aufgaben",
        viewTasks: "Aufgaben anzeigen",
        createTasks: "Aufgaben erstellen",
        deleteTasks: "Aufgaben löschen",
        leaveRequests: "Urlaubsanträge",
        viewLeaveRequests: "Urlaubsanträge anzeigen",
        leaveApprove: "Urlaub genehmigen",
        permissionRequests: "Berechtigungsanträge",
        viewPermissionRequests: "Berechtigungsanträge anzeigen",
        permissionApprove: "Berechtigungen genehmigen",
        reports: "Berichte",
        viewReports: "Berichte anzeigen",
        salaryReports: "Gehaltsberichte",
        attendanceReports: "Anwesenheitsberichte",
        other: "Sonstiges",
        clients: "Kunden",
        categories: "Kategorien",
        equipment: "Vermögen",
        tools: "Werkzeuge",
        positions: "Positionen",
        notifications: "Benachrichtigungen",
        dashboard: "Dashboard",
        devices: "Geräte"
      },
      adminRole: "Admin",
      thisUser: "dieser Benutzer",
      assign: "Zuweisen",
      add: "Hinzufügen",
      update: "Aktualisieren",
      selectAll: "Alles auswählen",
      permissionsLabel: "Berechtigungen",
      departmentsMultiSelect: "Abteilungen (Mehrfachauswahl möglich)",
      noDepartmentsAvailable: "Keine Abteilungen verfügbar",
      departmentsSelected: "{count} Abteilung(en) ausgewählt",
      addBonusForEmployee: "Bonus für Mitarbeiter hinzufügen",
      addDeductionForEmployee: "Abzug für Mitarbeiter hinzufügen",
      addTaxForEmployee: "Steuer für Mitarbeiter hinzufügen",
      currentMonth: "Aktueller Monat",
      permanentAllowance: "Dauerhafte Zulage",
      approverLabel: "Genehmiger",
      currentDefaultApprover: "Aktueller Standardgenehmiger",
      customApprover: "Benutzerdefiniert",
      teamLeaderOrAdmin: "Teamleiter / Admin",
      dailyOrders: "Tägliche Bestellungen",
      dailyOrdersPlaceholder: "Anzahl täglicher Bestellungen eingeben",
      dailyOrdersHint: "Bitte geben Sie die erwartete Anzahl täglicher Bestellungen für den Mitarbeiter ein",
      contactInfo: "Kontaktinformationen",
      employmentInfo: "Beschäftigungsinformationen",
      fullName: "Vollständiger Name",
      basicSalary: "Grundgehalt",
      branch: "Filiale",
      probationStatus: "Probezeitstatus",
      selectPosition: "Position wählen...",
      selectDepartment: "Abteilung wählen...",
      selectBranch: "Filiale wählen...",
      shift: "Schicht",
      selectShift: "Schicht wählen...",
      noShift: "Keine Schicht (Filial-/Firmenzeiten)",
      branchChangedShiftWarning: "Filiale geändert — bitte vor dem Speichern eine Schicht für die neue Filiale wählen (Zeiten und Standort folgen der neuen Filiale).",
      branchChangedShiftRequired: "Bitte eine Schicht für die neue Filiale wählen, bevor Sie speichern",
      selectStatus: "Status wählen",
      editData: "Daten bearbeiten",
      saveChanges: "Änderungen speichern",
      loadingEmployee: "Mitarbeiterdaten werden geladen...",
      ended: "Beendet",
      notActivated: "Nicht aktiviert",
      noChangesToSave: "Keine Änderungen zum Speichern",
      saveDataError: "Beim Speichern der Daten ist ein Fehler aufgetreten",
      allowanceSaveError: "Beim Speichern der Zulage ist ein Fehler aufgetreten",
      modals: {
        allowanceName: "Zulagenname",
        allowanceNamePlaceholder: "z. B. Fahrtkostenzulage",
        amountPlaceholder: "z. B. 500",
        bonusType: "Bonusart",
        bonusTypePerformance: "Leistungsbonus",
        bonusTypeAnnual: "Jahresbonus",
        bonusTypeProject: "Projektbonus",
        bonusTypeOther: "Sonstiges",
        bonusDescriptionPlaceholder: "z. B. Leistungsbonus für hervorragende Arbeit",
        deductionType: "Abzugsart",
        deductionAmountPlaceholder: "z. B. 200",
        deductionDescriptionPlaceholder: "z. B. Monatliche Kreditrückzahlung",
        taxName: "Abzugsname",
        taxNamePlaceholder: "z. B. Steuern",
        taxAmountPlaceholder: "z. B. 200",
        endDateOptionalPermanent: "Enddatum (leer lassen für dauerhaften Abzug)",
        insuranceNamePlaceholder: "z. B. Sozialversicherung",
        insuranceAmountPlaceholder: "z. B. 300",
        description: "Beschreibung",
        deductionTypeLoan: "Kreditabzug",
        deductionTypeAdvance: "Vorschussabzug",
        deductionTypeAbsence: "Abwesenheitsabzug",
        deductionTypeLate: "Verspätungsabzug"
      },
      attendanceHeatmap: {
        title: "Monatliche Anwesenheitskarte",
        subtitle: "Status jedes Tages auf einen Blick — Tippen für Details",
        prevMonth: "Vorheriger Monat",
        nextMonth: "Nächster Monat",
        loading: "Anwesenheitskarte wird geladen...",
        loadError: "Anwesenheitsdaten konnten nicht geladen werden",
        noRecord: "Kein Eintrag",
        futureDay: "Zukünftiger Tag",
        legend: "Legende",
        selectedDay: "Ausgewählter Tag",
        presentShort: "Pünktlich",
        lateShort: "Verspätet",
        absentShort: "Abwesend",
        leaveShort: "Urlaub",
        unpaidLeaveShort: "Unbezahlt",
        holidayShort: "Feiertag",
        earlyLeaveShort: "Früh weg",
        halfDayShort: "Halbtag",
        weekendShort: "Wochenende",
        emptyShort: "—",
        futureShort: "—",
        pickMonth: "Monat wählen",
        prevYear: "Vorheriges Jahr",
        nextYear: "Nächstes Jahr",
        thisMonth: "Dieser Monat"
      }
    },
    quickStats: {
      attendanceDetails: "Anwesenheitsdetails",
      attendanceStats: "Anwesenheitsstatistik des Mitarbeiters",
      attendance: "Anwesenheit",
      coreStats: "Kernstatistiken",
      workDays: "Arbeitstage",
      presentDays: "Anwesenheitstage",
      absentDays: "Abwesenheitstage",
      leaves: "Urlaub",
      holidayDays: "Feiertage",
      secondaryStats: "Zusätzliche Statistiken",
      late: "Verspätung",
      earlyLeave: "Früher Feierabend",
      halfDay: "Halber Tag",
      externalTasks: "Externe Aufgaben",
      hoursStats: "Stundenstatistik",
      totalHours: "Gesamtstunden",
      overtimeHours: "Überstunden",
      hoursUnit: "Std.",
      viewDetails: "Details anzeigen",
      viewAttendanceLog: "Anwesenheitsprotokoll anzeigen",
      attendanceLogDetails: "Anwesenheitsprotokoll-Details",
      closeModal: "Fenster schließen",
      searchPlaceholder: "Nach Datum oder Notizen suchen...",
      searchAria: "Anwesenheitsprotokoll durchsuchen",
      exportCsv: "Als CSV exportieren",
      exportCsvAria: "Daten als CSV-Datei exportieren",
      date: "Datum",
      delayHours: "Verspätungsstunden",
      deductionAmount: "Abzugsbetrag",
      overtimeAmount: "Überstundenbetrag",
      notes: "Notizen",
      noRecords: "Keine Einträge"
    },
    workTime: {
      title: "Arbeitszeiten",
      checkInTime: "Beginn:",
      checkOutTime: "Ende:",
      dailyHours: "Tägliche Arbeitsstunden:",
      weeklyDays: "Wochentage:",
      noWorkDays: "Keine Tage festgelegt",
      settingsNotFound: "Arbeitseinstellungen nicht gefunden",
      loadError: "Fehler beim Laden der Arbeitseinstellungen",
      hoursCount: "{hours} Stunden",
      hoursAndMinutes: "{hours} Stunden und {minutes} Minuten",
      defaultHours: "8 Stunden"
    },
    documentsPage: {
      manageTitle: "Dokumente verwalten",
      employeeIdMissing: "Mitarbeiter-ID nicht verfügbar",
      fetchFailed: "Dokumente konnten nicht geladen werden",
      fetchAfterDeleteFailed: "Dokumente nach dem Löschen konnten nicht geladen werden",
      deleteFailed: "Dokument konnte nicht gelöscht werden",
      noDescription: "Keine Beschreibung",
      error: "Fehler",
      noDocuments: "Keine Dokumente",
      noDocumentsForEmployee: "Keine Dokumente für diesen Mitarbeiter verfügbar",
      unknown: "Unbekannt",
      viewDocument: "Dokument anzeigen",
      deleteDocument: "Dokument löschen",
      newest: "Neueste",
      oldest: "Älteste",
      sizeLargest: "Dateigröße (größte)"
    },
    deviceRequests: {
      noRequestsHint: "Es wurden noch keine Geräteanfragen eingereicht",
      noDevicesTitle: "Keine registrierten Geräte",
      noDevicesHint: "Für diesen Mitarbeiter sind derzeit keine Geräte registriert",
      manufacturer: "Hersteller",
      reviewDate: "Prüfdatum",
      rejectionReason: "Ablehnungsgrund"
    },
    detailsHolidays: {
      loading: "Anträge werden geladen...",
      duration: "Dauer",
      description: "Beschreibung",
      filterPendingRejectedApproved: "Ausstehend, Abgelehnt, Genehmigt",
      filterRejectedApprovedPending: "Abgelehnt, Genehmigt, Ausstehend"
    },
    pending: {
      processing: "Wird verarbeitet...",
      approveTitle: "Mitarbeiter genehmigen",
      rejectTitle: "Mitarbeiter ablehnen",
      viewDetailsTitle: "Details anzeigen",
      rejectReasonPrompt: "Ablehnungsgrund (optional):",
      noReasonProvided: "Kein Grund angegeben",
      employeeRole: "Mitarbeiter",
      generalDepartment: "Allgemeine Abteilung",
      loadingDetails: "Details werden geladen...",
      loadDetailsFailed: "Mitarbeiterdetails konnten nicht geladen werden",
      tryAgain: "Bitte versuchen Sie es erneut",
      educationAndSkills: "Bildung & Fähigkeiten",
      education: "Bildung",
      skills: "Fähigkeiten",
      username: "Benutzername",
      maxDevices: "Max. Geräte",
      registeredDevices: "Registrierte Geräte",
      salaryToBeSetByManager: "Wird vom Manager festgelegt",
      accountStatus: "Kontostatus",
      approvedCheck: "✓ Genehmigt",
      pendingWait: "⏳ Ausstehend",
      rejectedCross: "✗ Abgelehnt",
      financialSetup: "Finanzielle Einrichtung des Mitarbeiters",
      shiftHint: "Wählen Sie die Schicht des Mitarbeiters. Nur Admin oder Teamleiter.",
      selectWorkLocationOption: "Arbeitsort wählen",
      workLocationHint: "Bitte wählen Sie den Arbeitsort des Mitarbeiters",
      baseSalaryPlaceholder: "Grundgehalt eingeben",
      baseSalaryHint: "Bitte geben Sie das Grundgehalt des Mitarbeiters ein",
      contractDurationMonths: "Vertragsdauer (Monate)",
      contractDurationPlaceholder: "z. B. 12",
      contractDurationHint: "Pflichtfeld. Geben Sie die Vertragsdauer in Monaten ein (ganze Zahl größer als 0).",
      addNewAllowance: "Neue Zulage hinzufügen",
      allowanceName: "Name der Zulage",
      allowanceNamePlaceholder: "z. B. Fahrt-, Wohn-, Verpflegungszulage",
      allowanceAmount: "Zulagenbetrag",
      allowanceAmountPlaceholder: "Zulagenbetrag eingeben",
      permanentAllowanceHint: "Die Zulage bleibt ohne Enddatum beim Mitarbeiter",
      addToList: "Zur Liste hinzufügen",
      addedAllowances: "Hinzugefügte Zulagen ({count})",
      amountPrefix: "Betrag: {amount}",
      fromDate: "Ab {date}",
      fromToDate: "Von {start} bis {end}",
      noAllowancesYet: "Noch keine Zulagen hinzugefügt",
      useFormAbove: "Nutzen Sie das Formular oben, um eine Zulage hinzuzufügen",
      saveData: "Daten speichern",
      allowanceCount: "({count} Zulage)",
      allowances: "Zulagen",
      salaryAndAllowancesSuccess: "Gehalt festgelegt und {count} Zulage(n) erfolgreich hinzugefügt",
      salaryPartialAllowances: "Gehalt gespeichert und {success} Zulage(n) hinzugefügt, aber {fail} fehlgeschlagen",
      salaryAllowancesAllFailed: "Gehalt gespeichert, aber alle Zulagen konnten nicht hinzugefügt werden",
      salarySavedAllowancesFailed: "Gehalt gespeichert, aber einige Zulagen konnten nicht hinzugefügt werden",
      salarySetSuccess: "Gehalt erfolgreich festgelegt",
      saveFailed: "Daten konnten nicht gespeichert werden",
      documentN: "Dokument {n}",
      sizeLabel: "Größe: {size}",
      typeLabel: "Typ: {type}",
      leaveDaysCount: "{count} Tag(e)"
    }
  },
  holidays: {
    title: "Urlaub",
    description: "Urlaubsanträge verwalten und Berichte erstellen",
    leaveDays: "Urlaubstage",
    remainingDays: "Verbleibende Tage",
    sickLeave: "Krankheitsurlaub",
    usedDays: "Genutzte Tage",
    workFromHome: "Homeoffice",
    upcomingLeave: "Bevorstehender Urlaub",
    noLeaveRequests: "Keine Urlaubsanträge gefunden",
    overview: "Übersicht",
    past: "Vergangene Urlaube",
    requests: "Urlaubsanträge",
    testRequest: "Testantrag",
    loading: "Wird geladen...",
    employeeInfo: "Mitarbeiterinformationen",
    name: "Name",
    department: "Abteilung",
    position: "Position",
    tableHeaders: {
      leaveType: "Urlaubsart",
      startDate: "Startdatum",
      endDate: "Enddatum",
      totalDays: "Tage gesamt",
      submissionTime: "Einreichungszeitpunkt",
      status: "Status",
      employeeNotes: "Anmerkungen des Mitarbeiters",
      managerNotes: "Anmerkungen des Vorgesetzten",
      approvedBy: "Genehmigt von"
    },
    status: {
      pending: "Ausstehend",
      approved: "Genehmigt",
      rejected: "Abgelehnt"
    },
    annualLeave: "Jahresurlaub",
    remaining: "Verbleibend",
    used: "Genutzt",
    day: "Tag",
    days: "Tage",
    sickLeaveTitle: "Krankheitsurlaub",
    workFromHomeTitle: "Homeoffice",
    unpaidLeave: "Unbezahlter Urlaub",
    of: "von",
    filterByStatus: "Nach Status filtern:",
    all: "Alle",
    cancelled: "Storniert",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    request: "Antrag",
    pendingRequestsTitle: "Ausstehende Anträge",
    pendingRequestsMessage: "Sie haben {count} ausstehende Urlaubsanträge",
    recentRequests: "Aktuelle Anträge",
    leaveRequests: "Urlaubsanträge",
    myRequests: "Meine Anträge",
    newRequest: "Neuer Urlaubsantrag",
    hideForm: "Formular ausblenden",
    reason: "Grund",
    reasonPlaceholder: "Urlaubsgrund eingeben",
    leaveCategory: "Urlaubsart",
    selectLeaveCategory: "Urlaubsart auswählen",
    leaveCategoryRequired: "Bitte eine Urlaubsart auswählen",
    startDateRequired: "Bitte Startdatum auswählen",
    endDateRequired: "Bitte Enddatum auswählen",
    endAfterStart: "Das Enddatum muss nach dem Startdatum liegen",
    selectStartDate: "Startdatum wählen",
    selectEndDate: "Enddatum wählen",
    leaveDaysLabel: "Urlaubstage:",
    submitting: "Wird gesendet...",
    submitRequest: "Antrag senden",
    submitSuccess: "Urlaubsantrag erfolgreich gesendet",
    submitFailed: "Urlaubsantrag konnte nicht gesendet werden",
    cancelConfirm: "Möchten Sie diesen Antrag wirklich stornieren?",
    cancelSuccess: "Urlaubsantrag erfolgreich storniert",
    cancelFailed: "Antrag konnte nicht storniert werden",
    fetchFailed: "Urlaubsanträge konnten nicht geladen werden",
    employeeIdMissing: "Mitarbeiter-ID nicht verfügbar",
    notAvailable: "Nicht verfügbar",
    from: "Von:",
    to: "Bis:",
    daysCount: "{count} Tag(e)",
    requestDate: "Antragsdatum:",
    cancel: "Abbrechen",
    admin: {
      title: "Offizielle Feiertage",
      description: "Offizielle Feiertage für Organisation und Filialen verwalten",
      addHoliday: "Feiertag hinzufügen",
      addNewHoliday: "Neuen Feiertag hinzufügen",
      holidayName: "Feiertagsname",
      holidayNamePlaceholder: "Feiertagsname eingeben",
      date: "Datum",
      branch: "Filiale",
      descriptionLabel: "Beschreibung",
      descriptionPlaceholder: "Feiertagsbeschreibung eingeben",
      allBranchesOrg: "Alle Filialen (Organisation)",
      allBranches: "Alle Filialen",
      add: "Hinzufügen",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      delete: "Löschen",
      save: "Speichern",
      durationDays: "Dauer (Tage)",
      actions: "Aktionen",
      status: "Status",
      active: "Aktiv",
      inactive: "Inaktiv",
      isActive: "Feiertag ist aktiv",
      employees: "Mitarbeiter",
      employeesHint: "Leer lassen, um alle in Filiale/Organisation einzuschließen. Oder bestimmte Mitarbeiter wählen (dann keine Filiale nötig).",
      branchHint: "Optional. Nur relevant, wenn keine bestimmten Mitarbeiter gewählt sind.",
      branchHiddenHint: "Geltungsbereich folgt den gewählten Mitarbeitern — keine Filialauswahl nötig.",
      scopeByEmployees: "Nach Mitarbeitern",
      searchEmployees: "Mitarbeiter suchen...",
      loadingEmployees: "Mitarbeiter werden geladen...",
      noEmployees: "Keine Mitarbeiter gefunden",
      selectAll: "Alle auswählen",
      clearSelection: "Auswahl löschen",
      noEmployeesSelected: "Keine Auswahl — gilt für alle im gewählten Bereich",
      selectedEmployeesCount: "{count} Mitarbeiter ausgewählt",
      employeesCount: "{count} Mitarbeiter",
      allBranchEmployees: "Alle Filialmitarbeiter",
      allOrgEmployees: "Alle Organisationsmitarbeiter",
      filterYear: "Jahr",
      filterBranch: "Filiale",
      filterStatus: "Status",
      filterAllBranches: "Alle Filialen",
      filterOrgWide: "Nur organisationsweit",
      filterAllStatuses: "Alle Status",
      seedEgyptian: "Ägyptische Feiertage laden",
      seeding: "Wird geladen...",
      seedConfirm: "Ägyptische Feiertage für dieses Jahr hinzufügen?",
      seedSuccess: "Ägyptische Feiertage erfolgreich geladen",
      seedFailed: "Ägyptische Feiertage konnten nicht geladen werden",
      fetchEmployeesFailed: "Mitarbeiter konnten nicht geladen werden",
      noHolidays: "Keine Feiertage gefunden",
      fillRequired: "Bitte alle Pflichtfelder ausfüllen",
      createSuccess: "Feiertag erfolgreich erstellt",
      createFailed: "Feiertag konnte nicht erstellt werden",
      editHoliday: "Feiertag bearbeiten",
      fetchFailed: "Feiertage konnten nicht geladen werden",
      updateSuccess: "Feiertag erfolgreich aktualisiert",
      updateFailed: "Feiertag konnte nicht aktualisiert werden",
      deleteConfirm: "Möchten Sie diesen Feiertag wirklich löschen?",
      deleteSuccess: "Feiertag erfolgreich gelöscht",
      deleteFailed: "Feiertag konnte nicht gelöscht werden"
    }
  },
  permissions: {
    title: "Berechtigungen",
    subtitle: "Berechtigungsanträge von Mitarbeitern prüfen und genehmigen",
    submittedRequests: "Eingereichte Anträge",
    filterByStatus: "Nach Status filtern:",
    all: "Alle",
    loading: "Wird geladen...",
    noRequests: "Keine Berechtigungsanträge gefunden",
    fetchFailed: "Berechtigungsanträge konnten nicht geladen werden",
    refresh: "Aktualisieren",
    approve: "Genehmigen",
    reject: "Ablehnen",
    forwardToAdmin: "An Administrator weiterleiten",
    takeOver: "Übernehmen",
    approveTitle: "Antrag genehmigen",
    rejectTitle: "Antrag ablehnen",
    approveNotes: "Anmerkungen (optional)",
    approveNotesPlaceholder: "Genehmigungsanmerkungen eingeben",
    rejectReason: "Ablehnungsgrund",
    rejectReasonPlaceholder: "Ablehnungsgrund eingeben",
    rejectReasonRequired: "Bitte geben Sie einen Ablehnungsgrund ein",
    cancel: "Abbrechen",
    confirmApprove: "Genehmigung bestätigen",
    confirmReject: "Ablehnung bestätigen",
    approveSuccess: "Antrag erfolgreich genehmigt",
    approveFailed: "Antrag konnte nicht genehmigt werden",
    rejectSuccess: "Antrag erfolgreich abgelehnt",
    rejectFailed: "Antrag konnte nicht abgelehnt werden",
    forwardSuccess: "Antrag an Administrator weitergeleitet",
    forwardFailed: "Antrag konnte nicht weitergeleitet werden",
    takeOverSuccess: "Antrag erfolgreich übernommen",
    takeOverFailed: "Antrag konnte nicht übernommen werden",
    status: {
      pending: "Ausstehend",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
      cancelled: "Storniert",
      forwarded: "Weitergeleitet"
    },
    table: {
      employee: "Mitarbeiter",
      type: "Berechtigungsart",
      date: "Datum",
      time: "Uhrzeit",
      reason: "Grund",
      status: "Status",
      actions: "Aktionen"
    },
    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    of: "von",
    requests: "Anträge",
  },
  company: {
    title: "Unternehmensverwaltung",
    description: "Beschreibung",
    branches: "Unternehmensfilialen",
    allBranches: "Alle Unternehmensfilialen",
    addBranch: "Neue Filiale hinzufügen",
    branchName: "Filialname",
    enterBranchName: "Filialnamen eingeben",
    noBranches: "Keine Filialen",
    cannotDeleteLast: "Letzte Filiale kann nicht gelöscht werden",
    alexandriaBranch: "Filiale Alexandria",
    cairoBranch: "Filiale Kairo",
    active: "Aktiv",
    inactive: "Inaktiv",
    code: "Code",
    manager: "Leiter",
    departments: "Abteilungen",
    employees: "Mitarbeiter",
    email: "E-Mail",
    phone: "Telefonnummer",
    address: "Adresse",
    emailPlaceholder: "example@unternehmen.com",
    phonePlaceholder: "01012345678",
    managerPlaceholder: "Name des Leiters eingeben",
    addressPlaceholder: "Filialadresse eingeben",
    descriptionPlaceholder: "Filialbeschreibung eingeben (optional)",
    departmentsPlaceholder: "0",
    employeesPlaceholder: "0",
    tabs: {
      branches: "Filialen",
      departments: "Abteilungen",
      documents: "Dokumente",
      assets: "Vermögenswerte",
      tools: "Werkzeuge",
      jobPositions: "Positionen",
      leaveRequests: "Urlaubsanträge",
      devices: "Geräte",
      admins: "Administratoren",
      orders: "Kuriere",
      documentApprovals: "Dokumentfreigaben",
      transfers: "Versetzungen"
    },
    admins: {
      description: "Organisationsadministratoren erstellen und verwalten",
      createNew: "Neuen Administrator erstellen",
      email: "E-Mail",
      emailPlaceholder: "admin@example.com",
      username: "Benutzername",
      usernamePlaceholder: "Benutzername eingeben",
      password: "Passwort",
      passwordPlaceholder: "Passwort eingeben",
      firstName: "Vorname",
      firstNamePlaceholder: "Vorname eingeben",
      lastName: "Nachname",
      lastNamePlaceholder: "Nachname eingeben",
      phone: "Telefon",
      phonePlaceholder: "+201000110001",
      nationalID: "Personalausweisnummer",
      nationalIDPlaceholder: "Personalausweisnummer eingeben",
      create: "Administrator erstellen",
      creating: "Wird erstellt..."
    },
    content: {
      allCompanyDepartments: "Alle Unternehmensabteilungen",
      uploadDocumentForEmployees: "Dokument für Mitarbeiter hochladen",
      uploadDocumentDescription: "Laden Sie ein Dokument hoch und senden Sie es an ausgewählte Mitarbeiter",
      pendingDevices: "Ausstehende Geräte",
      pendingRequests: "ausstehende Anfrage",
      employeeDevices: "Mitarbeitergeräte",
      file: "Datei",
      changeFile: "Datei ändern",
      clickToSelectFile: "Klicken Sie, um eine Datei auszuwählen",
      orDragFileHere: "oder ziehen Sie die Datei hierher",
      documentTitle: "Dokumenttitel",
      enterDocumentTitle: "Dokumenttitel eingeben",
      documentDescription: "Dokumentbeschreibung",
      optional: "(optional)",
      enterDocumentDescription: "Dokumentbeschreibung eingeben (optional)",
      selectEmployees: "Mitarbeiter auswählen",
      optionalLeaveEmptyForAll: "(optional – leer lassen, um an alle zu senden)",
      selectAll: "Alle auswählen",
      deselectAll: "Alle abwählen",
      loadingEmployees: "Mitarbeiter werden geladen...",
      noEmployeesAvailable: "Keine Mitarbeiter verfügbar",
      noEmployeesOrLoading: "Keine Mitarbeiter oder wird geladen...",
      selectEmployeeOptional: "Mitarbeiter auswählen (optional)",
      employeesSelected: "Ausgewählt",
      employee: "Mitarbeiter",
      uploading: "Wird hochgeladen...",
      uploadDocument: "Dokument hochladen",
      refresh: "Aktualisieren",
      uploadedDocuments: "Hochgeladene Dokumente",
      totalDocuments: "Gesamt",
      document: "Dokument",
      all: "Alle",
      company: "Unternehmen",
      employees: "Mitarbeiter",
      employeeBadge: "Mitarbeiter",
      companyBadge: "Unternehmen",
      untitledDocument: "Unbenanntes Dokument",
      clickEmployeeToViewDocuments: "Klicken Sie auf einen Mitarbeiternamen, um alle Dokumente anzuzeigen",
      noCompanyDocuments: "Keine Unternehmensdokumente",
      noEmployeeDocuments: "Keine Mitarbeiterdokumente",
      noDocumentsUploaded: "Keine Dokumente hochgeladen",
      startUploadingAbove: "Beginnen Sie, indem Sie oben ein neues Dokument hochladen",
      loading: "Wird geladen...",
      assets: "Vermögenswerte",
      manageCompanyEquipment: "Unternehmensvermögen verwalten",
      noEquipment: "Keine Vermögenswerte",
      addEquipment: "Vermögen hinzufügen",
      editBranch: "Filiale bearbeiten",
      status: "Status",
      selectStatus: "Status auswählen",
      active: "Aktiv",
      inactive: "Inaktiv",
      branchLocation: "Filialstandort (optional)",
      latitude: "Breitengrad",
      longitude: "Längengrad",
      areaRadius: "Bereichsradius in Metern (Radius)",
      useMyCurrentLocation: "Meinen aktuellen Standort verwenden",
      updateLocationOnMap: "Standort auf Karte aktualisieren",
      branchSettings: "Filialeinstellungen",
      loadingBranchSettings: "Filialeinstellungen werden geladen...",
      startTime: "Startzeit",
      endTime: "Endzeit",
      gracePeriod: "Karenzzeit (in Minuten)",
      selectAtLeastOneWorkDay: "Bitte wählen Sie mindestens einen Arbeitstag aus",
      scheduleInheritanceTitle: "Filialarbeitszeitplan",
      scheduleInheritanceHint: "Wenn Sie \"Unternehmensvorgaben folgen\" wählen, verwenden Mitarbeiter dieser Filiale die Hauptunternehmenseinstellungen (Arbeitstage, -zeiten, Karenzzeit und Zeitzone). Bei individueller Anpassung gelten die Einstellungen nur für die Mitarbeiter dieser Filiale.",
      useOrgWorkSchedule: "Unternehmensvorgaben folgen",
      useOrgWorkScheduleHint: "Arbeitstage, -zeiten, Karenzzeit und Zeitzone werden von den Hauptunternehmenseinstellungen übernommen.",
      branchShiftsTitle: "Filialschichten",
      useOrgShifts: "Firmenschichten übernehmen",
      useOrgShiftsHint: "Schichten aus den Firmeneinstellungen verwenden. Mitarbeiter dieser Filiale erhalten Firmenschichten.",
      customizeBranchShifts: "Filialschichten anpassen",
      customizeBranchShiftsHint: "Eigene Schichten für diese Filiale definieren, unabhängig von der Firma.",
      customizeBranchSchedule: "Für diese Filiale anpassen",
      customizeBranchScheduleHint: "Unabhängige Einstellungen nur für diese Filiale festlegen (Arbeitstage, -zeiten, Karenzzeit und Zeitzone).",
      fromOrganization: "Unternehmensvorgaben folgen",
      followCompanyLatePenalty: "Unternehmensvorgaben folgen",
      followCompanyLatePenaltyHint: "Verspätungsstrafen werden von den Hauptunternehmenseinstellungen übernommen.",
      customizeBranchLatePenalty: "Für diese Filiale anpassen",
      customizeBranchLatePenaltyHint: "Verspätungsstrafen nur für diese Filiale festlegen.",
      autoCheckoutSettings: "Einstellungen für automatisches Auschecken",
      followCompanyAutoCheckout: "Unternehmensvorgaben folgen",
      followCompanyAutoCheckoutHint: "Automatisches Auschecken wird von den Hauptunternehmenseinstellungen übernommen.",
      customizeBranchAutoCheckout: "Für diese Filiale anpassen",
      customizeBranchAutoCheckoutHint: "Einstellungen für automatisches Auschecken nur für diese Filiale festlegen.",
      checkInSelfieSettings: "Check-in-Selfie-Einstellungen",
      followCompanyCheckInSelfie: "Unternehmensvorgaben folgen",
      followCompanyCheckInSelfieHint: "Selfie-Richtlinie wird vom Hauptunternehmen übernommen.",
      customizeBranchCheckInSelfie: "Für diese Filiale anpassen",
      customizeBranchCheckInSelfieHint: "Selfie-Modus und Arbeitsarten nur für diese Filiale festlegen.",
      checkInSelfieMode: "Selfie-Modus",
      checkInSelfieApplyTo: "Für Arbeitsarten",
      checkInSelfieApplyToRequired: "Mindestens eine Arbeitsart auswählen",
      checkInSelfieModes: {
        off: "Aus",
        optional: "Optional",
        required: "Erforderlich",
      },
      checkInSelfieWorkTypes: {
        office: "Büro",
        remote: "Remote",
        hybrid: "Hybrid",
        delivery: "Lieferung",
      },
      autoCheckoutEnabled: "Automatisches Auschecken aktivieren",
      autoCheckoutGraceHours: "Stunden nach Schichtende",
      autoCheckoutGraceHoursHint: "Stunden nach Arbeitsende vor dem automatischen Auschecken (0–24)",
      autoCheckoutGraceHoursInvalid: "Stunden müssen zwischen 0 und 24 liegen",
      autoCheckoutCountOvertime: "Überstunden zählen",
      autoCheckoutNotifyEmployee: "Mitarbeiter benachrichtigen",
      autoCheckoutNotifyAdmin: "Admin benachrichtigen",
      autoCheckoutDeductionSettings: "Abzug bei vergessenem Checkout",
      followCompanyAutoCheckoutDeduction: "Unternehmensvorgaben folgen",
      followCompanyAutoCheckoutDeductionHint: "Der Abzug bei vergessenem Checkout wird vom Hauptunternehmen übernommen.",
      customizeBranchAutoCheckoutDeduction: "Für diese Filiale anpassen",
      customizeBranchAutoCheckoutDeductionHint: "Legen Sie eine Abzugsrichtlinie nur für diese Filiale fest, einschließlich keinem Abzug.",
      autoCheckoutDeductionPolicy: "Abzugsrichtlinie",
      autoCheckoutDeductionFree: "Kein Abzug",
      autoCheckoutDeductionQuarterDay: "Vierteltag",
      autoCheckoutDeductionHalfDay: "Halber Tag",
      autoCheckoutDeductionFixedAmount: "Fester Betrag",
      autoCheckoutDeductionFixedAmountHint: "Abzugsbetrag in der Gehaltswährung",
      autoCheckoutDeductionFixedAmountInvalid: "Geben Sie einen positiven Betrag mit höchstens 2 Dezimalstellen ein",
      hoursUnit: "Stunden",
      useOrgScheduledRemote: "Geplanten Remote-Tagen folgen",
      useOrgScheduledRemoteHint: "Geplante Remote-Arbeitstage aus den Hauptunternehmenseinstellungen verwenden.",
      customizeBranchScheduledRemote: "Remote-Tage für diese Filiale anpassen",
      customizeBranchScheduledRemoteHint: "Geplante Remote-Tage und Mitarbeiterkreis nur für diese Filiale festlegen.",
      scheduledRemoteFollowCompanyLocked: "Gesperrt, während den Unternehmenseinstellungen gefolgt wird. Wählen Sie \"Remote-Tage für diese Filiale anpassen\", um diese Optionen zu bearbeiten.",
      scheduledRemoteTitle: "Geplante Remote-Arbeitstage",
      scheduledRemoteHint: "Dies ändert nicht den dauerhaften Arbeitsort des Mitarbeiters. An ausgewählten Tagen werden sie als Remote behandelt und wechseln dann automatisch zurück zu Büro oder Hybrid.",
      scheduledRemoteEnable: "Geplante Remote-Tage aktivieren",
      scheduledRemoteDays: "Wochentage",
      scheduledRemoteScope: "Anwenden auf",
      scheduledRemoteEmployees: "Mitarbeiter",
      scheduledRemoteDepartments: "Abteilungen",
      scheduledRemoteSearchEmployees: "Nach Name oder E-Mail suchen...",
      scheduledRemoteNoEmployees: "Keine Mitarbeiter",
      scheduledRemoteNoDepartments: "Keine Abteilungen",
      scheduledRemoteScopeAll: "Alle Mitarbeiter",
      scheduledRemoteScopeSelected: "Ausgewählte Mitarbeiter",
      scheduledRemoteScopeDepartment: "Ausgewählte Abteilungen",
      latePenaltySettings: "Einstellungen für Verspätungsstrafen",
      enable: "Aktivieren",
      penaltyRules: "Strafregeln",
      addRule: "Regel hinzufügen",
      noRulesMessage: "Keine Regeln. Klicken Sie auf \"Regel hinzufügen\", um eine neue Regel hinzuzufügen.",
      rule: "Regel",
      delayMinutes: "Verspätungsminuten *",
      penaltyType: "Strafart",
      selectPenaltyType: "Strafart auswählen",
      none: "Keine",
      quarterDay: "Vierteltag",
      halfDay: "Halbtag",
      fullDay: "Ganzer Tag",
      custom: "Benutzerdefiniert",
      penaltyAmount: "Strafbetrag",
      penaltyDays: "Strafe in Tagen",
      tools: {
        title: "Werkzeuge",
        totalTools: "Gesamt",
        tool: "Tool",
        addTool: "Tool hinzufügen",
        noTools: "Keine Tools",
        startAddingTool: "Beginnen Sie, indem Sie oben ein neues Tool hinzufügen",
        assignmentCount: "Zuweisungsanzahl:",
        creationDate: "Erstellungsdatum:",
        showAssignedEmployees: "Zugewiesene Mitarbeiter anzeigen",
        hideAssignedEmployees: "Zugewiesene Mitarbeiter ausblenden",
        assignedAt: "Zugewiesen am:",
        addNewTool: "Neues Tool hinzufügen",
        toolName: "Tool-Name *",
        toolNamePlaceholder: "Beispiel: ChatGPT Pro",
        adding: "Wird hinzugefügt...",
        add: "Hinzufügen",
        editTool: "Tool bearbeiten",
        editToolPlaceholder: "Beispiel: ChatGPT Pro - Aktualisiert",
        updating: "Wird aktualisiert...",
        update: "Aktualisieren",
        assignTool: "Tool zuweisen:",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
        loadingEmployees: "Mitarbeiter werden geladen...",
        noAvailableEmployees: "Keine Mitarbeiter verfügbar",
        employeesSelected: "Ausgewählt",
        employee: "Mitarbeiter",
        assigning: "Wird zugewiesen...",
        assign: "Zuweisen",
        removeTool: "Tool entfernen:",
        employeesSelectedForRemoval: "Ausgewählt",
        employeesForRemoval: "Mitarbeiter zur Entfernung",
        removing: "Wird entfernt...",
        remove: "Entfernen",
        fetchFailed: "Tools konnten nicht abgerufen werden"
      },
      jobPositions: {
        title: "Positionen",
        allPositions: "Alle Positionen",
        addNewPosition: "Neue Position hinzufügen",
        noPositions: "Keine Positionen",
        positionName: "Positionsname *",
        enterPositionName: "Positionsnamen eingeben",
        description: "Beschreibung",
        enterDescription: "Beschreibung eingeben (optional)",
        status: "Status",
        selectStatus: "Status auswählen",
        order: "Reihenfolge:",
        creating: "Wird erstellt...",
        create: "Erstellen",
        createSuccess: "Position erfolgreich erstellt",
        createFailed: "Position konnte nicht erstellt werden",
        deleteConfirm: "Sind Sie sicher, dass Sie diese Position löschen möchten?",
        deleteSuccess: "Position erfolgreich gelöscht",
        deleteFailed: "Position konnte nicht gelöscht werden",
        fetchFailed: "Positionen konnten nicht geladen werden",
        orgIdNotFound: "Organisations-ID nicht gefunden. Bitte melden Sie sich ab und wieder an.",
        invalidOrgIdFormat: "Ungültiges Organisations-ID-Format. Muss XX-0000 entsprechen (z. B. DE-5292)",
        enterPositionNameRequired: "Bitte geben Sie einen Positionsnamen ein"
      },
      leaveRequests: {
        title: "Urlaubsanträge",
        request: "Antrag",
        noRequests: "Keine Urlaubsanträge",
        employee: "Mitarbeiter:",
        department: "Abteilung:",
        position: "Position:",
        from: "Von:",
        to: "Bis:",
        daysCount: "Tage:",
        day: "Tag",
        reason: "Grund:",
        leaveCategory: "Urlaubskategorie:",
        leaveType: "Urlaubsart:",
        paid: "Bezahlt",
        unpaid: "Unbezahlt",
        rejectionReason: "Ablehnungsgrund:",
        notes: "Anmerkungen:",
        requestDate: "Antragsdatum:",
        approve: "Genehmigen",
        reject: "Ablehnen",
        previous: "Zurück",
        next: "Weiter",
        page: "Seite",
        of: "von",
        approveTitle: "Urlaubsantrag genehmigen",
        leaveTypeLabel: "Urlaubsart",
        notesLabel: "Anmerkungen (optional)",
        notesPlaceholder: "Zusätzliche Anmerkungen eingeben",
        modifyDays: "Anzahl der Tage ändern (optional)",
        modifyDaysPlaceholder: "Leer lassen, um die ursprüngliche Anzahl beizubehalten",
        processing: "Wird verarbeitet...",
        approveSuccess: "Urlaubsantrag erfolgreich genehmigt",
        approveFailed: "Urlaubsantrag konnte nicht genehmigt werden",
        rejectTitle: "Urlaubsantrag ablehnen",
        rejectReasonLabel: "Ablehnungsgrund *",
        rejectReasonPlaceholder: "Grund für die Ablehnung des Urlaubsantrags eingeben",
        rejectReasonRequired: "Bitte geben Sie einen Ablehnungsgrund ein",
        rejectSuccess: "Urlaubsantrag erfolgreich abgelehnt",
        rejectFailed: "Urlaubsantrag konnte nicht abgelehnt werden",
        fetchFailed: "Urlaubsanträge konnten nicht geladen werden",
        unknown: "Unbekannt",
        notSpecified: "Nicht angegeben",
        cancelled: "Storniert"
      },
      devices: {
        title: "Mitarbeitergeräte",
        device: "Gerät",
        noDevices: "Keine Geräte",
        noPendingRequests: "Keine ausstehenden Geräteanfragen",
        status: {
          approved: "Genehmigt",
          pending: "Ausstehend",
          rejected: "Abgelehnt"
        },
        deviceType: "Gerätetyp:",
        brand: "Marke:",
        deviceName: "Gerätename:",
        model: "Modell:",
        deviceId: "Geräte-ID:",
        system: "Betriebssystem:",
        type: "Typ:",
        carrier: "Netzbetreiber:",
        requestDate: "Antragsdatum:",
        reviewDate: "Prüfdatum:",
        id: "ID:",
        unknown: "Unbekannt",
        notSpecified: "Nicht angegeben",
        unknownDevice: "Unbekanntes Gerät",
        approve: "Genehmigen",
        reject: "Ablehnen",
        approveSuccess: "Geräteantrag erfolgreich genehmigt",
        approveFailed: "Geräteantrag konnte nicht genehmigt werden",
        rejectSuccess: "Geräteantrag erfolgreich abgelehnt",
        rejectFailed: "Geräteantrag konnte nicht abgelehnt werden",
        rejectReasonPrompt: "Bitte geben Sie einen Ablehnungsgrund ein:",
        deleteConfirm: "Sind Sie sicher, dass Sie dieses Gerät löschen möchten?",
        deleteSuccess: "Gerät erfolgreich gelöscht",
        deleteFailed: "Gerät konnte nicht gelöscht werden",
        deviceIdNotFound: "Geräte-ID nicht gefunden",
        previous: "Zurück",
        next: "Weiter",
        page: "Seite",
        of: "von"
      },
      buttonTitles: {
        refreshList: "Liste aktualisieren",
        branchSettings: "Filialeinstellungen",
        viewBranchLocation: "Filialstandort anzeigen",
        editBranch: "Filiale bearbeiten",
        deleteBranch: "Filiale löschen",
        delete: "Löschen",
        reassign: "Neu zuweisen",
        unassign: "Zuweisung aufheben",
        assign: "Zuweisen",
        readingStatistics: "Lesestatistiken",
        viewDocument: "Dokument anzeigen",
        deleteDocument: "Dokument löschen",
        edit: "Bearbeiten",
        assignToEmployees: "Mitarbeitern zuweisen",
        removeFromEmployees: "Von Mitarbeitern entfernen",
        deleteDevice: "Gerät löschen",
        close: "Schließen"
      },
      confirmDeleteBranch: "Möchten Sie diese Filiale wirklich löschen?",
      confirmDeleteDepartment: "Möchten Sie diese Abteilung wirklich löschen?",
      confirmDeleteEquipment: "Möchten Sie diesen Vermögenswert wirklich löschen?",
      confirmUnassignEquipment: "Möchten Sie die Zuweisung dieses Vermögenswerts wirklich aufheben?",
      confirmDeleteTool: "Möchten Sie dieses Tool wirklich löschen?",
      confirmDeleteDocument: "Möchten Sie das Dokument \"{title}\" wirklich löschen?",
      customPenaltyNeedsAmountOrDays: "Benutzerdefinierte Strafe erfordert einen Betrag oder eine Anzahl von Tagen",
      createWithAssign: "Erstellen und zuweisen",
      createWithoutAssign: "Erstellen ohne Zuweisung",
      creating: "Wird erstellt...",
      orgNotFound: "Organisation nicht gefunden",
      addNewEquipment: "Neuen Vermögenswert hinzufügen",
      equipmentNameRequired: "Vermögenswertname *",
      equipmentNamePlaceholder: "z. B. Dell Latitude 5540 Laptop",
      equipmentDescPlaceholder: "z. B. Laptop für Büroarbeit",
      serialNumber: "Seriennummer",
      serialNumberPlaceholder: "z. B. DL-2024-001",
      priceEGPRequired: "Preis (EGP) *",
      pricePlaceholder: "z. B. 25000",
      assignToEmployeeOptional: "Mitarbeiter zuweisen (optional)",
      withoutAssignment: "Ohne Zuweisung",
      ordersCount: "{n} Bestellungen",
      loadMore: "Mehr laden",
      showingOf: "Anzeige {shown} von {total}",
      noOrders: "Keine Bestellungen",
      viewEmployeeDetails: "Mitarbeiterdetails anzeigen",
      employeeLabel: "Mitarbeiter:",
      emailLabel: "E-Mail:",
      phoneLabel: "Telefon:",
      departmentLabel: "Abteilung:",
      positionLabel: "Position:",
      orderDateLabel: "Bestelldatum:",
      locationLabel: "Standort:",
      createdAtLabel: "Erstellt am:",
      viewOnMap: "Auf Karte anzeigen",
      perPageOption: "{n} pro Seite",
      enterCount: "Anzahl eingeben",
      apply: "Anwenden",
      pageOfOrders: "Seite {page} von {pages} ({total} Bestellungen)",
      editEquipment: "Vermögen bearbeiten",
      assignEquipment: "Vermögen zuweisen",
      selectEmployeeRequired: "Mitarbeiter auswählen *",
      selectEmployeePlaceholder: "Mitarbeiter auswählen",
      selectNewEmployeeRequired: "Neuen Mitarbeiter auswählen *",
      selectNewEmployeePlaceholder: "Neuen Mitarbeiter auswählen",
      equipmentColon: "Vermögen:",
      currentlyAssigned: "Derzeit zugewiesen:",
      assigning: "Wird zugewiesen...",
      reassigning: "Wird neu zugewiesen...",
      assigned: "Zugewiesen",
      returned: "Zurückgegeben",
      serialNumberColon: "Seriennummer:",
      priceLabel: "Preis",
      egp: "EGP",
      assignedToColon: "Zugewiesen an:",
      assignmentDateColon: "Zuweisungsdatum:",
      autoPenaltyCalculated: "Diese Strafe wird automatisch anhand der Arbeitszeiten berechnet",
      setWorkStartEndRequired: "Bitte legen Sie Beginn und Ende der Arbeitszeit für die Filiale fest",
      selectTimezoneRequired: "Bitte wählen Sie eine Zeitzone für die Filiale",
      addLatePenaltyRuleOrDisable: "Fügen Sie mindestens eine Verspätungsregel hinzu oder deaktivieren Sie Verspätungsstrafen",
      invalidLatePenaltyType: "Jede Verspätungsregel muss einen gültigen Straftyp haben",
      totalReads: "Gesamte Lesungen",
      employeesWhoRead: "Mitarbeiter, die gelesen haben",
      readersList: "Leserliste",
      unknownEmployee: "Unbekannter Mitarbeiter",
      addressLabel: "Adresse:",
      coordinatesLabel: "Koordinaten:",
      areaRadiusLabel: "Bereichsradius:",
      meters: "Meter",
      addNewDepartment: "Neue Abteilung hinzufügen",
      editDepartment: "Abteilung bearbeiten",
      editPosition: "Position bearbeiten",
      editPositionHint: "Der Name wird automatisch für alle Mitarbeiter mit dieser Position aktualisiert.",
      deleteDepartment: "Abteilung löschen",
      editDepartmentHint: "Der Name wird automatisch für alle Mitarbeiter dieser Abteilung aktualisiert.",
      departmentName: "Abteilungsname",
      enterDepartmentName: "Abteilungsname eingeben",
      saving: "Wird gespeichert...",
      toasts: {
        loadBranchesFailed: "Fehler {status}: Filialen konnten nicht geladen werden",
        fetchDevicesFailed: "Gerätedaten konnten nicht abgerufen werden",
        fetchPendingDeviceRequestsFailed: "Ausstehende Geräteanfragen konnten nicht abgerufen werden",
        createBranchSuccess: "Filiale erfolgreich erstellt",
        createBranchFailed: "Filiale konnte nicht erstellt werden",
        deleteBranchSuccess: "Filiale erfolgreich gelöscht",
        deleteBranchFailed: "Filiale konnte nicht gelöscht werden",
        updateBranchSuccess: "Filiale erfolgreich aktualisiert",
        updateBranchFailed: "Filiale konnte nicht aktualisiert werden",
        loadBranchSettingsFailed: "Filialeinstellungen konnten nicht geladen werden. Lokal gespeicherte Daten werden verwendet.",
        updateBranchSettingsSuccess: "Filialeinstellungen erfolgreich aktualisiert",
        updateBranchSettingsFailed: "Filialeinstellungen konnten nicht aktualisiert werden",
        loadDepartmentsFailed: "Abteilungen konnten nicht geladen werden",
        fetchOrdersFailed: "Bestelldaten konnten nicht abgerufen werden",
        createDepartmentSuccess: "Abteilung erfolgreich erstellt",
        createDepartmentFailed: "Abteilung konnte nicht erstellt werden",
        updateDepartmentSuccess: "Abteilungsname erfolgreich aktualisiert",
        updateDepartmentFailed: "Abteilungsname konnte nicht aktualisiert werden",
        updateDepartmentEmployeesUpdated: "({count} Mitarbeiter aktualisiert)",
        updatePositionSuccess: "Positionsname erfolgreich aktualisiert",
        updatePositionFailed: "Positionsname konnte nicht aktualisiert werden",
        updatePositionEmployeesUpdated: "({count} Mitarbeiter aktualisiert)",
        deleteDepartmentSuccess: "Abteilung erfolgreich gelöscht",
        deleteDepartmentFailed: "Abteilung konnte nicht gelöscht werden",
        fetchEquipmentFailed: "Vermögensdaten konnten nicht abgerufen werden",
        createEquipmentSuccess: "Vermögen erfolgreich erstellt",
        createEquipmentAssignedSuccess: "Vermögen erfolgreich erstellt und zugewiesen",
        createEquipmentFailed: "Vermögen konnte nicht erstellt werden",
        updateEquipmentSuccess: "Vermögen erfolgreich aktualisiert",
        updateEquipmentFailed: "Vermögen konnte nicht aktualisiert werden",
        deleteEquipmentSuccess: "Vermögen erfolgreich gelöscht",
        deleteEquipmentFailed: "Vermögen konnte nicht gelöscht werden",
        assignEquipmentSuccess: "Vermögen erfolgreich zugewiesen",
        assignEquipmentFailed: "Vermögen konnte nicht zugewiesen werden",
        unassignEquipmentSuccess: "Zuweisung des Vermögens erfolgreich aufgehoben",
        unassignEquipmentFailed: "Zuweisung des Vermögens konnte nicht aufgehoben werden",
        reassignEquipmentSuccess: "Vermögen erfolgreich neu zugewiesen",
        reassignEquipmentFailed: "Vermögen konnte nicht neu zugewiesen werden",
        fetchDocumentsFailed: "Dokumente konnten nicht abgerufen werden",
        fetchDocumentStatsFailed: "Dokumentstatistiken konnten nicht abgerufen werden",
        deleteDocumentSuccess: "Dokument erfolgreich gelöscht",
        deleteDocumentAffectedEmployees: " ({count} Mitarbeiter aktualisiert)",
        deleteDocumentFailed: "Dokument konnte nicht gelöscht werden",
        uploadDocumentSuccess: "Dokument erfolgreich hochgeladen",
        uploadDocumentSummary: " ({updated} Mitarbeiter aktualisiert, {notified} Mitarbeiter benachrichtigt)",
        uploadDocumentFailed: "Dokument konnte nicht hochgeladen werden",
        fetchEmployeesFailed: "Mitarbeiter konnten nicht abgerufen werden",
        createToolSuccess: "Tool erfolgreich erstellt",
        createToolFailed: "Tool konnte nicht erstellt werden",
        updateToolSuccess: "Tool erfolgreich aktualisiert",
        updateToolFailed: "Tool konnte nicht aktualisiert werden",
        deleteToolSuccess: "Tool erfolgreich gelöscht",
        deleteToolFailed: "Tool konnte nicht gelöscht werden",
        assignToolSuccess: "Tool erfolgreich an {count} Mitarbeiter zugewiesen",
        assignToolFailed: "Tool konnte nicht zugewiesen werden",
        removeToolSuccess: "Tool erfolgreich von {count} Mitarbeitern entfernt",
        removeToolFailed: "Tool konnte nicht entfernt werden",
        createAdminSuccess: "Administrator erfolgreich erstellt",
        createAdminFailed: "Administrator konnte nicht erstellt werden",
        onlyOrgAdminsCanCreate: "Nur Organisationsadministratoren können zusätzliche Administratoren erstellen"
      }
    },
    days: {
      sunday: "Sonntag",
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag"
    }
  },
  reports: {
    title: "Berichte",
    description: "Alle Systemberichte anzeigen und verwalten",
    generalInfo: "Allgemeine Informationen",
    generalInfoDesc: "Allgemeine Informationen zu Mitarbeitern und Unternehmen anzeigen",
    salaryInfo: "Gehaltsinformationen",
    salaryInfoDesc: "Umfassende Berichte über Gehälter und Zulagen",
    employmentInfo: "Beschäftigungsinformationen",
    employmentInfoDesc: "Beschäftigungsdetails und Eintrittsdatum",
    leaveBalance: "Urlaubsguthaben",
    leaveBalanceDesc: "Verbleibendes Urlaubsguthaben pro Mitarbeiter anzeigen",
    annualLeaves: "Jahresurlaube",
    annualLeavesDesc: "Alle Urlaube innerhalb des Jahres erfassen",
    contactInfo: "Kontaktinformationen",
    contactInfoDesc: "Kontaktdaten aller Mitarbeiter",
    birthdays: "Geburtstage",
    birthdaysDesc: "Liste der Mitarbeitergeburtstage",
    emergencyContact: "Notfallkontakt",
    emergencyContactDesc: "Notfallkontaktinformationen",
    probationPeriods: "Probezeiten",
    probationPeriodsDesc: "Probezeiten neuer Mitarbeiter verfolgen",
    formerEmployees: "Ehemalige Mitarbeiter",
    formerEmployeesDesc: "Datensätze ausgeschiedener Mitarbeiter",
    bankAccounts: "Bankkonten",
    bankAccountsDesc: "Bankkontoinformationen der Mitarbeiter",
    fixedAssets: "Anlagevermögen",
    fixedAssetsDesc: "Anlagevermögen und Inventar",
    attendanceData: "Anwesenheitsdaten",
    attendanceDataDesc: "Detaillierte Berichte über An- und Abwesenheit",
    disciplinaryReport: "Disziplinarbericht",
    disciplinaryReportDesc: "Erfassung von Disziplinarmaßnahmen und Abmahnungen",
    permissionRequests: "Berechtigungsanträge",
    permissionRequestsDesc: "Berechtigungsanträge und Genehmigungen verfolgen",
    backToReports: "Zurück zu Berichten",
    reportNotFound: "Bericht nicht gefunden",
    reportNotFoundDesc: "Der angeforderte Bericht existiert nicht oder wurde gelöscht.",
    loadingData: "Daten werden geladen...",
    errorLoadingData: "Beim Laden der Daten ist ein Fehler aufgetreten",
    errorFetchingData: "Beim Abrufen der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    errorExportingFile: "Beim Exportieren der Datei ist ein Fehler aufgetreten",
    dataLabel: "Daten",
    reportSheetName: "Bericht",
    totalEmployees: "Mitarbeiter gesamt",
    activeEmployees: "Aktive Mitarbeiter",
    onLeaveEmployees: "Im Urlaub",
    totalDepartments: "Abteilungen gesamt",
    averageSalary: "Durchschnittsgehalt",
    totalSalary: "Gesamtgehalt",
    maxSalary: "Höchstgehalt",
    minSalary: "Mindestgehalt",
    totalAllowances: "Zulagen gesamt",
    totalDeductions: "Abzüge gesamt",
    totalFormerEmployees: "Ehemalige Mitarbeiter gesamt",
    employeeList: "Mitarbeiterliste",
    downloadExcel: "Excel herunterladen",
    no: "Nein",
    serialNo: "Nr.",
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    department: "Abteilung",
    position: "Position",
    status: "Status",
    joinDate: "Eintrittsdatum",
    workLocation: "Arbeitsort",
    baseSalary: "Grundgehalt",
    allowances: "Zulagen",
    deductions: "Abzüge",
    netSalary: "Nettogehalt",
    approvalStatus: "Genehmigungsstatus",
    startDate: "Startdatum",
    directManager: "Direkter Vorgesetzter",
    teamLeader: "Teamleiter",
    distributionByDepartments: "Verteilung nach Abteilungen",
    distributionByStatus: "Verteilung nach Status",
    birthDate: "Geburtsdatum",
    birthday: "Geburtstag",
    daysUntilBirthday: "Tage bis zum Geburtstag",
    probationEndDate: "Ende der Probezeit",
    daysRemaining: "Verbleibende Tage",
    daysInProbation: "Tage in Probezeit",
    endDate: "Enddatum",
    reason: "Grund",
    requestDate: "Antragsdatum",
    duration: "Dauer (Tage)",
    approvedBy: "Genehmigt von",
    rejectionReason: "Ablehnungsgrund",
    date: "Datum",
    checkIn: "Einchecken",
    checkOut: "Auschecken",
    workHours: "Arbeitsstunden",
    overtimeHours: "Überstunden",
    earlyLeave: "Frühzeitiges Gehen",
    deductionAmount: "Abzugsbetrag",
    assetName: "Vermögenswertname",
    assetStatus: "Status",
    assignedTo: "Zugewiesen an",
    assetPrice: "Preis",
    assets: "Vermögenswerte",
    assetsCount: "Anzahl der Vermögenswerte",
    assignedDate: "Zuweisungsdatum",
    serialNumber: "Seriennummer",
    noAssets: "Keine Vermögenswerte",
    noFixedAssetsData: "Keine Anlagevermögensdaten verfügbar",
    totalAssets: "Vermögenswerte gesamt",
    employeesWithAssets: "Mitarbeiter mit Vermögenswerten",
    issuedAssets: "Ausgegebene Vermögenswerte",
    bankName: "Bankname",
    accountNumber: "Kontonummer",
    iban: "IBAN",
    noEmployeeData: "Keine Mitarbeiterdaten verfügbar",
    noDataAvailable: "Keine Daten verfügbar",
    employeesWithSalary: "Mitarbeiter mit Gehalt",
    notSpecified: "Nicht angegeben",
    active: "Aktiv",
    inactive: "Inaktiv",
    onLeave: "Im Urlaub",
    underTraining: "In der Einarbeitung",
    serviceEnded: "Dienst beendet",
    resigned: "Zurückgetreten",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    underReview: "In Prüfung",
    approvedPlural: "Genehmigt",
    teamLeaders: "Teamleiter",
    departmentLabels: {
      management: "Leitung"
    },
    totalApprovedLeaves: "Genehmigte Urlaube gesamt",
    totalPendingLeaves: "Ausstehende Urlaube gesamt",
    averageLeaveBalance: "Durchschnittliches Urlaubsguthaben",
    totalLeaveBalance: "Urlaubsguthaben gesamt",
    totalRejectedLeaves: "Abgelehnte Urlaube gesamt",
    totalLeaveRequests: "Urlaubsanträge gesamt",
    totalLeaves: "Urlaube gesamt",
    totalPendingLeavesDays: "Ausstehende Urlaubstage gesamt",
    pendingCount: "Ausstehend (Anzahl)",
    pendingDays: "Ausstehend (Tage)",
    approvedCount: "Genehmigt (Anzahl)",
    approvedDays: "Genehmigt (Tage)",
    totalDeductionsLabel: "Abzüge gesamt",
    selectYear: "Jahr auswählen",
    year: "Jahr",
    totalAllLeaves: "Alle Urlaube gesamt",
    totalApprovedLeaveDays: "Genehmigte Urlaubstage gesamt",
    totalAllLeaveDays: "Alle Urlaubstage gesamt",
    annualLeavesTitle: "Jahresurlaube",
    totalPermissionDays: "Berechtigungstage gesamt",
    employeesWithEmail: "Mitarbeiter mit E-Mail",
    employeesWithPhone: "Mitarbeiter mit Telefon",
    employeesWithEmergencyContact: "Mitarbeiter mit Notfallkontakt",
    employeesWithBankAccount: "Mitarbeiter mit Bankkonto",
    employeesWithIBAN: "Mitarbeiter mit IBAN",
    employeesWithSwiftCode: "Mitarbeiter mit SWIFT-Code",
    employeesWithDisciplinary: "Mitarbeiter mit Disziplinarmaßnahmen",
    address: "Adresse",
    probationCompleted: "Probezeit abgeschlossen",
    inProbationPeriod: "In Probezeit",
    averageDaysRemaining: "Durchschnittlich verbleibende Tage",
    completed: "Abgeschlossen",
    leaveTypeAnnual: "Jährlich",
    leaveTypeSick: "Krankheit",
    leaveType: "Urlaubsart",
    selectDays: "Tage auswählen",
    notAvailable: "Nicht verfügbar",
    selectTimePeriod: "Zeitraum auswählen",
    fromDate: "Von Datum:",
    toDate: "Bis Datum:",
    search: "Suchen",
    totalRecords: "Datensätze gesamt",
    numberOfEmployees: "Anzahl der Mitarbeiter",
    present: "Pünktlich anwesend",
    late: "Verspätet",
    absent: "Abwesend",
    totalAbsences: "Abwesenheiten gesamt",
    totalLateArrivals: "Verspätete Ankünfte gesamt",
    absences: "Abwesenheiten",
    lateArrivals: "Verspätete Ankünfte",
    hour: "Stunde",
    hours: "Stunden",
    yes: "Ja",
    noAttendanceDataForPeriod: "Keine Anwesenheitsdaten für den ausgewählten Zeitraum",
    attendanceDataReport: "Anwesenheitsdaten",
    totalPositions: "Positionen gesamt",
    totalStatuses: "Status gesamt",
    all: "Alle",
    totalDisciplinaryActions: "Disziplinarmaßnahmen gesamt",
    totalWarnings: "Abmahnungen gesamt",
    totalPenalties: "Strafen gesamt",
    totalPenaltyAmount: "Strafbetrag gesamt",
    disciplinaryActions: "Disziplinarmaßnahmen",
    warnings: "Abmahnungen",
    penalties: "Strafen",
    selectRequestStatus: "Antragsstatus auswählen",
    requestStatus: "Status:",
    totalRequests: "Anträge gesamt",
    noPermissionRequestsForStatus: "Keine Berechtigungsanträge für den ausgewählten Status verfügbar",
    departureDate: "Austrittsdatum",
    paymentMethod: "Zahlungsmethode",
    bankTransfer: "Banküberweisung",
    noContactData: "Keine Kontaktdaten verfügbar",
    totalWorkingHours: "Arbeitsstunden gesamt",
    totalOvertimeHours: "Überstunden gesamt",
    noSalaryData: "Keine Gehaltsdaten verfügbar",
    salaryBreakdown: {
      title: "Gehaltsaufschlüsselung",
      clickHint: "Klicken Sie auf einen Mitarbeiter, um die Gehaltserklärung anzuzeigen",
      close: "Schließen",
      ok: "OK",
      prorationTitle: "Warum ist der Betrag niedriger als das zugewiesene Gehalt?",
      prorationExplain: "Da das Eintrittsdatum {date} ist, werden Grundgehalt, Zulagen und Boni für die Arbeitstage dieses Monats berechnet ({actual} Tage von {total} Arbeitstagen).",
      baseSalaryExplain: "Dies ist das volle vom Management zugewiesene Grundgehalt.",
      baseSalaryExplainProrated: "Dies ist das volle monatliche Grundgehalt. Der fällige Betrag wird für diesen Monat basierend auf dem Eintrittsdatum anteilig berechnet.",
      thisMonthBase: "Grundgehalt dieses Monats (nach anteiliger Berechnung)",
      bonuses: "Boni",
      totalBonuses: "Boni gesamt",
      overtime: "Überstunden",
      noAllowances: "Derzeit keine Zulagen zugewiesen",
      noBonuses: "Keine Boni in diesem Monat",
      noDeductions: "Keine Abzüge in diesem Monat",
      amountDue: "Fälliger Betrag (Nettogehalt)",
      amountDueHint: "Nach Zulagen, Boni und Abzügen",
      amountDueHintProrated: "Fällig für {actual} Tage von {total} Arbeitstagen",
      netFormula: "Netto = berechnetes Grundgehalt + Zulagen + Boni − Abzüge",
    },
    noEmploymentData: "Keine Beschäftigungsdaten verfügbar",
    noLeaveBalanceData: "Keine Urlaubsguthabensdaten verfügbar",
    noAnnualLeavesData: "Keine Jahresurlaubsdaten für Jahr verfügbar",
    leaveDetails: "Urlaubsdetails:",
    from: "Von",
    to: "Bis",
    totalBirthdays: "Geburtstage gesamt",
    upcomingBirthdays: "Bevorstehende Geburtstage",
    daysUntil: "Tage bis",
    age: "Alter",
    noBirthdaysInPeriod: "Keine bevorstehenden Geburtstage in den nächsten",
    noProbationData: "Keine Probezeitdaten verfügbar",
    noDisciplinaryData: "Keine Disziplinardaten verfügbar",
    disciplinaryDetails: "Disziplinardetails:",
    penaltyAmount: "Strafbetrag:",
    day: "Tag",
    days: "Tage",
    rejectedCount: "Abgelehnt (Anzahl)",
    rejectedDays: "Abgelehnt (Tage)",
    annual: "Jährlich",
    sick: "Krankheit",
    export: {
      notSpecified: "Nicht angegeben",
      notAvailable: "Nicht verfügbar",
      leaveAnnual: "Jährlich",
      leaveSick: "Krankheit",
      leaveApproved: "Genehmigt",
      leavePending: "Ausstehend",
      leaveRejected: "Abgelehnt",
      male: "Männlich",
      female: "Weiblich",
      yes: "Ja",
      no: "Nein",
      approvedSingular: "Genehmigt",
      penalty: "Strafe",
      warning: "Verwarnung",
      bankTransfer: "Banküberweisung",
      leaveDetails: "Urlaubsdetails",
      disciplinaryDetails: "Disziplinardetails",
      employeesWithAddress: "Mitarbeiter mit Adresse",
      numberOfDays: "Anzahl der Tage",
      numberOfPositions: "Anzahl der Positionen",
      numberOfStatuses: "Anzahl der Status",
      daysSuffix: "Tage",
      daySuffix: "Tag",
      headers: {
        number: "Nr.",
        employeeNumber: "Mitarbeiter-Nr.",
        name: "Name",
        employeeName: "Mitarbeitername",
        email: "E-Mail",
        phone: "Telefon",
        department: "Abteilung",
        position: "Position",
        status: "Status",
        joinDate: "Eintrittsdatum",
        nationalId: "Personalausweis-Nr.",
        gender: "Geschlecht",
        birthDate: "Geburtsdatum",
        birthday: "Geburtstag",
        address: "Adresse",
        workLocation: "Arbeitsort",
        directManager: "Direkter Vorgesetzter",
        baseSalary: "Grundgehalt",
        allowances: "Zulagen",
        deductions: "Abzüge",
        netSalary: "Nettogehalt",
        approvalStatus: "Genehmigungsstatus",
        startDate: "Startdatum",
        endDate: "Enddatum",
        teamLead: "Teamleiter",
        periodOfStay: "Verweildauer (Tage)",
        totalLeaves: "Urlaub gesamt",
        approved: "Genehmigt",
        pending: "Ausstehend",
        rejected: "Abgelehnt",
        leaveBalance: "Urlaubssaldo",
        year: "Jahr",
        approvedCount: "Genehmigt (Anzahl)",
        approvedDays: "Genehmigt (Tage)",
        pendingCount: "Ausstehend (Anzahl)",
        pendingDays: "Ausstehend (Tage)",
        rejectedCount: "Abgelehnt (Anzahl)",
        rejectedDays: "Abgelehnt (Tage)",
        leaveType: "Urlaubsart",
        daysCount: "Anzahl der Tage",
        emergencyContactName: "Notfallkontakt - Name",
        emergencyContactPhone: "Notfallkontakt - Telefon",
        daysRemaining: "Verbleibende Tage",
        age: "Alter",
        daysInProbation: "Tage in Probezeit",
        completed: "Abgeschlossen",
        date: "Datum",
        checkIn: "Check-in",
        checkOut: "Check-out",
        workHours: "Arbeitsstunden",
        overtimeHours: "Überstunden",
        earlyLeave: "Früherer Feierabend",
        deductionAmount: "Abzugsbetrag",
        totalActions: "Maßnahmen gesamt",
        absences: "Abwesenheiten",
        lateArrivals: "Verspätungen",
        warnings: "Verwarnungen",
        penalties: "Strafen",
        type: "Typ",
        reason: "Grund",
        description: "Beschreibung",
        penaltyAmount: "Strafbetrag",
        bankName: "Bankname",
        accountNumber: "Kontonummer",
        iban: "IBAN",
        swiftCode: "Swift Code",
        paymentMethod: "Zahlungsmethode",
        departureDate: "Austrittsdatum",
        requestId: "Antrags-Nr.",
        requestDate: "Antragsdatum",
        duration: "Dauer (Tage)",
        approvedBy: "Genehmigt von",
        rejectionReason: "Ablehnungsgrund",
        totalEmployees: "Mitarbeiter gesamt",
        activeEmployees: "Aktive Mitarbeiter",
        onLeave: "Im Urlaub",
        departmentsCount: "Anzahl der Abteilungen",
        totalBaseSalaries: "Grundgehälter gesamt",
        averageSalary: "Durchschnittsgehalt",
        maxSalary: "Höchstes Gehalt",
        minSalary: "Niedrigstes Gehalt",
        totalAllowances: "Zulagen gesamt",
        totalDeductions: "Abzüge gesamt",
        employeesCount: "Anzahl der Mitarbeiter",
        approvedCountStat: "Genehmigt",
        underReview: "In Prüfung",
        teamLeaders: "Teamleiter",
        totalApprovedLeaves: "Genehmigte Urlaube gesamt",
        totalPendingLeaves: "Ausstehende Urlaube gesamt",
        totalRejectedLeaves: "Abgelehnte Urlaube gesamt",
        totalLeaveBalance: "Urlaubssaldo gesamt",
        averageLeaveBalance: "Durchschnittlicher Urlaubssaldo",
        totalLeaveRequests: "Urlaubsanträge gesamt",
        totalApprovedLeaveDays: "Genehmigte Urlaubstage gesamt",
        totalPendingLeaveDays: "Ausstehende Urlaubstage gesamt",
        totalRejectedLeaveDays: "Abgelehnte Urlaubstage gesamt",
        totalAllLeaveDays: "Alle Urlaubstage gesamt",
        employeesWithEmail: "Mitarbeiter mit E-Mail",
        employeesWithPhone: "Mitarbeiter mit Telefon",
        employeesWithEmergencyContact: "Mitarbeiter mit Notfallkontakt",
        totalBirthdays: "Geburtstage gesamt",
        probationCompleted: "Probezeit abgeschlossen",
        inProbation: "In Probezeit",
        averageDaysRemaining: "Durchschnittlich verbleibende Tage",
        totalDisciplinaryActions: "Disziplinarmaßnahmen gesamt",
        totalWarnings: "Verwarnungen gesamt",
        totalPenalties: "Strafen gesamt",
        totalAbsences: "Abwesenheiten gesamt",
        totalLateArrivals: "Verspätungen gesamt",
        employeesWithActions: "Mitarbeiter mit Disziplinarmaßnahmen",
        totalPenaltyAmount: "Strafbetrag gesamt",
        employeesWithBankAccount: "Mitarbeiter mit Bankkonto",
        employeesWithIBAN: "Mitarbeiter mit IBAN",
        employeesWithSwiftCode: "Mitarbeiter mit Swift Code",
        totalFormerEmployees: "Ehemalige Mitarbeiter gesamt",
        totalRequests: "Anträge gesamt",
        totalPermissionDays: "Genehmigungstage gesamt"
      },
      fileNames: {
        generalInfo: "allgemeine_infos",
        salaryInfo: "gehaltsinfos",
        employmentInfo: "beschaeftigungsinfos",
        leaveBalance: "urlaubssaldo",
        annualLeaves: "jahresurlaub",
        contactInfo: "kontaktinfos",
        upcomingBirthdays: "bevorstehende_geburtstage",
        days: "tage",
        probationPeriods: "probezeiten",
        attendanceData: "anwesenheitsdaten",
        disciplinaryReport: "disziplinarbericht",
        bankAccounts: "bankkonten",
        formerEmployees: "ehemalige_mitarbeiter",
        permissionRequests: "genehmigungsantraege",
        statusAll: "alle",
        statusPending: "ausstehend",
        statusApproved: "genehmigt",
        statusRejected: "abgelehnt"
      }
    }
  },
  attendance: {
    title: "Anwesenheitserfassung",
    description: "Anwesenheit aller Mitarbeiter für einen bestimmten Monat anzeigen",
    employeeRecord: "Anwesenheitserfassung",
    loadingEmployees: "Mitarbeiter werden geladen...",
    loadingData: "Daten werden geladen...",
    noEmployees: "Keine Mitarbeiter",
    noSearchResults: "Keine Suchergebnisse",
    noAttendanceData: "Keine Anwesenheitsdaten für diesen Monat",
    noAttendanceDataYet: "Noch keine Anwesenheitsdaten verfügbar",
    employeesList: "Anwesenheitserfassung",
    viewAttendance: "Anwesenheit anzeigen",
    viewAttendanceDetails: "Anwesenheitsdetails anzeigen",
    monthlyDetails: "Monatliche Anwesenheitsdetails",
    searchPlaceholder: "Nach Mitarbeiter nach Name, Position oder Abteilung suchen...",
    viewingMonth: "Anwesenheit anzeigen für",
    clickToView: "Klicken Sie für jeden Mitarbeiter auf die Schaltfläche \"Anwesenheit anzeigen\", um seine vollständigen Anwesenheitsdetails für diesen Monat anzuzeigen",
    stats: {
      presentDays: "Anwesend",
      absentDays: "Abwesend",
      lateDays: "Verspätet",
      holidayDays: "Feiertage",
      earlyLeaveDays: "Frühzeitiges Gehen",
      totalHours: "Arbeitsstunden",
      overtimeHours: "Überstunden"
    },
    tableHeaders: {
      number: "Nr.",
      name: "Name",
      position: "Position",
      department: "Abteilung",
      actions: "Aktionen",
      employeeName: "Mitarbeitername",
      date: "Datum",
      checkIn: "Einchecken",
      checkOut: "Auschecken",
      checkInLocation: "Eincheckort",
      checkOutLocation: "Auscheckort",
      workingHours: "Arbeitsstunden",
      status: "Status"
    },
    status: {
      present: "Pünktlich anwesend",
      absent: "Abwesend",
      late: "Verspätet",
      holiday: "Gesetzlicher Feiertag",
      leave: "Bezahlter Urlaub",
      unpaidLeave: "Unbezahlter Urlaub",
      halfDay: "Halbtag",
      quarterDay: "Vierteltag",
      earlyLeave: "Frühzeitiges Gehen",
      autoCheckout: "Automatisches Auschecken",
      externalTask: "Externe Aufgabe",
      notSpecified: "Nicht angegeben"
    },
    time: {
      morning: "Uhr",
      evening: "Uhr",
      hours: "Stunden"
    },
    payroll: {
      generateTitle: "Gehaltsabrechnungen für diesen Monat generieren",
      generateDescription: "Das Gehalt wird aus Anwesenheit, Auschecken und Abzügen berechnet, und die Gehaltsabrechnung für den angegebenen Monat wird erstellt.",
      generating: "Wird generiert...",
      generateButton: "Pläne für diesen Monat generieren",
      selectEmployeeFirst: "Bitte wählen Sie zuerst einen Mitarbeiter aus",
      confirmGenerate: "Möchten Sie die Gehaltsabrechnung für Mitarbeiter generieren?",
      confirmForMonth: "für Monat",
      success: "Gehaltsabrechnung erfolgreich für Mitarbeiter generiert",
      error: "Beim Generieren der Gehaltsabrechnung ist ein Fehler aufgetreten",
      failed: "Gehaltsabrechnung konnte nicht generiert werden"
    },
    days: {
      sunday: "Sonntag",
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag"
    },
    errorLoadingAttendance: "Anwesenheitsdaten konnten nicht geladen werden",
    errorLoadingAttendanceMessage: "Beim Laden der Anwesenheitsdaten ist ein Fehler aufgetreten",
    errorSelectDates: "Bitte wählen Sie Start- und Enddatum aus",
    errorFetchingData: "Daten für den Export konnten nicht abgerufen werden",
    noDataToExport: "Keine Daten zum Exportieren",
    errorExporting: "Beim Exportieren der Daten ist ein Fehler aufgetreten",
    exportSuccess: "Exportiert",
    exportSuccessRecords: "Anwesenheitsdatensätze erfolgreich",
    employeeNumber: "Mitarbeiternummer",
    employeeName: "Mitarbeitername",
    position: "Position",
    date: "Datum",
    checkInTime: "Eincheckzeit",
    checkOutTime: "Auscheckzeit",
    checkInPhoto: "Check-in-Foto",
    viewCheckInPhoto: "Check-in-Foto anzeigen",
    noCheckInPhoto: "Kein Foto",
    closePhoto: "Foto schließen",
    workingHours: "Arbeitsstunden",
    overtimeHours: "Überstunden",
    earlyLeave: "Frühzeitiges Gehen",
    deductionAmount: "Abzugsbetrag",
    attendanceRecord: "Anwesenheitserfassung",
    refresh: "Aktualisieren",
    exportExcel: "Excel herunterladen",
    exporting: "Wird exportiert...",
    fromDate: "Von Datum",
    toDate: "Bis Datum",
    userIDNotAvailable: "Benutzer-ID nicht verfügbar",
    errorLoadingWeeklyAttendance: "Wöchentliche Anwesenheitsdaten konnten nicht geladen werden",
    errorLoadingTodayAttendance: "Heutige Anwesenheitsdaten konnten nicht geladen werden",
    attendanceData: "Anwesenheitsdaten",
    selectDateRange: "Datumsbereich auswählen (optional)",
    selectDateRangeTitle: "Datumsbereich auswählen",
    cancel: "Abbrechen",
    save: "Speichern",
    todayAttendance: "Heutige Anwesenheit",
    periodAttendance: "Anwesenheit im Zeitraum",
    workedFrom: "Gearbeitet von",
    workedTo: "bis",
    workingHoursLabel: "Arbeitsstunden:",
    overtimeHoursLabel: "Überstunden:",
    deductionHoursLabel: "Abzugsstunden:",
    hours: "Stunden",
    presentDays: "Anwesend",
    absentDays: "Abwesend",
    earlyLeaveDays: "Frühzeitiges Gehen",
    lateDays: "Verspätet",
    holidayDays: "Feiertage",
    halfDay: "Halbtag",
    errorFetchingLocation: "Fehler beim Abrufen des Standorts",
    enableLocationPermission: "Bitte aktivieren Sie die Standortberechtigung im Browser",
    browserNotSupportGeolocation: "Browser unterstützt Geolokalisierung nicht",
    mainOffice: "Hauptbüro",
    deliveryByOrder: "Auftragszustellung",
    deliveryByOrderNoCheckIn: "Dieser Arbeitstyp erfordert kein Ein- oder Auschecken",
    yourCurrentLocation: "Ihr aktueller Standort",
    companyLocation: "Unternehmensstandort",
    updateEmployeeLocation: "Mitarbeiterstandort aktualisieren",
    updateMapData: "Kartendaten aktualisieren",
    clearBrowserCache: "Browser-Cache löschen",
    enableLocationPermissionForCheckIn: "Für das Einchecken ist eine Standortberechtigung erforderlich",
    outsideCompanyRadius: "Sie befinden sich außerhalb des Radius einer Unternehmensfiliale.",
    enableLocationPermissionForCheckOut: "Für das Auschecken ist eine Standortberechtigung erforderlich",
    checkInSuccess: "Einchecken erfolgreich",
    checkInFailed: "Einchecken fehlgeschlagen",
    errorDuringCheckIn: "Beim Einchecken ist ein Fehler aufgetreten",
    checkOutSuccess: "Auschecken erfolgreich",
    checkOutFailed: "Auschecken fehlgeschlagen",
    errorDuringCheckOut: "Beim Auschecken ist ein Fehler aufgetreten",
    notRegistered: "Nicht registriert",
    registered: "Registriert",
    checkedOut: "Ausgecheckt",
    checkIn: "Einchecken",
    checkOut: "Auschecken",
    loading: "Wird geladen...",
    todayAttendanceTitle: "Heutige Anwesenheit",
    statistics: "Statistiken",
    selectStatisticsPeriod: "Statistikzeitraum auswählen",
    thisMonth: "Diesen Monat",
    lastMonth: "Letzten Monat",
    allData: "Alle Daten",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Enddatum",
    search: "Suchen",
    dailyHoursAverage: "Durchschnittliche Stunden pro Tag",
    hoursPerDay: "Stunden pro Tag",
    totalWorkingHours: "Arbeitsstunden gesamt",
    attendanceRate: "Anwesenheitsquote",
    lastUpdate: "Letzte Aktualisierung:",
    enter: "Eingang",
    exit: "Ausgang",
    extra: "Extra",
    deduction: "Abzug",
    errorLoadingUserData: "Benutzerdaten konnten nicht geladen werden",
    errorLoadingDailyAttendance: "Tägliche Anwesenheitsdaten konnten nicht geladen werden",
    errorLoadingData: "Beim Laden der Daten ist ein Fehler aufgetreten",
    and: "und",
    rejectReasonOptional: "Ablehnungsgrund (optional):",
    enterRejectionReason: "Bitte geben Sie einen Ablehnungsgrund ein:",
    rejectionReasonLabel: "Ablehnungsgrund:",
    enterDeductionNameInRow: "Bitte geben Sie einen Abzugsnamen in Zeile ein",
    enterValidAmountInRow: "Bitte geben Sie einen gültigen Betrag in Zeile ein",
    enterAllowanceName: "Bitte geben Sie einen Zulagennamen ein",
    enterValidAllowanceAmount: "Bitte geben Sie einen gültigen Zulagenbetrag ein",
    enterValidBaseSalary: "Bitte geben Sie ein gültiges Grundgehalt ein",
    enterDailyOrdersCount: "Bitte geben Sie die tägliche Auftragsanzahl ein (muss 1 oder mehr sein)",
    enterExpectedDailyOrders: "Bitte geben Sie die erwartete tägliche Auftragsanzahl für den Mitarbeiter ein",
    enterBaseSalaryInEGP: "Bitte geben Sie das Grundgehalt des Mitarbeiters ein",
    enterEndDateOrEnablePermanent: "Bitte geben Sie ein Enddatum ein oder aktivieren Sie die Option \"Dauerhaft\"",
    enterRejectionReasonMinLength: "Der Ablehnungsgrund muss mindestens 10 Zeichen lang sein",
    enterRejectionReasonMaxLength: "Der Ablehnungsgrund ist zu lang (maximal 500 Zeichen)",
    enterRejectionReasonForEmployee: "Bitte geben Sie einen Ablehnungsgrund für den Mitarbeiter ein",
    rejectionReasonPlaceholder: "Ablehnungsgrund (zwischen 10 und 500 Zeichen)...",
    enterValidCoordinates: "Bitte geben Sie gültige Koordinaten ein",
    enterBranchName: "Bitte geben Sie einen Filialnamen ein",
    enterDepartmentName: "Bitte geben Sie einen Abteilungsnamen ein",
    enterAssetName: "Bitte geben Sie einen Vermögenswertnamen ein",
    enterValidPrice: "Bitte geben Sie einen gültigen Preis ein",
    enterDocumentTitle: "Bitte geben Sie einen Dokumenttitel ein",
    enterToolName: "Bitte geben Sie einen Tool-Namen ein",
    confirmApproveTransaction: "Möchten Sie diese Transaktion genehmigen?",
    failedToApproveTransaction: "Transaktion konnte nicht genehmigt werden. Bitte versuchen Sie es später erneut.",
    failedToFetchTransactions: "Transaktionen konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut."
  },
  approvals: {
    title: "Genehmigungen",
    description: "Genehmigungen für Transaktionen und Anträge verwalten",
    rejectReasonOptional: "Ablehnungsgrund (optional):",
    enterRejectionReason: "Bitte geben Sie einen Ablehnungsgrund ein:",
    rejectionReasonLabel: "Ablehnungsgrund:",
    confirmApproveTransaction: "Möchten Sie diese Transaktion genehmigen?",
    failedToApproveTransaction: "Transaktion konnte nicht genehmigt werden. Bitte versuchen Sie es später erneut.",
    failedToFetchTransactions: "Transaktionen konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
    rejectReasonForMultipleTransactions: "Ablehnungsgrund für",
    transactions: "Transaktion",
    rejectionReasonOptionalForMultiple: "(optional):"
  },
  common: {
    clearCacheConfirm: "Möchten Sie gespeicherte Daten löschen und die Seite neu laden?\nDadurch werden temporäre Daten gelöscht.\nSie müssen sich erneut anmelden.",
    clearCacheError: "Beim Löschen des Caches ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    clearCacheSuccess: "Cache erfolgreich gelöscht",
    aiGreeting: "Bitte begrüßen Sie sie und teilen Sie ihnen mit, dass Sie eine von Hamdy Mohamed programmierte KI sind.",
    unknown: "Unbekannt",
    notSpecified: "Nicht angegeben",
    loading: "Wird geladen...",
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    close: "Schließen",
    deletedUndo: "Gelöscht",
    undoSuccessful: "Rückgängig erfolgreich",
    undo: "Rückgängig",
    warning: "Warnung",
    info: "Info",
    all: "Alle",
    create: "Erstellen",
    update: "Aktualisieren",
    search: "Suchen",
    searchPlaceholder: "In Einstellungen oder Abteilungen suchen...",
    saving: "Wird gespeichert...",
    other: "Sonstiges",
    retry: "Erneut versuchen",
    reloadPage: "Seite neu laden",
    pageNotFoundTitle: "404 - Seite nicht gefunden",
    pageNotFoundMessage: "Die gesuchte Seite existiert leider nicht.",
    login: "Anmelden",
    user: "Benutzer",
    amount: "Betrag",
    amountMustBePositive: "{label} muss eine positive Zahl sein",
    amountMustNotExceed: "{label} darf {max} nicht überschreiten",
    emptyData: "Keine Daten verfügbar",
    emptyDataMessage: "Derzeit sind keine Daten zur Anzeige verfügbar",
    loadingData: "Daten werden geladen...",
    orgNotFound: "Organisation nicht gefunden. Bitte kontaktieren Sie den Support.",
    routeNotFound: "Seite nicht gefunden",
    now: "Gerade eben",
    agoDay: "vor {n} Tag",
    agoDays: "vor {n} Tagen",
    agoHour: "vor {n} Stunde",
    agoHours: "vor {n} Stunden",
    agoMinute: "vor {n} Minute",
    agoMinutes: "vor {n} Minuten",
    pause: "Pause",
    resume: "Fortsetzen",
    previous: "Zurück",
    next: "Weiter",
    read: "Gelesen",
    unread: "Ungelesen"
  },
  errorBoundary: {
    connectionIssue: "Verbindungsproblem",
    sessionExpired: "Sitzung abgelaufen",
    somethingWentWrong: "Etwas ist schiefgelaufen",
    chunkError: "Die Seite konnte nach einem Update nicht geladen werden. Cache leeren oder einmal neu laden.",
    networkError: "Keine Verbindung zum Server. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    authError: "Ihre Anmeldesitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    unexpectedError: "Entschuldigung, ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    errorDetails: "Fehlerdetails (nur Entwicklung)"
  },
  layout: {
    supportSessionActive: "Aktive Support-Sitzung",
    supportSessionBy: " (von {name})",
    supportSessionSuffix: " — Sie sehen das System als der ausgewählte Benutzer.",
    supportSessionEnd: "Support-Sitzung beenden"
  },
  supportSession: {
    invalidLinkNoToken: "Ungültiger Sitzungslink (kein Token).",
    invalidLinkMissingToken: "Ungültiger Sitzungslink (Token fehlt).",
    invalidToken: "Ungültiges Token.",
    sessionExpired: "Dieser Sitzungslink ist abgelaufen. Fordern Sie eine neue Identitätsübernahme über das Admin-Panel an.",
    notSupportSession: "Dieser Link ist keine Support-Sitzung.",
    invalidOrgId: "Ungültige Organisations-ID im Support-Link.",
    invalidTenantId: "Ungültige Mandanten-ID im Support-Link.",
    openFailed: "Support-Sitzung konnte nicht geöffnet werden. Versuchen Sie es erneut über das Admin-Panel.",
    title: "Sitzung konnte nicht geöffnet werden",
    opening: "Support-Sitzung wird geöffnet…",
    confirmTitle: "Support-Sitzung starten?",
    confirmBody: "Sie sehen die App anschließend als der ausgewählte Benutzer. Fahren Sie nur fort, wenn Sie das im Admin-Panel angefordert haben.",
    confirmReplaceWarning: "Dadurch wird Ihre aktuelle Anmeldung in diesem Browser ersetzt.",
    startSession: "Support-Sitzung starten",
    cancel: "Abbrechen"
  },
  infoPop: {
    title: "Spannende neue Funktion!",
    description: "Entdecken Sie die neue Funktion, die Ihr Erlebnis mit uns verändern wird",
    actionText: "Jetzt ausprobieren"
  },
  updates: {
    newUpdate: "Neues Update",
    close: "Schließen",
    pause: "Pause",
    resume: "Fortsetzen",
    pauseTitle: "Pause (Leertaste)",
    resumeTitle: "Fortsetzen (Leertaste)",
    clickToPause: "Klicken zum Pausieren (oder Leertaste)",
    clickToResume: "Klicken zum Fortsetzen (oder Leertaste)",
    previous: "Zurück",
    next: "Weiter",
    read: "Gelesen",
    unread: "Ungelesen",
    noText: "Kein Update-Text",
    video: "Video"
  },
  chat: {
    title: "Chat",
    mobileTitle: "Chat",
    searchPlaceholder: "Suchen...",
    noConversations: "Keine Unterhaltungen",
    noMessages: "Noch keine Nachrichten. Beginnen Sie die Unterhaltung!",
    noMessagesPlaceholder: "Keine Nachrichten",
    selectConversation: "Wählen Sie eine Unterhaltung aus",
    typeMessage: "Nachricht eingeben...",
    attachFile: "Datei anhängen",
    attachImage: "Bild anhängen",
    addEmoji: "Emoji hinzufügen",
    sendMessage: "Nachricht senden",
    openConversations: "Unterhaltungsliste öffnen",
    now: "Jetzt",
    minutesAgo: "vor",
    minute: "Minute",
    employee: "Mitarbeiter",
    department: "Abteilung",
    minutes: "Minuten",
    startConversation: "Beginnen Sie die Unterhaltung mit Ihrem Team",
    members: "Mitglied",
    groupChat: "Gruppenchat",
    groups: "Abteilungen",
    selectGroup: "Wählen Sie eine Abteilung aus",
    deleteMessageConfirm: "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
    delete: "Löschen",
    cancel: "Abbrechen",
    deleteSuccess: "Nachricht erfolgreich gelöscht",
    fetchGroupsFailed: "Gruppen konnten nicht abgerufen werden",
    fetchMessagesFailed: "Nachrichten konnten nicht abgerufen werden",
    sendMessageFailed: "Nachricht konnte nicht gesendet werden",
    deleteMessageFailed: "Nachricht konnte nicht gelöscht werden",
    unnamedGroup: "Unbenannte Gruppe",
    today: "Heute",
    yesterday: "Gestern",
    connected: "Verbunden",
    disconnected: "Getrennt",
    you: "Du",
    welcomeGeneral: "Willkommen im allgemeinen Chat!",
    welcomeDepartment: "Willkommen im Chat von {name}!",
    welcomeSubtitle: "Beginnen Sie die Unterhaltung mit Ihrem Team. Senden Sie eine Nachricht, um zu starten!",
    minuteShort: "Min",
    reply: "Antworten",
    replyingTo: "Antwort an",
    cancelReply: "Antwort abbrechen",
    react: "Reagieren",
    pin: "Anheften",
    unpin: "Loslösen",
    pinnedMessages: "Angeheftete Nachrichten",
    pinnedMessage: "Angeheftete Nachricht",
    searchMessages: "Nachrichten suchen",
    searchMessagesPlaceholder: "Nachrichten suchen...",
    noSearchResults: "Keine Ergebnisse",
    pinSuccess: "Nachricht angeheftet",
    unpinSuccess: "Anheftung aufgehoben",
    pinFailed: "Anheften fehlgeschlagen",
    pinUnauthorized: "Nur Admins und Teamleiter können Nachrichten anheften.",
    pinLimitReached: "Du kannst nur bis zu 5 Nachrichten anheften. Löse zuerst eine Anheftung.",
    reactionFailed: "Reaktion fehlgeschlagen",
    searchFailed: "Suche fehlgeschlagen"
  },
  sidebar: {
    title: "HR-System",
    expand: "Erweitern",
    collapse: "Zusammenklappen",
    settings: "Einstellungen",
    mainMenu: "Hauptmenü",
    hrSystem: "Personalverwaltungssystem",
    version: "Version 1.0.0",
    dashboard: "Dashboard",
    employees: "Mitarbeiter",
    payroll: "Gehaltsabrechnung",
    salary: "Gehalt",
    holidays: "Urlaub",
    permissions: "Berechtigungen",
    company: "Unternehmen",
    reports: "Berichte",
    attendance: "Anwesenheit",
    tasks: "Aufgabenverwaltung",
    chat: "Chat",
    documents: "Meine Dokumente",
    myProfile: "Mein Profil",
    employeesList: "Mitarbeiterverzeichnis",
    home: "Startseite",
    connected: "Verbunden",
    searchPlaceholder: "Im System suchen...",
    notifications: "Benachrichtigungen",
    newNotification: "neue Benachrichtigung",
    viewUpdates: "Updates anzeigen",
    viewUpdate: "Anzeigen",
    newUpdate: "neues Update",
    companyCode: "Firmencode",
    roles: {
      employee: "Mitarbeiter",
      admin: "Administrator",
      teamLeader: "Teamleiter",
      user: "Benutzer"
    }
  },
  topHeader: {
    searchPlaceholder: "Im System suchen...",
    assistBar: {
      ask: "Fragen",
      askHint: "Fragen Sie, wo etwas im System ist",
      jump: "Schnellsprung",
      jumpHint: "Schnelle Navigationsliste öffnen"
    },
    toggleLightMode: "Zum hellen Modus wechseln",
    toggleDarkMode: "Zum dunklen Modus wechseln",
    changeLanguage: "Sprache ändern",
    notifications: "Benachrichtigungen",
    notificationsPanel: "Benachrichtigungsbereich",
    loading: "Wird geladen...",
    loadError: "Ladefehler",
    noNotifications: "Keine Benachrichtigungen anzuzeigen",
    loadingNotifications: "Benachrichtigungen werden geladen...",
    loadingMore: "Wird geladen...",
    loadMore: "Weitere Benachrichtigungen laden",
    seeMore: "Mehr anzeigen",
    seeLess: "Weniger anzeigen",
    allRead: "Alle Benachrichtigungen gelesen",
    justNow: "Gerade eben",
    unreadNotification: "ungelesene Benachrichtigung",
    total: "Gesamt",
    notificationCount: "Anzahl der Benachrichtigungen:",
    decreaseCount: "Benachrichtigungen pro Seite verringern",
    increaseCount: "Benachrichtigungen pro Seite erhöhen",
    countPerPage: "Anzahl der Benachrichtigungen pro Seite",
    markAllAsRead: "Alle als gelesen markieren",
    deleteAll: "Alle löschen",
    closeWindow: "Fenster schließen",
    noNotificationsTitle: "Keine Benachrichtigungen",
    noNotificationsMessage: "Sie werden benachrichtigt, wenn neue Benachrichtigungen eintreffen.",
    notificationWithoutTitle: "Benachrichtigung ohne Titel",
    noNotificationText: "Kein Benachrichtigungstext",
    unreadNotificationLabel: "Ungelesene Benachrichtigung",
    notificationLabel: "Benachrichtigung:",
    fetchFailed: "Benachrichtigungen konnten nicht abgerufen werden",
    fetchError: "Beim Abrufen der Benachrichtigungen ist ein Fehler aufgetreten",
    fetchNewFailed: "Neue Benachrichtigungen konnten nicht abgerufen werden. Wiederholung...",
    markReadFailed: "Benachrichtigungsstatus konnte nicht aktualisiert werden",
    markAllReadFailed: "Benachrichtigungsstatus konnte nicht aktualisiert werden",
    deleteFailed: "Benachrichtigung konnte nicht gelöscht werden",
    deleteAllFailed: "Alle Benachrichtigungen konnten nicht gelöscht werden",
    unauthorized: "Nicht autorisiert, bitte Token überprüfen",
    noTitle: "Kein Titel",
    noMessage: "Keine Nachricht",
    read: "Gelesen",
    unread: "Ungelesen",
    markAsRead: "Als gelesen markieren",
    delete: "Löschen",
    viewAllNotifications: "Alle Benachrichtigungen anzeigen",
    userMenu: "Benutzermenü",
    profile: "Profil",
    settings: "Einstellungen",
    logout: "Abmelden",
    login: "Anmelden",
    user: "Benutzer",
    admin: "Systemadministrator",
    teamLeader: "Teamleiter",
    employee: "Mitarbeiter",
    newNotification: "Neue Benachrichtigung",
    youHaveNewNotification: "Sie haben eine neue Benachrichtigung",
    browserNotSupportNotifications: "Dieser Browser unterstützt keine Benachrichtigungen.",
    notificationPermissionDenied: "Benachrichtigungsberechtigung wurde verweigert. Bitte aktivieren Sie Benachrichtigungen in den Browsereinstellungen.",
    notificationPermissionError: "Beim Anfordern der Benachrichtigungsberechtigung ist ein Fehler aufgetreten.",
    searchPopup: {
      title: "TeamIN fragen",
      description: "Finden Sie jede Seite oder Funktion in wenigen Worten",
      placeholder: "Wonach suchen Sie?",
      closeHint: "zum Schließen",
      sendHint: "zum Senden",
      sending: "Wird gesucht...",
      fullScreen: "Vollbild",
      exitFullScreen: "Vollbild beenden",
      welcomeMessage: "Hallo! Fragen Sie mich, wo etwas ist — z. B. „Wo ist die Gehaltsabrechnung?“ oder „Firmeneinstellungen“",
      welcomeMessageEmployee: "Hallo! Fragen Sie mich, wo etwas ist — z. B. „Wo ist mein Gehalt?“ oder „Wie beantrage ich Urlaub?“",
      responseMessage: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      takeMeThere: "Bring mich dorthin",
      suggestion1: "Wo ist die Gehaltsabrechnung?",
      suggestion2: "Firmeneinstellungen",
      suggestion3: "Anwesenheitsberichte",
      suggestion1Employee: "Wo ist mein Gehalt?",
      suggestion2Employee: "Wie beantrage ich Urlaub?",
      suggestion3Employee: "Meine Dokumente"
    },
    report: {
      title: "Problem oder Vorschlag melden",
      description: "Wählen Sie den passenden Bereich und beschreiben Sie kurz das Problem. Wir prüfen es zeitnah.",
      subject: "Betreff",
      subjectPlaceholder: "z. B. Check-in wegen Standort fehlgeschlagen",
      category: "Worum geht es?",
      categoryHint: "Wählen Sie den nächsten Bereich, damit wir die Meldung richtig zuordnen.",
      categories: {
        attendance: "Anwesenheit & Check-in",
        notifications: "Benachrichtigungen",
        payroll: "Gehalt & Gehaltsabrechnung",
        leaves_permissions: "Urlaub & Genehmigungen",
        tasks_chat: "Aufgaben & Chat",
        account_login: "Login, Konto & Gerät",
        suggestion: "Verbesserungsvorschlag",
        other: "Etwas anderes",
        technical: "Technisch",
        billing: "Abrechnung",
        account: "Konto",
        feature_request: "Funktionsanfrage"
      },
      descriptionLabel: "Beschreibung",
      placeholder: "Was ist passiert, wann, und welche Fehlermeldung erschien...",
      submit: "Senden",
      cancel: "Abbrechen",
      close: "Schließen",
      sending: "Wird gesendet...",
      thankYou: "Vielen Dank. Ihre Nachricht wurde erfolgreich empfangen.",
      errorSending: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
    }
  },
  forgetPassword: {
    title: "Passwort zurücksetzen",
    titleStep2: "Code und neues Passwort eingeben",
    description: "Geben Sie Ihre E-Mail-Adresse ein, um einen Rücksetzcode zu erhalten",
    descriptionStep2: "Geben Sie den an Ihre E-Mail gesendeten Code und Ihr neues Passwort ein",
    email: "E-Mail",
    emailPlaceholder: "Ihre E-Mail-Adresse eingeben",
    code: "Verifizierungscode",
    codePlaceholder: "Verifizierungscode eingeben",
    newPassword: "Neues Passwort",
    newPasswordPlaceholder: "Neues Passwort eingeben",
    sendCode: "Verifizierungscode senden",
    sending: "Wird gesendet...",
    resetPassword: "Passwort zurücksetzen",
    resetting: "Wird zurückgesetzt...",
    backToLogin: "Zurück zum Login",
    codeSent: "Rücksetzcode wurde an Ihre E-Mail gesendet",
    resetSuccess: "Passwort wurde erfolgreich zurückgesetzt",
    sendError: "Beim Senden des Codes ist ein Fehler aufgetreten",
    resetError: "Beim Zurücksetzen des Passworts ist ein Fehler aufgetreten",
    passwordTooShort: "Passwort ist erforderlich",
    validationCodeLength: "Geben Sie den 6-stelligen Bestätigungscode ein"
  },
  deleteAccount: {
    title: "Konto löschen",
    description:
      "Fordern Sie die dauerhafte Löschung Ihres TeamIN-Kontos und der zugehörigen personenbezogenen Daten an. Diese Seite erfüllt die Google Play-Anforderungen zur Kontolöschung.",
    verifyHint: "Melden Sie sich mit E-Mail und Passwort an, um Ihre Identität vor der Löschung zu bestätigen.",
    continue: "Weiter",
    verifying: "Wird überprüft...",
    confirmDescription: "Bestätigen Sie, dass Sie dieses Konto und seine Daten dauerhaft löschen möchten.",
    accountLabel: "Konto",
    confirmCheckbox:
      "Ich verstehe, dass das Löschen meines Kontos mein Profil, meine E-Mail und zugehörige Daten dauerhaft entfernt und nicht rückgängig gemacht werden kann.",
    confirmCheckboxRequired: "Bitte bestätigen Sie, dass Sie die Unwiderruflichkeit verstehen.",
    deleteButton: "Mein Konto löschen",
    deleting: "Wird gelöscht...",
    back: "Zurück",
    backHome: "Zur Startseite",
    failed: "Konto konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    doneTitle: "Konto gelöscht",
    doneDescription: "Ihr Konto und die zugehörigen personenbezogenen Daten wurden gelöscht.",
    doneNote: "Sie können diese Seite schließen. Bei Nutzung der App melden Sie sich ab oder deinstallieren Sie sie bei Bedarf.",
    warningTitle: "Diese Aktion ist dauerhaft",
    warningItem1: "Ihre Anmeldedaten und Profilinformationen werden entfernt.",
    warningItem2: "Personenbezogene Daten Ihres Benutzerkontos werden aus unseren Systemen gelöscht.",
    warningItem3: "Sie können sich mit diesem Konto nicht mehr anmelden.",
    appHint: "Sie können Ihr Konto auch in den Einstellungen der TeamIN-App löschen. Lesen Sie unsere",
  },
  login: {
    admin: "Administrator",
    employee: "Mitarbeiter",
    teamLeader: "Teamleiter",
    superAdmin: "Superadministrator",
    expired: "Abgelaufen",
    sessionExpired: "Sitzung abgelaufen, bitte melden Sie sich erneut an",
    invalidToken: "Kein gültiges Token zurückgegeben",
    error: "Bei der Anmeldung ist ein Fehler aufgetreten",
    toggleTheme: "Design umschalten",
    switchToLight: "Zum hellen Modus wechseln",
    switchToDark: "Zum dunklen Modus wechseln",
    title: "Anmelden",
    subtitle: "Geben Sie Ihre Zugangsdaten ein, um auf Ihr Konto zuzugreifen",
    username: "E-Mail",
    usernamePlaceholder: "E-Mail-Adresse eingeben",
    password: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    forgotPassword: "Passwort vergessen?",
    submitting: "Wird angemeldet...",
    submit: "Anmelden",
    noAccount: "Noch kein Konto?",
    createAccountAlert: "Sie müssen die Teamin-App aus dem Store installieren, um ein neues Konto zu erstellen",
    createAccount: "Konto erstellen",
    copyright: "Alle Rechte vorbehalten.",
    privacyPolicy: "Datenschutzerklärung",
    selectOrg: "Organisation auswählen",
    selectOrgDesc: "Sie haben Konten in mehreren Organisationen. Bitte wählen Sie die Organisation aus, bei der Sie sich anmelden möchten",
    rateLimitExceeded: "Sie haben sich zu oft angemeldet. Bitte warten Sie kurz und versuchen Sie es erneut.",
    deviceNotRegistered: "Dieses Gerät ist nicht für Ihr Konto registriert. Bitte kontaktieren Sie einen Administrator zur Freischaltung.",
    accountLocked: "Die Anmeldung wurde wegen mehrerer fehlgeschlagener Versuche vorübergehend gesperrt. Bitte versuchen Sie es in wenigen Minuten erneut.",
    heroTitle: "Personalverwaltungssystem",
    heroSubtitle: "Eine umfassende Plattform zur Verwaltung von Mitarbeitern, Gehalt und Finanzprozessen",
    features: {
      employees: {
        title: "Mitarbeiterverwaltung",
        description: "Mitarbeiterdaten einfach hinzufügen und bearbeiten"
      },
      payroll: {
        title: "Gehaltsverwaltung",
        description: "Gehälter und Zulagen berechnen und verfolgen"
      },
      reports: {
        title: "Finanzberichte",
        description: "Umfassende Berichte zum Finanzstatus"
      },
      attendance: {
        title: "Anwesenheitsverwaltung",
        description: "Anwesenheit und Abwesenheit der Mitarbeiter verfolgen"
      }
    }
  },
  landing: {
    footer: {
      allRightsReserved: "Alle Rechte vorbehalten.",
      portfolio: "Portfolio"
    },
    marquee: {
      label: "Vertraut von Teams weltweit"
    }
  },
  smartSearch: {
    placeholder: "Tippen zum schnellen Navigieren...",
    close: "Schließen",
    navigate: "Navigieren",
    select: "Auswählen",
    noResults: "Keine Ergebnisse",
    noResultsDescription: "Versuchen Sie andere Suchbegriffe",
    selected: "Ausgewählt",
    footer: {
      assistant: "Schnellnavigation · Anleitungen · UI-Texte · Ctrl/⌘ K",
      results: "Ergebnisse"
    },
    categories: {
      route: "Seiten",
      guide: "Anleitungen",
      i18n: "Aus Oberflächenbeschriftungen"
    },
    routes: {
      dashboard: "Dashboard",
      "dashboard.description": "Systemübersicht anzeigen",
      employees: "Mitarbeiter",
      "employees.description": "Mitarbeiter verwalten",
      payroll: "Gehaltsabrechnung",
      "payroll.description": "Gehaltsabrechnung verwalten",
      settings: "Einstellungen",
      "settings.description": "Systemeinstellungen",
      "system-logs": "Systemprotokolle",
      "system-logs.description": "Systemaktivitätsprotokolle anzeigen",
      reports: "Berichte",
      "reports.description": "Berichte und Analysen anzeigen",
      company: "Unternehmen",
      "company.description": "Unternehmensinformationen und Filialen",
      notifications: "Benachrichtigungen",
      "notifications.description": "Alle Benachrichtigungen anzeigen",
      tasks: "Aufgaben",
      "tasks.description": "Aufgaben und Projekte verwalten",
      chat: "Chat",
      "chat.description": "Teamnachrichten",
      attendance: "Anwesenheit",
      "attendance.description": "Anwesenheitsaufzeichnungen",
      holidays: "Feiertage",
      "holidays.description": "Urlaubsanträge und Status",
      permissions: "Berechtigungen",
      "permissions.description": "Rollen und Berechtigungen verwalten",
      "employees-list": "Mitarbeiterverzeichnis",
      "employees-list.description": "Mitarbeiterverzeichnis durchsuchen",
      salary: "Gehalt",
      "salary.description": "Gehaltsinformationen anzeigen",
      me: "Mein Profil",
      "me.description": "Ihr persönliches Profil",
      overview: "Übersicht",
      "overview.description": "Profilübersicht",
      "desktop-tracking": "Desktop-Tracking",
      "desktop-tracking.description": "Desktop-Aktivitätsverfolgung",
      Msg: "Nachrichten",
      "Msg.description": "Ihre Nachrichten",
      performance: "Leistung",
      "performance.description": "Leistungsbewertung",
      myDocument: "Meine Dokumente",
      "myDocument.description": "Ihre Dokumente und Dateien",
      requests: "Anfragen",
      "requests.description": "Ihre Anfragen"
    },
    help: {
      dashboard: {
        title: "Dashboard",
        description: "Systemübersicht anzeigen"
      },
      employees: {
        title: "Mitarbeiter",
        description: "Mitarbeiter verwalten"
      },
      attendance: {
        title: "Anwesenheit",
        description: "Anwesenheitserfassung"
      },
      payroll: {
        title: "Gehaltsabrechnung",
        description: "Gehaltsabrechnung verwalten"
      }
    }
  },
  hero: {
    badge: "Komplette HR-Management-Lösung",
    title: "TeamIN",
    subtitle: "HR-System",
    description: "HR-Management in Ihrer Tasche – Von Mitarbeitern bis Admins",
    joinWaitingList: "Warteliste beitreten",
    learnMore: "Mehr erfahren",
    poweredBy: "Das System wird von KI unterstützt",
    downloadApp: "App herunterladen",
    appStore: "App Store",
    googlePlay: "Google Play",
    downloadOn: "Laden im",
    getItOn: "Jetzt bei",
    secureEncrypted: "Sicher & verschlüsselt",
    cloudBased: "Vollständig cloudbasiert",
    aiPowered: "KI-gestützt"
  },
  features: {
    title: "Funktionen",
    subtitle: "Komplette HR-Management-Lösung für Mitarbeiter und Administratoren.",
    eyebrow: "Ein wachsendes System für",
    bentoSubtitle: "Die Module, die Teams wirklich nutzen — Anwesenheit, Gehalt, Chat und mehr an einem Ort.",
    stats: {
      modules: "Anwesenheit & Gehalt",
      platforms: "Chat & Aufgaben",
      featuresCount: "in einem System"
    },
    allFeatures: "Hauptfunktionen",
    categories: {
      employeeManagement: "Mitarbeiterverwaltung",
      attendance: "Anwesenheit & Zeiterfassung",
      payroll: "Gehaltsabrechnung & Finanzen",
      communication: "Kommunikation & Zusammenarbeit",
      tasks: "Aufgaben & Projekte",
      reports: "Berichte & Analysen",
      admin: "Verwaltung & Einstellungen"
    },
    employeeManagement: {
      title: "Mitarbeiterverwaltung",
      description: "Umfassende Mitarbeiterdatenverwaltung"
    },
    teamLeader: {
      title: "Teamleiter",
      description: "Team- und Projektmanagement"
    },
    documents: {
      title: "Dokumente",
      description: "Dokumenten- und Dateiverwaltung"
    },
    performance: {
      title: "Leistung",
      description: "Mitarbeiterleistungsbewertung"
    },
    companyManagement: {
      title: "Unternehmensverwaltung",
      description: "Unternehmens- und Filialdatenverwaltung"
    },
    clientsManagement: {
      title: "Kundenverwaltung",
      description: "Kundendatenverwaltung"
    },
    checkInOut: {
      title: "Ein-/Auschecken",
      description: "Erweitertes Ein-/Auschecksystem"
    },
    deviceBinding: {
      title: "Gerätebindung",
      description: "Sichere Gerätebindung"
    },
    timeAttendance: {
      title: "Zeiterfassung",
      description: "Präzise Anwesenheitsverfolgung"
    },
    payslip: {
      title: "Gehaltsabrechnung",
      description: "Gehaltsabrechnungen generieren"
    },
    payrollManagement: {
      title: "Gehaltsabrechnungsverwaltung",
      description: "Gehaltsabrechnung berechnen und verwalten"
    },
    transactions: {
      title: "Transaktionen",
      description: "Finanztransaktionen verfolgen"
    },
    groupChat: {
      title: "Gruppenchat",
      description: "Kommunikation mit Ihrem Team"
    },
    realtimeChat: {
      title: "Echtzeit-Chat",
      description: "Sofortige Nachrichten mit Mitarbeitern"
    },
    aiChatbot: {
      title: "KI-Chatbot",
      description: "Intelligenter Assistent zur Beantwortung von Fragen"
    },
    notifications: {
      title: "Benachrichtigungen",
      description: "Erweitertes Benachrichtigungssystem"
    },
    tasksManagement: {
      title: "Aufgabenverwaltung",
      description: "Aufgaben erstellen und verfolgen"
    },
    advancedAnalytics: {
      title: "Erweiterte Analysen",
      description: "Umfassende Datenanalysen"
    },
    reportsAnalytics: {
      title: "Berichte und Analysen",
      description: "Detaillierte Berichte und Statistiken"
    },
    adminDashboard: {
      title: "Admin-Dashboard",
      description: "Umfassendes Admin-Dashboard"
    },
    holidaysManagement: {
      title: "Urlaubsverwaltung",
      description: "Urlaube und Anträge verwalten"
    },
    approvals: {
      title: "Genehmigungen",
      description: "Genehmigungs- und Autorisierungssystem"
    },
    categoriesManagement: {
      title: "Kategorienverwaltung",
      description: "Unternehmensabteilungen verwalten"
    },
    desktopTracking: {
      title: "Desktop-Verfolgung",
      description: "Mitarbeiteraktivität verfolgen"
    },
    mobileApp: {
      title: "Mobile App",
      description: "Mobile Anwendung"
    }
  },
  benefits: {
    title: "Warum wählen Sie",
    titleTeamIN: "TeamIN",
    titleQuestion: "?",
    eyebrow: "Warum Teams wechseln",
    description: "Das umfassende HR-Managementsystem, das alles vereint, was Sie benötigen, um Ihre Belegschaft effizient und effektiv zu verwalten.",
    getStarted: "Jetzt starten",
    benefit1: "Umfassende Mitarbeiterverwaltung von der Einstellung bis zur Rente",
    benefit2: "Echtzeit-Anwesenheitsverfolgung mit Standorttracking",
    benefit3: "Automatisierte Gehaltsberechnung mit Boni und Abzügen",
    benefit4: "Nahtlose Kommunikation über Gruppenchat",
    benefit5: "Detaillierte Berichte und Analysen für fundierte Entscheidungen",
    benefit6: "Hohe Sicherheit mit Gerätebindung und Datenschutz",
    benefit7: "Fortschrittliche KI für Datenanalysen und intelligente Prognosen",
    chat: {
      groupName: "HR-Team",
      online: "12 online",
      members: "24 Mitglieder",
      typing: "Sara tippt...",
      placeholder: "Nachricht schreiben...",
      avatarInitials: "SA"
    },
    aiPowered: "KI-gestützt"
  },
  contact: {
    title: "Treten Sie der",
    waitingList: "Warteliste bei",
    eyebrow: "Frühzugang sichern",
    description: "Gehören Sie zu den Ersten, die TeamIN HR System erhalten. Registrieren Sie Ihre E-Mail und wir benachrichtigen Sie, wenn wir bereit sind!",
    contactUs: "Kontaktieren Sie uns",
    viewPortfolio: "Portfolio anzeigen"
  },
  privacy: {
    title: "Datenschutzerklärung",
    paragraph1: "Wir verpflichten uns, Ihre Privatsphäre zu schützen. Ihre persönlichen Daten werden nicht an Dritte weitergegeben.",
    paragraph2: "Wenn Sie Fragen zu unserer Datenschutzerklärung haben, kontaktieren Sie uns bitte unter",
    close: "Schließen",
    readFull: "Vollständige Datenschutzerklärung lesen"
  },
  form: {
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "Geben Sie Ihre E-Mail ein",
    phoneLabel: "Telefonnummer",
    phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
    categoryLabel: "Unternehmenskategorie",
    categoryPlaceholder: "Unternehmenskategorie auswählen",
    success: "Erfolgreich registriert! Wir werden Sie bald kontaktieren.",
    viewPortfolio: "Anzeigen",
    back: "Zurück",
    next: "Weiter",
    joining: "Wird beigetreten...",
    joinWaitingList: "Warteliste beitreten",
    privacyPolicy: "Datenschutzerklärung"
  },
  capabilities: {
    title: "Systemfähigkeiten",
    subtitle: "Ein leistungsstarkes und flexibles System, das mit Ihrem Unternehmen wächst",
    eyebrow: "Gebaut zum Wachsen",
    scrollHint: "Scrollen zum Erkunden",
    multiPlatform: {
      title: "Multi-Plattform",
      description: "Funktioniert auf Android, iOS und Web – voller Zugriff von jedem Gerät"
    },
    realTimeSync: {
      title: "Echtzeitsynchronisation",
      description: "Sofortige Synchronisation aller Daten über alle Geräte"
    },
    secure: {
      title: "Sicher & geschützt",
      description: "Erweiterter Schutz Ihrer Daten mit starker Verschlüsselung"
    },
    scalable: {
      title: "Skalierbar",
      description: "Wächst mit Ihrem Unternehmen vom Kleinunternehmen bis zum Großkonzern"
    },
    customizable: {
      title: "Anpassbar",
      description: "Passen Sie das System an die einzigartigen Bedürfnisse Ihres Unternehmens an",
      modules: {
        attendance: "Anwesenheit",
        chat: "Chat",
        tasks: "Aufgaben",
        reports: "Berichte"
      }
    },
    support: {
      title: "Technischer Support",
      description: "Ein engagiertes Support-Team steht Ihnen jederzeit zur Verfügung"
    },
    platforms: {
      androidIos: {
        title: "Mobile Apps",
        description: "Native Apps für Android und iOS"
      },
      webDashboard: {
        title: "Web-Dashboard",
        description: "Leistungsstarkes Dashboard für Administratoren"
      },
      realTimeSync: {
        title: "Echtzeitsynchronisation",
        description: "Echtzeit-Sync über alle Plattformen"
      }
    }
  },
  screenshots: {
    title: "TeamIN in Aktion sehen",
    subtitle: "Entdecken Sie unser System anhand echter Screenshots der mobilen App und des Web-Dashboards",
    mobile: "Mobile App",
    web: "Web-Dashboard",
    viewFullSize: "In voller Größe anzeigen",
    items: {
      mobileDashboard: {
        title: "Mobiles Dashboard",
        description: "Schönes und intuitives mobiles Dashboard für Mitarbeiter"
      },
      mobileAttendance: {
        title: "Ein-/Auschecken",
        description: "Einfaches Ein- und Auschecken mit Standortverfolgung"
      },
      mobileTasks: {
        title: "Aufgabenverwaltung",
        description: "Aufgaben unterwegs verwalten und verfolgen"
      },
      mobileChat: {
        title: "Team-Chat",
        description: "Echtzeit-Nachrichten mit Ihrem Team"
      },
      mobilePayslip: {
        title: "Digitaler Gehaltszettel",
        description: "Monatliche Gehaltsabrechnungen anzeigen und herunterladen"
      },
      adminDashboard: {
        title: "Admin-Dashboard",
        description: "Umfassendes Admin-Dashboard mit Analysen"
      },
      employeeManagement: {
        title: "Mitarbeiterverwaltung",
        description: "Vollständiges Mitarbeiterverwaltungssystem"
      },
      payrollManagement: {
        title: "Gehaltsabrechnungsverwaltung",
        description: "Automatisierte Gehaltsberechnung und -verwaltung"
      },
      attendanceTracking: {
        title: "Anwesenheitsverfolgung",
        description: "Echtzeit-Anwesenheitsüberwachung und Berichte"
      },
      reportsAnalytics: {
        title: "Berichte & Analysen",
        description: "Umfassendes Berichts- und Analysedashboard"
      }
    },
    placeholder: "Screenshot-Platzhalter",
    placeholderHint: "Screenshot-Platzhalter – echte Screenshots hinzufügen"
  },
  tasks: {
    title: "Aufgabenverwaltung",
    description: "Aufgaben verwalten und verfolgen",
    addTask: "Aufgabe hinzufügen",
    addTaskButton: "Hinzufügen",
    taskTitle: "Aufgabentitel",
    enterTaskTitle: "Aufgabentitel eingeben",
    enterTaskTitleRequired: "Bitte geben Sie einen Aufgabentitel ein",
    taskDescription: "Aufgabenbeschreibung",
    enterTaskDescription: "Aufgabenbeschreibung eingeben",
    assignType: "Zuweisungstyp",
    singleEmployee: "Einzelner Mitarbeiter",
    fullTeam: "Ganze Abteilung",
    selectEmployee: "Mitarbeiter auswählen",
    selectEmployeeRequired: "Bitte wählen Sie einen Mitarbeiter aus",
    selectEmployeePlaceholder: "Mitarbeiter auswählen...",
    selectTeam: "Abteilung auswählen",
    selectTeamPlaceholder: "Abteilung auswählen...",
    selectTeamRequired: "Bitte wählen Sie eine Abteilung aus",
    deadline: "Frist",
    selectDeadlineRequired: "Bitte wählen Sie eine Frist aus",
    deadlineLabel: "Frist",
    priority: "Priorität",
    high: "Hoch",
    medium: "Mittel",
    low: "Niedrig",
    allPriorities: "Alle Prioritäten",
    status: "Status",
    pending: "Ausstehend",
    inProgress: "In Bearbeitung",
    completed: "Abgeschlossen",
    cancelled: "Storniert",
    allStatuses: "Alle Status",
    employee: "Mitarbeiter",
    team: "Abteilung",
    expired: "Abgelaufen",
    createdAt: "Erstellt am",
    completedAt: "Abgeschlossen am",
    updates: "Aktualisierungen",
    viewDetails: "Details anzeigen",
    taskDetails: "Aufgabendetails",
    task: "Aufgabe",
    noTasks: "Keine Aufgaben",
    noTasksDesc: "Beginnen Sie, indem Sie eine neue Aufgabe hinzufügen",
    loading: "Wird geladen...",
    search: "Suchen",
    searchPlaceholder: "In Titel und Beschreibung suchen...",
    clearFilters: "Filter löschen",
    updateMessage: "Update-Nachricht",
    enterUpdateMessage: "Update-Nachricht eingeben...",
    addUpdate: "Update hinzufügen",
    editTask: "Aufgabe bearbeiten",
    edit: "Bearbeiten",
    delete: "Löschen",
    deleteTaskConfirm: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
    markDone: "Als erledigt markieren",
    markPending: "Als ausstehend markieren",
    cannotUpdateCompleted: "Für abgeschlossene Aufgaben können keine Updates hinzugefügt werden",
    notSpecified: "Nicht angegeben",
    untitled: "Unbenannte Aufgabe",
    requestExtension: "Zeitverlängerung beantragen",
    extensionReason: "Verlängerungsgrund",
    extensionReasonPlaceholder: "Grund für die Zeitverlängerung eingeben...",
    extensionRequests: "Verlängerungsanträge",
    extensionRequestsDesc: "Zeitverlängerungsanträge von Mitarbeitern prüfen und beantworten",
    requestMessage: "Antragsnachricht",
    responseMessage: "Antwortnachricht",
    respondedAt: "Antwortdatum",
    sendRequest: "Antrag senden",
    sendUpdate: "Senden",
    updateMessagePlaceholder: "Update oder Kommentar zur Aufgabe eingeben...",
    noExtensionRequests: "Keine Verlängerungsanträge",
    approve: "Genehmigen",
    reject: "Ablehnen",
    allTasks: "Alle Aufgaben",
    all: "Alle",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    refresh: "Aktualisieren",
    page: "Seite",
    of: "von",
    tasks: "Aufgaben",
    requests: "Anträge",
    previous: "Zurück",
    next: "Weiter",
    createSuccess: "Aufgabe erfolgreich erstellt",
    updateSuccess: "Aufgabe erfolgreich aktualisiert",
    deleteSuccess: "Aufgabe erfolgreich gelöscht",
    markDoneSuccess: "Aufgabe erfolgreich als erledigt markiert",
    extensionRequestSuccess: "Verlängerungsantrag erfolgreich gesendet",
    addUpdateSuccess: "Update erfolgreich hinzugefügt",
    approveExtensionSuccess: "Verlängerungsantrag erfolgreich genehmigt",
    rejectExtensionSuccess: "Verlängerungsantrag erfolgreich abgelehnt",
    errorFetchingEmployees: "Beim Abrufen der Mitarbeiter ist ein Fehler aufgetreten",
    errorFetchingTasks: "Beim Abrufen der Aufgaben ist ein Fehler aufgetreten",
    errorFetchingTaskDetails: "Beim Abrufen der Aufgabendetails ist ein Fehler aufgetreten",
    errorCreatingTask: "Beim Erstellen der Aufgabe ist ein Fehler aufgetreten",
    errorUpdatingTask: "Beim Aktualisieren der Aufgabe ist ein Fehler aufgetreten",
    errorDeletingTask: "Beim Löschen der Aufgabe ist ein Fehler aufgetreten",
    markDoneFailed: "Aufgabe konnte nicht als erledigt markiert werden",
    extensionRequestFailed: "Verlängerungsantrag konnte nicht gesendet werden",
    addUpdateFailed: "Update konnte nicht hinzugefügt werden",
    approveExtensionFailed: "Antrag konnte nicht genehmigt werden",
    rejectExtensionFailed: "Antrag konnte nicht abgelehnt werden",
    errorFetchingExtensionRequests: "Verlängerungsanträge konnten nicht abgerufen werden",
    extensionReasonRequired: "Bitte geben Sie einen Verlängerungsgrund ein",
    updateMessageRequired: "Bitte geben Sie ein Update oder einen Kommentar ein",
    department: "Abteilung",
    requestDate: "Antragsdatum"
  },
  payroll: {
    title: "Gehaltsabrechnungssystem",
    description: "Umfassende Gehaltsabrechnungsverwaltung",
    totalSalaries: "Gesamtgehälter",
    beforeDeductions: "Vor Abzügen und Boni",
    allBasicSalaries: "Alle Grundgehälter",
    beforeModifications: "Vor Änderungen",
    remainingSalaries: "Verbleibende Gehälter",
    afterDeductions: "Nach Abzügen und Boni",
    forDisplayedEmployees: "Für angezeigte Mitarbeiter",
    readyForPayment: "Bereit zur Zahlung",
    bonuses: "Boni",
    bonusesThisMonth: "Boni diesen Monat",
    totalBonuses: "Boni gesamt",
    forMonth: "Für",
    deductions: "Abzüge",
    deductionsThisMonth: "Abzüge diesen Monat",
    totalDeductions: "Abzüge gesamt",
    monthlySummary: "Monatliche Gehaltsübersicht",
    monthlySummaryDesc: "Gehaltsdetails für einen bestimmten Monat anzeigen",
    showSummary: "Übersicht anzeigen",
    hideSummary: "Übersicht ausblenden",
    backToEmployees: "Zurück zu Mitarbeitern",
    loading: "Daten werden geladen...",
    adjustments: "Anpassungen",
    adjustmentsDesc: "Teilzahlung (Vorschuss), Gehaltsanpassungen, Abzug, Bonus, Gehaltszahlung",
    stats: "Statistiken",
    statsDesc: "Detaillierte Gehaltsanalysen",
    categoryAdjustments: "Anpassungen",
    categoryAnalytics: "Analysen",
    tabs: {
      payments: "Zahlungen",
      adjustments: "Anpassungen (Boni/Abzüge)"
    },
    adjustmentsPage: {
      title: "Gehalts- und Anpassungsverwaltung",
      employeeLabel: "Mitarbeiter: {name}",
      viewDetails: "Details anzeigen",
      selectEmployee: "Bitte wählen Sie einen Mitarbeiter",
      fillRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
      fillRequiredAmount: "Bitte füllen Sie alle Pflichtfelder aus (Betrag muss größer als 0 sein)",
      fullPaymentTitle: "Vollständige Gehaltszahlung",
      partialPaymentTitle: "Teilzahlung (Vorschuss)",
      month: "Monat",
      monthPlaceholder: "YYYY-MM (z. B. 2025-01)",
      paymentMethod: "Zahlungsmethode",
      bankTransfer: "Banküberweisung",
      cash: "Bar",
      referenceNumberOptional: "Referenznummer (optional)",
      referenceNumber: "Referenznummer",
      notesOptional: "Notizen (optional)",
      notesPlaceholder: "Zusätzliche Notizen",
      earlyPayment: "Frühzeitige Zahlung",
      earlyPaymentReason: "Grund für frühzeitige Zahlung",
      earlyPaymentReasonPlaceholder: "Grund für frühzeitige Zahlung",
      confirmFullPayment: "Gehaltszahlung bestätigen",
      amountRequired: "Betrag *",
      amountPlaceholder: "Betrag eingeben",
      partialReasonRequired: "Grund der Teilzahlung *",
      partialReasonPlaceholder: "z. B. Notfallvorschuss",
      confirmPartialPayment: "Teilzahlung bestätigen",
      addBonus: "Bonus hinzufügen",
      addDeduction: "Abzug hinzufügen",
      adjustmentType: "Anpassungstyp",
      bonusOption: "Bonus (+)",
      deductionOption: "Abzug (-)",
      bonusTypeRequired: "Bonustyp *",
      deductionTypeRequired: "Abzugstyp *",
      bonusTypePlaceholder: "z. B. Arbeitsleistung",
      deductionTypePlaceholder: "z. B. Verspätung",
      amountMustBePositive: "Betrag * (muss größer als 0 sein)",
      descriptionRequired: "Beschreibung *",
      descriptionPlaceholder: "z. B. Bonus für Einsatz bei der Arbeit",
      submitBonus: "Bonus hinzufügen",
      submitDeduction: "Abzug hinzufügen",
      adjustmentSuccess: "Anpassung erfolgreich hinzugefügt",
      adjustmentFailed: "Anpassung konnte nicht hinzugefügt werden",
      adjustmentFailedWithError: "Anpassung fehlgeschlagen: {error}",
      paySuccess: "Gehalt erfolgreich ausgezahlt",
      payFailed: "Gehaltszahlung fehlgeschlagen",
      payFailedWithError: "Gehaltszahlung fehlgeschlagen: {error}",
      partialPaySuccess: "Teilzahlung erfolgreich abgeschlossen",
      partialPayFailed: "Teilzahlung fehlgeschlagen",
      fetchEmployeeFailed: "Mitarbeiterdaten konnten nicht geladen werden",
      fetchEmployeeFailedWithError: "Mitarbeiterdaten fehlgeschlagen: {error}",
      employeeDataTitle: "Mitarbeiterdaten: {name}",
      close: "Schließen",
      bonuses: "Boni",
      noBonuses: "Keine Boni",
      deductions: "Abzüge",
      noDeductions: "Keine Abzüge",
      monthlyPayments: "Monatliche Zahlungen",
      monthPrefix: "Monat: {month}",
      netSalary: "Nettogehalt: {amount}",
      paid: "Bezahlt: {amount}",
      remaining: "Verbleibend: {amount}",
      statusCompleted: "Abgeschlossen",
      statusPending: "Ausstehend"
    },
    labels: {
      basicSalary: "Grundgehalt:",
      bonusesIncentivesAllowances: "Boni, Prämien und Zulagen:",
      allowances: "Zulagen:",
      totalRevenue: "Gesamteinnahmen:",
      deductions: "Abzüge",
      deductionsLabel: "Abzüge:",
      latePenalties: "Verspätungsstrafen:",
      totalDeductions: "Abzüge gesamt:",
      netSalary: "Nettogehalt:",
      totalEmployees: "Mitarbeiter gesamt",
      totalGrossSalaries: "Bruttogehälter gesamt",
      totalNetSalaries: "Nettogehälter gesamt",
      totalDeductionsSummary: "Abzüge gesamt",
      totalPaid: "Gesamt gezahlt",
      totalRemaining: "Gesamt verbleibend",
      workDays: "Arbeitstage:",
      workHours: "Arbeitsstunden:",
      timezone: "Zeitzone:",
      revenue: "Einnahmen"
    },
    currentPeriod: "Aktuellen Zeitraum bearbeiten",
    currentPeriodDesc: "Gehälter des aktuellen Monats verwalten und berechnen",
    previousPeriods: "Vorherige Zeiträume",
    previousPeriodsDesc: "Gehälter vorheriger Zeiträume anzeigen und bearbeiten",
    previousPeriodsViewDesc: "Gehälter vorheriger Zeiträume anzeigen",
    viewRecords: "Datensätze anzeigen",
    taxSettings: "Steuer- und Versicherungseinstellungen",
    taxSettingsDesc: "Steuer- und Sozialversicherungseinstellungen verwalten",
    taxSettingsViewDesc: "Alle Mitarbeiterabzüge anzeigen und verwalten",
    editSettings: "Einstellungen bearbeiten",
    back: "Zurück",
    downloadPayrollFile: "Gehaltsdatei herunterladen",
    markAllAsPaid: "Alle als bezahlt markieren",
    deletePayroll: "Gehaltsabrechnung löschen",
    calculateSalary: "Gehalt berechnen",
    calculating: "Wird berechnet...",
    processing: "Wird verarbeitet...",
    markAsPaid: "Als bezahlt markieren",
    downloadPayslip: "Gehaltsabrechnung herunterladen",
    revenue: "Einnahmen",
    bankInformation: "Bankinformationen",
    bankName: "Bankname",
    accountNumber: "Kontonummer",
    swiftCode: "SWIFT-Code",
    selectMonth: "Monat auswählen",
    selectMonthPlaceholder: "-- Monat auswählen --",
    selectMonthToView: "Bitte wählen Sie einen Monat aus, um Gehaltsdaten anzuzeigen",
    noPayrollData: "Keine Gehaltsdaten für diesen Monat. Klicken Sie auf \"Gehalt berechnen\", um die Berechnung zu starten.",
    noPayrollDataForMonth: "Keine Gehaltsdaten für diesen Monat.",
    currency: "",
    notSpecified: "Nicht angegeben",
    notAvailable: "Nicht verfügbar",
    row: "Zeile",
    filtersAndSearch: "Filter und Suche",
    hide: "Ausblenden",
    showFilters: "Filter anzeigen",
    search: "Suchen...",
    allDepartments: "Alle Abteilungen",
    allEmployees: "Alle Mitarbeiter",
    withDeductions: "Mit Abzügen",
    withoutDeductions: "Ohne Abzüge",
    noSort: "Keine Sortierung",
    highestDeductions: "Höchste Abzüge",
    lowestDeductions: "Niedrigste Abzüge",
    nameAsc: "Name (A-Z)",
    nameDesc: "Name (Z-A)",
    sortByDepartment: "Nach Abteilung",
    minAmount: "Mindestbetrag",
    maxAmount: "Höchstbetrag",
    noLimit: "Kein Limit",
    clearAllFilters: "Alle Filter löschen",
    noEmployeesAvailable: "Keine Mitarbeiter verfügbar",
    noSearchResults: "Keine Suchergebnisse",
    edit: "Bearbeiten",
    cancel: "Abbrechen",
    save: "Speichern",
    saving: "Wird gespeichert...",
    delete: "Löschen",
    deductionName: "Abzugsname",
    amount: "Betrag",
    endDate: "Enddatum",
    addDeduction: "Abzug hinzufügen",
    addNewDeduction: "Neuen Abzug hinzufügen",
    noDeductionsDefined: "Keine Abzüge definiert",
    showing: "Zeige",
    to: "bis",
    of: "von",
    employees: "Mitarbeiter",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    itemsPerPage: "Einträge pro Seite",
    deductionTypes: {
      socialInsurance: "Sozialversicherung",
      insurance: "Versicherung",
      tax: "Steuer",
      loans: "Darlehen",
      absence: "Abwesenheit"
    },
    status: {
      paid: "Bezahlt",
      pending: "Ausstehend",
      partiallyPaid: "Teilweise bezahlt"
    },
    export: {
      employeeName: "Mitarbeitername",
      baseSalary: "Grundgehalt",
      bonuses: "Boni",
      allowances: "Zulagen",
      deductions: "Abzüge",
      grossSalary: "Bruttogehalt",
      netSalary: "Nettogehalt",
      status: "Status",
      sheetName: "Mitarbeitergehälter",
      fileNamePrefix: "Gehaltsabrechnung"
    },
    saveDeductionsSuccess: "Abzüge erfolgreich gespeichert",
    downloadPayrollFileSuccess: "Gehaltsdatei erfolgreich heruntergeladen",
    downloadPayslipSuccess: "Gehaltsabrechnung erfolgreich heruntergeladen",
    markAsPaidSuccess: "Gehalt erfolgreich als bezahlt markiert",
    payAllEmployeesSuccess: "Alle Gehälter erfolgreich als bezahlt markiert",
    calculatePayrollSuccess: "Gehaltsabrechnung erfolgreich berechnet",
    deletePayrollSuccess: "Gehaltsabrechnung erfolgreich gelöscht",
    errorFetchingPayroll: "Gehaltsdaten konnten nicht abgerufen werden",
    errorFetchingEmployees: "Mitarbeiterdaten konnten nicht geladen werden",
    errorDeductionNameRequired: "Bitte geben Sie einen Abzugsnamen ein in",
    errorDeductionAmountRequired: "Bitte geben Sie einen gültigen Betrag ein in",
    saveDeductionsFailed: "Abzüge konnten nicht gespeichert werden",
    errorSavingDeductions: "Beim Speichern der Abzüge ist ein Fehler aufgetreten",
    downloadPayrollFileFailed: "Gehaltsdatei konnte nicht heruntergeladen werden",
    downloadPayslipFailed: "Gehaltsabrechnung konnte nicht heruntergeladen werden",
    errorSelectMonth: "Bitte wählen Sie einen Monat aus",
    errorEmployeeIdNotAvailable: "Mitarbeiter-ID nicht verfügbar",
    errorPayrollDataRequired: "Bitte stellen Sie sicher, dass Gehaltsdaten und Monat verfügbar sind",
    markAsPaidFailed: "Gehalt konnte nicht als bezahlt markiert werden",
    payAllEmployeesFailed: "Alle Gehälter konnten nicht als bezahlt markiert werden",
    calculatePayrollFailed: "Gehaltsabrechnung konnte nicht berechnet werden",
    calculatingPayroll: "Gehaltsabrechnung wird berechnet...",
    deletePayrollConfirm: "Sind Sie sicher, dass Sie die Gehaltsabrechnung für diesen Monat löschen möchten? Alle berechneten Daten werden gelöscht.",
    payAllEmployeesConfirm: "Sind Sie sicher, dass Sie alle Mitarbeiter als bezahlt markieren möchten? Alle Mitarbeitergehälter für diesen Monat werden als bezahlt markiert.",
    bulkPaymentNote: "Massenauszahlung",
    byMonth: {
      searchTitle: "Nach einem bestimmten Monat suchen",
      year: "Jahr",
      monthOptional: "Monat (optional)",
      summaryTitle: "Gehaltsübersicht {year}",
      employees: "Mitarbeiter",
      totalSalaries: "Gesamtgehälter",
      remaining: "Verbleibend",
      paid: "Bezahlt",
      pending: "Ausstehend",
      paidCount: "Bezahlt",
      viewEmployeeDetails: "Details eines bestimmten Mitarbeiters anzeigen",
      selectEmployeeOptional: "Mitarbeiter auswählen (optional)",
      employeePayrollDetails: "Gehaltsdetails: {name}",
      statusCompleted: "Abgeschlossen",
      statusPartial: "Teilweise",
      statusPending: "Ausstehend",
      net: "Netto:",
      paidLabel: "Bezahlt:",
      remainingLabel: "Verbleibend:",
      noPayrollData: "Keine Gehaltsdaten verfügbar",
      employeeNotFound: "Keine Daten für diesen Mitarbeiter gefunden",
      noDataHint: "Keine Daten verfügbar. Bitte Jahr und Monat wählen und auf \"Suchen\" klicken",
      fetchFailed: "Daten konnten nicht abgerufen werden"
    }
  },
  systemLogs: {
    title: "Systemprotokolle",
    description: "Systemaktivitätsprotokolle anzeigen und verwalten",
    searchPlaceholder: "Protokolle durchsuchen...",
    exportSuccess: "Protokolle erfolgreich exportiert",
    exportFailed: "Fehler beim Exportieren der Protokolle",
    clearConfirm: "Möchten Sie wirklich alle Protokolle löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    clearSuccess: "Alle Protokolle erfolgreich gelöscht",
    clearFailed: "Fehler beim Löschen der Protokolle",
    fetchFailed: "Fehler beim Abrufen der Protokolle",
    statsFailed: "Fehler beim Abrufen der Statistiken",
    noLogs: "Keine Protokolle gefunden",
    action: "Aktion",
    resource: "Ressource",
    dateFrom: "Von Datum",
    dateTo: "Bis Datum",
    clearFilters: "Filter zurücksetzen",
    export: "Exportieren",
    clearAll: "Alles löschen",
    totalLogs: "Protokolle gesamt",
    financialTransactions: "Finanztransaktionen",
    today: "Heute",
    thisMonth: "Dieser Monat",
    searchFilters: "Suchfilter",
    showFilters: "Filter anzeigen",
    hideFilters: "Filter ausblenden",
    search: "Suche",
    allActions: "Alle Aktionen",
    allResources: "Alle Ressourcen",
    logsCount: "Protokolle ({count})",
    pageOf: "Seite {current} von {pages}",
    datetime: "Datum & Uhrzeit",
    user: "Benutzer",
    operation: "Aktion",
    financialDetails: "Finanzdetails",
    status: "Status",
    actions: "Aktionen",
    details: "Details",
    logDetails: "Protokolldetails",
    unknownUser: "Unbekannt",
    unavailable: "Nicht verfügbar",
    ip: "IP",
    amount: "Betrag",
    transactionType: "Transaktionstyp",
    category: "Kategorie",
    transactionDate: "Transaktionsdatum",
    descriptionLabel: "Beschreibung",
    transactionId: "Transaktions-ID",
    transactionStatus: "Transaktionsstatus",
    completed: "Abgeschlossen",
    endpoint: "Endpunkt",
    detailsLabel: "Details",
    userAgent: "User-Agent",
    showingRange: "Anzeige {from} bis {to} von {total} Protokollen",
    previous: "Zurück",
    next: "Weiter",
    actionLabels: {
      add: "Hinzufügen",
      edit: "Bearbeiten",
      delete: "Löschen",
      view: "Anzeigen",
      login: "Anmeldung",
      logout: "Abmeldung"
    },
    resourceLabels: {
      financial: "Finanztransaktionen",
      employees: "Mitarbeiter",
      payroll: "Gehaltsabrechnung",
      whatsapp: "WhatsApp",
      systemLog: "Systemprotokoll"
    }
  },
  invoices: {
    title: "Rechnungen",
    description: "Rechnungen und Zahlungen verwalten",
    addInvoice: "Neue Rechnung hinzufügen",
    editInvoice: "Rechnung bearbeiten",
    deleteConfirm: "Möchten Sie diese Rechnung wirklich löschen?",
    deleteSuccess: "Rechnung erfolgreich gelöscht",
    createSuccess: "Rechnung erfolgreich erstellt",
    updateSuccess: "Rechnung erfolgreich aktualisiert",
    statusUpdateSuccess: "Rechnungsstatus erfolgreich aktualisiert",
    statusUpdateFailed: "Rechnungsstatus konnte nicht aktualisiert werden",
    fetchFailed: "Fehler beim Abrufen der Daten",
    noPermissionDelete: "Sie haben keine Berechtigung, Rechnungen zu löschen",
    noInvoices: "Keine Rechnungen gefunden",
    client: "Kunde",
    amount: "Betrag",
    descriptionLabel: "Beschreibung",
    dueDate: "Fälligkeitsdatum",
    paymentMethod: "Zahlungsmethode",
    notes: "Notizen",
    status: "Status",
    paid: "Bezahlt",
    pending: "Ausstehend",
    overdue: "Überfällig",
    cancelled: "Storniert"
  },
  me: {
    desktopNotConnected: "Desktop-App ist nicht verbunden",
    serverDisconnected: "Nicht mit dem Server verbunden",
    desktopRequiredForAttendance: "Bitte starten Sie zuerst die Desktop-App für Check-in/Check-out",
    commandFailed: "Befehl konnte nicht gesendet werden",
    actionSuccess: "erfolgreich abgeschlossen",
    remoteWorkStarted: "Remote-Arbeit gestartet",
    remoteWorkEnded: "Remote-Arbeit beendet",
    remoteWorkResumed: "Remote-Arbeit fortgesetzt",
    remoteWorkPaused: "Remote-Arbeit pausiert",
    breakEnded: "Pause beendet",
    breakStarted: "Pause gestartet",
    noReason: "Kein Grund angegeben",
    monthRecordsSynced: "Alle Monatsdatensätze aus App-Daten aktualisiert",
    monthRecordsSyncFailed: "Monatsdatensätze konnten nicht aktualisiert werden",
    monthRecordsSyncError: "Fehler beim Aktualisieren der Monatsdatensätze",
    todayRecordsSynced: "Heutige Datensätze erfolgreich aktualisiert",
    todayRecordsSyncFailed: "Datensätze konnten nicht aktualisiert werden",
    todayRecordsSyncError: "Fehler beim Aktualisieren der Datensätze",
    allDataSynced: "Alle Daten aus der App aktualisiert",
    syncError: "Bei der Synchronisierung ist ein Fehler aufgetreten",
    breakSettingsNotFound: "Pauseneinstellungen nicht gefunden",
    breakSettingsFetchError: "Fehler beim Abrufen der Pauseneinstellungen",
    employeeFetchFailed: "Mitarbeiterdaten konnten nicht abgerufen werden",
    employeeFetchError: "Fehler beim Abrufen der Mitarbeiterdaten",
    holidaysFetchFailed: "Urlaubsanträge konnten nicht abgerufen werden",
    holidaysFetchError: "Fehler beim Abrufen der Urlaubsanträge",
    weeklyAttendanceFailed: "Wöchentliche Anwesenheit konnte nicht geladen werden",
    weeklyAttendanceError: "Fehler beim Laden der Anwesenheitsdaten",
    todayAttendanceFailed: "Heutige Anwesenheit konnte nicht geladen werden",
    todayAttendanceError: "Fehler beim Laden der heutigen Anwesenheit",
    selectMonth: "Bitte wählen Sie einen Monat",
    payslipDownloadSuccess: "Gehaltsabrechnung erfolgreich heruntergeladen",
    noPayslipMonths: "Noch keine Monate mit Gehaltsabrechnung",
    payrollDataRequired: "Bitte stellen Sie sicher, dass Gehaltsdaten und Monat verfügbar sind",
    markPaidSuccess: "Gehalt erfolgreich als bezahlt markiert",
    documentsPage: {
      title: "Meine Dokumente",
      description: "Ihre Dokumente anzeigen und verwalten",
      fetchFailed: "Dokumente konnten nicht geladen werden",
      noDocuments: "Keine Dokumente",
      noDocumentsAvailable: "Derzeit keine Dokumente zum Anzeigen verfügbar",
      noDescription: "Keine Beschreibung",
      untitled: "Unbenanntes Dokument",
      unknown: "Unbekannt",
      view: "Anzeigen",
      viewUnavailable: "Anzeige nicht verfügbar",
      download: "Herunterladen",
      successKeyword: "Erfolg",
      upload: "Hochladen",
      uploading: "Wird hochgeladen...",
      uploadSuccess: "Dokument erfolgreich hochgeladen",
      uploadFailed: "Dokument konnte nicht hochgeladen werden",
      uploadToManagement: "Dokument an die Verwaltung hochladen",
      uploadToManagementHint: "Senden Sie ein Dokument an Admin oder Manager",
      descriptionOptional: "Beschreibung (optional)",
      titleRequired: "Dokumenttitel ist vor der Dateiauswahl erforderlich",
      titleRequiredPlaceholder: "Dokumenttitel (erforderlich)",
      fromManagement: "Von der Verwaltung",
      uploadedByMe: "Von mir hochgeladen",
      noFromManagement: "Noch keine Dokumente von der Verwaltung",
      noUploadedByMe: "Sie haben noch keine Dokumente hochgeladen"
    },
    salaryPage: {
      manageTitle: "Gehalts- und Leistungsmanagement",
      manageDesc: "Gehalt, Boni und Abzüge des Mitarbeiters verwalten",
      markAsPaid: "Gehalt als bezahlt markieren",
      noDataForMonth: "Keine Gehaltsdaten für diesen Monat verfügbar. Bitte kontaktieren Sie die Verwaltung.",
      noData: "Keine Gehaltsdaten verfügbar.",
      displayError: "Fehler beim Anzeigen der Gehaltsdaten",
      displayErrorHint: "Bitte aktualisieren Sie die Seite oder kontaktieren Sie den technischen Support",
      monthlyFixed: "Fester Monatsbetrag",
      monthlyBonuses: "Monatliche Boni",
      monthlyDeductions: "Monatliche Abzüge: {amount}",
      remainingAfterPartial: "Restbetrag nach Teilzahlungen",
      paidAmount: "Gezahlter Betrag: {amount}",
      fromDailySalary: "Vom Tagesgehalt",
      dailyRate: "Tagessatz (÷ Arbeitstage)",
      hourlyRate: "Stundensatz (÷ 8)",
      finalNetSalary: "Endgültiges Nettogehalt",
      cash: "Bar",
      fullyPaid: "Vollständig bezahlt",
      byUser: "Von: {user} am {date}",
      earnings: "Einnahmen",
      totalEarnings: "Gesamteinnahmen:",
      totalDeductionsColon: "Gesamtabzüge:",
      baseSalaryColon: "Grundgehalt:",
      netSalaryColon: "Nettogehalt:",
      bonusesAllowances: "Boni, Anreize & Zulagen:",
      allowancesColon: "Zulagen:",
      deductionsColon: "Abzüge:",
      monthlyLateHours: "Monatliche Verspätungsstunden",
      totalInDays: "Gesamt in {days} Tagen",
      deductionPerHour: "Abzugssatz/Stunde",
      monthDeduction: "Monatsabzug",
      actualWorkDays: "Tatsächliche Arbeitstage (ohne Feiertage):",
      daysCount: "{count} Tage"
    },
    ui: {
      overview: "Übersicht",
      attendanceCheckout: "Anwesenheit & Check-out",
      skillsAndCertificates: "Fähigkeiten & Zertifikate",
      messaging: "Nachrichten",
      myDocuments: "Meine Dokumente",
      holidays: "Urlaub",
      tasks: "Aufgaben",
      welcome: "Willkommen,",
      employeeNumber: "Mitarbeiter-Nr.",
      joined: "Beigetreten:",
      directManager: "Direkter Vorgesetzter:",
      todayStatus: "Heutiger Status",
      checkInLabel: "Eintritt:",
      netSalary: "Nettogehalt",
      attendanceRate: "Anwesenheitsquote",
      performanceRating: "Leistungsbewertung",
      todayBreakTime: "Heutige Pausenzeit",
      currentlyOnBreak: "Derzeit in Pause",
      completedTasks: "Erledigte Aufgaben",
      recentNotifications: "Aktuelle Benachrichtigungen",
      recentRequests: "Letzte Anfragen",
      attendanceStatus: "Anwesenheitsstatus",
      status: "Status:",
      totalTime: "Gesamtzeit:",
      activeTime: "Aktive Zeit:",
      idleTime: "Leerlaufzeit:",
      checkIn: "Check-in",
      checkOut: "Check-out",
      checkInEmoji: "🟢 Check-in",
      checkOutEmoji: "🔴 Check-out",
      break: "Pause",
      startBreak: "Pause starten",
      endBreak: "Pause beenden",
      breakNotes: "Pausennotizen",
      breakNotesCount: "Pausennotizen ({count})",
      viewBreakNotes: "Pausennotizen anzeigen ({count} Notizen)",
      breakDuration: "Pausendauer:",
      breakTime: "Pausenzeit:",
      currentlyOnBreakColon: "Derzeit in Pause:",
      startedAt: "Begonnen um:",
      workingAlready: "Arbeit läuft bereits",
      workingInProgress: "Arbeit läuft...",
      onBreakHint: "In Pause...",
      canStartWorkNow: "Sie können jetzt mit der Arbeit beginnen",
      workingCanPauseOrBreak: "Arbeit läuft - Sie können pausieren oder eine Pause nehmen",
      workPausedCanResumeOrEnd: "Arbeit pausiert - Sie können fortsetzen oder beenden",
      onBreakCanEndOrWork: "In Pause - Sie können die Pause beenden oder arbeiten",
      canControlFromHere: "Sie können die App von hier steuern",
      onTime: "Pünktlich",
      late: "Verspätet",
      absent: "Abwesend",
      onBreak: "In Pause",
      present: "Pünktlich anwesend",
      weekend: "Wochenende",
      unavailable: "Nicht verfügbar",
      holiday: "Feiertag",
      leave: "Urlaub",
      officialHoliday: "Offizieller Feiertag",
      offline: "Getrennt",
      connected: "Verbunden",
      activeWorking: "Aktiv - arbeitet derzeit",
      paused: "Pausiert",
      connectedReady: "Verbunden - bereit zur Arbeit",
      appStatus: "App-Status",
      todayWorkTime: "Heutige Arbeitszeit:",
      productivity: "Produktivität:",
      workPausedHint: "Arbeit ist pausiert - Sie können fortsetzen oder beenden",
      appReadyHint: "App ist verbunden und bereit, die Arbeit zu starten",
      appOfflineHint: "App ist getrennt - bitte starten Sie die Desktop-App",
      timeTracking: "Zeiterfassung",
      refresh: "Aktualisieren",
      retry: "Erneut versuchen",
      verifyMatch: "Übereinstimmung prüfen",
      updateTodayRecord: "Heutigen Eintrag aktualisieren",
      endWork: "Arbeit beenden",
      resumeWork: "Arbeit fortsetzen",
      startWork: "Arbeit starten",
      pause: "Pausieren",
      resume: "Fortsetzen",
      remoteControl: "Fernsteuerung",
      useDesktopAppHint: "Nutzen Sie die Desktop-App für die beste Tracking-Erfahrung",
      todayActivity: "Heutige Aktivität",
      productivityRate: "Produktivitätsrate:",
      lastActivity: "Letzte Aktivität:",
      noActivityToday: "Keine Aktivität heute",
      monitoring: "Überwachung",
      monitoringMode: "Überwachungsmodus:",
      active: "Aktiv",
      screenshots: "Screenshots",
      recentScreenshots: "Aktuelle Screenshots",
      noScreenshots: "Keine Screenshots verfügbar",
      ensureDesktopRunning: "Stellen Sie sicher, dass die Desktop-App läuft",
      syncing: "Synchronisierung...",
      syncNow: "Daten jetzt synchronisieren",
      totalBreakTime: "Gesamte Pausenzeit",
      lastImage: "Letztes Bild:",
      view: "Anzeigen",
      noImages: "Keine Bilder",
      connectedNow: "Derzeit verbunden",
      verifyDataMatch: "Datenübereinstimmung prüfen",
      clear: "Löschen",
      export: "Exportieren",
      viewOnlyNoClear: "Nur Ansicht - Löschen nicht möglich",
      updateMonth: "Monat aktualisieren",
      date: "Datum",
      day: "Tag",
      remainingTime: "Verbleibende Zeit",
      productivityCol: "Produktivität",
      statusCol: "Status",
      dataCol: "Daten",
      today: "Heute",
      weeklyStats: "Wochenstatistik",
      avgProductivity: "Durchschn. Produktivität",
      totalWork: "Gesamtarbeit",
      workDays: "Arbeitstage",
      hours: "Stunden",
      minutes: "Minuten",
      detailedDailyLog: "Detailliertes Tagesprotokoll",
      notLoggedIn: "Nicht angemeldet",
      pleaseLogin: "Bitte melden Sie sich an, um auf diese Seite zuzugreifen",
      loadingData: "Daten werden geladen...",
      pleaseWait: "Bitte warten",
      loadingTrackingData: "Tracking-Daten werden geladen...",
      fetchingLatestFromDesktop: "Aktuelle Daten werden von der Desktop-App abgerufen",
      fetchDataError: "Fehler beim Abrufen der Daten",
      verifyAndSyncTitle: "Datenübereinstimmung prüfen und synchronisieren",
      createUpdateTodayRecordTitle: "Heutigen Eintrag erstellen/aktualisieren",
      desktopTimeTrackingApp: "Desktop-Zeiterfassungs-App",
      desktopAppFeatures: "Präzise Zeiterfassung • Produktivitätsanalyse • Aufgabenverwaltung",
      completelyFree: "Völlig kostenlos",
      easyToUse: "Einfach zu bedienen",
      instantSync: "Sofortige Synchronisierung",
      downloadApp: "App herunterladen",
      compatibleWithOs: "Kompatibel mit Windows, Mac, Linux",
      weeklyStatsDesc: "Arbeitsstunden und Produktivität der vergangenen Woche verfolgen",
      productivityRateLabel: "Produktivitätsrate",
      workTimeLabel: "Arbeitszeit",
      activeTimeLabel: "Aktive Zeit",
      dayLabel: "Tag {day}",
      productivityPercentLabel: "Produktivitätsrate %",
      workTimeHoursLabel: "Arbeitszeit (Stunden)",
      activeTimeHoursLabel: "Aktive Zeit (Stunden)",
      filters: "Filter",
      screenshotsProtectedDesc: "Zufällige Screenshots werden regelmäßig gemacht, um die tatsächliche Anwesenheit zu prüfen — Daten sind geschützt und können nicht gelöscht werden",
      search: "Suche",
      searchImagesPlaceholder: "Bilder suchen...",
      activityType: "Aktivitätstyp",
      allActivities: "Alle Aktivitäten",
      activeWork: "Aktive Arbeit",
      idle: "Leerlauf",
      timePeriod: "Zeitraum",
      allTimes: "Alle Zeiten",
      morningRange: "Morgen (6–12 Uhr)",
      afternoonRange: "Nachmittag (12–18 Uhr)",
      eveningRange: "Abend (18–6 Uhr)",
      productivityLevel: "Produktivitätsniveau",
      allLevels: "Alle Niveaus",
      highProductivity: "Hoch (80%+)",
      mediumProductivity: "Mittel (50%–80%)",
      lowProductivity: "Niedrig (unter 50%)",
      dateRange: "Datumsbereich",
      fromDate: "Von Datum",
      toDate: "Bis Datum",
      reset: "Zurücksetzen",
      ofImages: "{filtered} von {total} Bildern",
      applyFilters: "Filter anwenden",
      totalImagesCount: "Gesamtbilder: {count}",
      pageOf: "Seite {current} von {total}",
      showingRange: "Anzeige {start}-{end} von {total}",
      screenshotN: "Screenshot {n}",
      screenshot: "Screenshot",
      workActivity: "Arbeitsaktivität",
      previous: "Zurück",
      next: "Weiter",
      liveConnected: "Live verbunden",
      sameAppData: "Gleiche App-Daten",
      updateMonthTitle: "Alle Monatseinträge (einschließlich heute) aus App-Daten aktualisieren",
      liveConnectedDesc: "Live mit der Desktop-App verbunden — Daten stimmen zu 100% mit der App überein (Gesamt, Aktiv, Leerlauf, Pause)",
      loadingOrDefaultData: "Daten werden geladen oder Standarddaten verwendet",
      showingDefaultData: "Standarddaten werden angezeigt — stellen Sie sicher, dass die Desktop-App läuft",
      zeroMinutes: "0 Minuten",
      hoursAndMinutes: "{hours} Stunden {minutes} Minuten",
      minutesOnly: "{minutes} Minuten",
      completed: "Abgeschlossen",
      fromApp: "App",
      none: "Keine",
      realDataDays: "Tage mit echten Daten",
      totalWorkHours: "Gesamtarbeitsstunden",
      totalActiveHours: "Gesamte aktive Stunden",
      totalIdleTime: "Gesamte Leerlaufzeit",
      dailyLogLinkedToDb: "Das detaillierte Tagesprotokoll ist direkt mit der Datenbank verknüpft",
      dataMatch100: "Daten stimmen zu 100% überein:",
      dataMatchExample: "Wenn die App 4 Minuten Gesamtzeit und 2 Minuten aktiv zeigt, sehen Sie dieselben Zahlen hier in der Tabelle",
      totalTimeBullet: "Gesamtzeit:",
      totalTimeBulletDesc: "Genau dieselbe Zahl wie in der App",
      activeTimeBullet: "Aktive Zeit:",
      activeTimeBulletDesc: "Dieselbe aktive Zeit wie in der App",
      idleTimeBullet: "Leerlaufzeit:",
      idleTimeBulletDesc: "Dieselbe in der App berechnete Leerlaufzeit",
      breakTimeBullet: "Pausenzeit:",
      breakTimeBulletDesc: "Dieselbe Pausenzeit, falls Pausen genommen wurden",
      updateTodayBullet: "Schaltfläche „Heute aktualisieren“:",
      updateTodayBulletDesc: "Aktualisiert nur den heutigen Eintrag aus App-Daten",
      updateMonthBullet: "Schaltfläche „Monat aktualisieren“:",
      updateMonthBulletDesc: "Aktualisiert alle Einträge des aktuellen Monats aus App-Daten",
      appIndicatorBullet: "App-Indikator:",
      appIndicatorBulletDesc: "Erscheint für Tage mit echten Daten aus der App",
      desktopMonitoringGuide: "Leitfaden zum Desktop-Überwachungssystem",
      desktopMonitoringGuideDesc: "Vollständiger Leitfaden zur Nutzung des Anwesenheits- und Produktivitätsüberwachungssystems",
      basicRequirements: "Grundvoraussetzungen",
      desktopApp: "Desktop-App",
      desktopAppDesc: "Laden Sie die App herunter und installieren Sie sie auf Ihrem Arbeitsgerät",
      stableInternet: "Stabile Internetverbindung",
      stableInternetDesc: "Um die Datensynchronisierung mit dem Server sicherzustellen",
      login: "Anmeldung",
      loginDesc: "Verwenden Sie dieselben Anmeldedaten wie auf der Website",
      monitoringAndTracking: "Überwachung und Tracking",
      autoActivityTracking: "Automatische Aktivitätsverfolgung",
      autoActivityTrackingDesc: "Überwacht Maus- und Tastaturaktivität zur Berechnung der tatsächlichen Arbeitszeit",
      randomScreenshots: "Zufällige Screenshots",
      randomScreenshotsDesc: "Alle 10–30 Minuten zur Überprüfung der tatsächlichen Anwesenheit — vor Löschung geschützt",
      productivityCalculation: "Berechnung der Produktivitätsrate",
      productivityCalculationDesc: "Basierend auf dem Verhältnis von aktiver Zeit zur Gesamtzeit",
      activeAppRequired: "Aktive App erforderlich",
      activeAppRequiredDesc: "Check-in von der Website ist nur möglich, wenn die App verbunden ist",
      dualCheckIn: "Doppelter Check-in",
      dualCheckInDesc: "Check-in über die App oder die Website möglich (App muss verbunden sein)",
      preciseTiming: "Präzise Zeitmessung",
      preciseTimingDesc: "Genaue Erfassung von Check-in/out-Zeiten und Zeitabschnitten",
      privacyAndSecurity: "Datenschutz und Sicherheit",
      protectedData: "Geschützte Daten",
      protectedDataDesc: "Alle Daten sind verschlüsselt und gemäß Sicherheitsstandards geschützt",
      viewOnly: "Nur Ansicht",
      viewOnlyDesc: "Mitarbeiter können nur ihre eigenen Screenshots ansehen",
      cannotDelete: "Löschen nicht möglich",
      cannotDeleteDesc: "Daten sind geschützt und können vom Mitarbeiter nicht gelöscht werden",
      importantNotice: "Wichtiger Hinweis",
      importantNoticeDesc: "Das Überwachungssystem dient der Fairness und Transparenz am Arbeitsplatz. Alle Daten werden nur für administrative Zwecke verwendet und mit höchsten Datenschutzstandards geschützt. Bei Fragen wenden Sie sich bitte an die Personalabteilung.",
      screenshotGallery: "Screenshot-Galerie ({count})",
      galleryFilters: "Galeriefilter",
      galleryDesc: "Alle während der Arbeit aufgenommenen Bilder — mit Blättern und Filtern",
      galleryImagesCount: "Galerie: {count} Bilder",
      clickToViewFull: "Klicken Sie auf ein Bild, um es in voller Größe anzuzeigen",
      screenshotTitle: "Screenshot - {timestamp}",
      close: "Schließen",
      screenshotPreview: "Screenshot-Vorschau",
      activityColon: "Aktivität:",
      imageProtected: "Dieses Bild ist geschützt und kann nicht heruntergeladen oder gelöscht werden",
      noDataAvailable: "Keine Daten verfügbar",
      noEmployeeProfile: "Derzeit ist kein Mitarbeiterprofil mit Ihrem Konto verknüpft.",
      noEmployeeProfileContactAdmin: "Derzeit ist kein Mitarbeiterprofil mit Ihrem Konto verknüpft. Bitte kontaktieren Sie die Verwaltung, um ein Mitarbeiterprofil hinzuzufügen.",
      noEmployeeFile: "Kein Mitarbeiterprofil",
      adminNoEmployeeFile: "Sie sind als Administrator angemeldet und haben kein Mitarbeiterprofil mit Ihrem Konto verknüpft.",
      needEmployeeFileAccess: "Um auf Mitarbeiterinformationen zuzugreifen, benötigen Sie ein mit Ihrem Konto verknüpftes Mitarbeiterprofil.",
      backToDashboard: "Zurück zum Dashboard",
      breakReason: "Pausengrund",
      breakReasonPrompt: "Geben Sie den Grund für die Pause ein (optional):",
      breakReasonPlaceholder: "z. B. Mittagessen, Kaffeepause, Telefonat...",
      noBreakNotes: "Keine Pausennotizen gespeichert",
      breakNotesWillAppear: "Hier erscheinen die Pausennotizen, die Sie erfassen",
      totalBreaksLogged: "Erfasste Pausen insgesamt:",
      deleteThisNote: "Diese Notiz löschen",
      confirmDeleteAllBreakNotes: "Möchten Sie wirklich alle Pausennotizen löschen?",
      deleteAllNotes: "Alle Notizen löschen",
      work: "Arbeit",
      zeroMinShort: "0m",
      minShort: "{m}m",
      hourShort: "{h}h",
      hourMinShort: "{h}h {m}m",
      zeroHoursMinutes: "0 Stunden 0 Minuten",
      verifyDataMatchDetailedTitle: "Datenübereinstimmung zwischen App und detaillierter Tabelle prüfen",
      unspecified: "Nicht angegeben",
      loadPartialDataFailed: "Einige Daten konnten nicht geladen werden",
      months: {
        1: "Januar",
        2: "Februar",
        3: "März",
        4: "April",
        5: "Mai",
        6: "Juni",
        7: "Juli",
        8: "August",
        9: "September",
        10: "Oktober",
        11: "November",
        12: "Dezember"
      }
    },
    msg: {
      companyGroup: "Firmengruppe",
      readOnly: "Nur Lesen",
      title: "Meine gesendeten Nachrichten",
      underDevelopment: "Noch in Entwicklung...!",
      loading: "Nachrichten werden geladen...",
      aiEnabled: "KI: An",
      aiDisabled: "KI: Aus",
      enableAi: "KI-Modus aktivieren",
      disableAi: "KI-Modus deaktivieren",
      sentCount: "{count} gesendete Nachrichten",
      sortNewest: "Neueste zuerst",
      sortOldest: "Älteste zuerst",
      sortAria: "Nachrichten sortieren",
      searchAria: "Nachrichten suchen",
      emptyTitle: "Noch keine gesendeten Nachrichten",
      emptyHint: "Gesendete Nachrichten erscheinen hier.",
      noContent: "Kein Inhalt verfügbar",
      languageLabel: "Sprache: {lang}",
      sendFailed: "Senden fehlgeschlagen",
      aiFeatures: "KI-Funktionen",
      translateTo: "Übersetzen in Sprache:",
      languagePlaceholder: "Sprache eingeben (z. B. English)",
      translate: "Übersetzen",
      messagePlaceholder: "Schreiben Sie hier Ihre professionelle Nachricht...",
      messageAria: "Neue Nachricht eingeben",
      improveTitle: "Nachricht sprachlich verbessern",
      translateToTitle: "Übersetzen nach {lang}",
      sendAria: "Nachricht senden",
      translateError: "Fehler beim Übersetzen der Nachricht",
      improveError: "Fehler beim Verbessern der Nachricht",
      invalidDate: "Ungültiges Datum",
      invalidToken: "Ungültiges oder fehlendes Auth-Token",
      unauthorized: "Nicht autorisiert: bitte erneut anmelden",
      badRequest: "Ungültige Anfrage",
      sendFailedStatus: "Nachricht konnte nicht gesendet werden: {status}",
      sendSuccess: "Nachricht erfolgreich gesendet",
      sendUnknownError: "Unbekannter Fehler beim Senden der Nachricht",
      you: "Sie",
      hrTitle: "HR-Ankündigungen",
      loadingChat: "Chat wird geladen...",
      noSearchResults: "Keine Nachrichten für \"{term}\" gefunden",
      noSearchHint: "Versuchen Sie einen anderen Suchbegriff oder leeren Sie die Suche.",
      noAnnouncements: "Noch keine Ankündigungen",
      noAnnouncementsHint: "Nachrichten von Administratoren erscheinen hier.",
      unknownSender: "Unbekannter Absender",
      employeesOnlySend: "Nur Mitarbeiter können senden",
      selectLanguage: "Sprache auswählen",
      customLanguagePlaceholder: "Benutzerdefinierte Sprache eingeben (z. B. Italian)",
      searchPlaceholder: "Nachrichten nach Text oder Datum suchen (z. B. 'März 2023')",
      translatedTo: "Übersetzt nach {lang}:",
      read: "Gelesen",
      unread: "Ungelesen",
      newest: "Neueste",
      oldest: "Älteste",
      toggleSearch: "Suche ein-/ausblenden",
      toggleTranslate: "Übersetzung ein-/ausblenden",
      sortBy: "Nachrichten sortieren",
      selectTranslateAll: "Sprache zum Übersetzen aller Nachrichten wählen",
      selectTranslateOne: "Sprache zum Übersetzen der Nachricht wählen",
      submitLanguage: "Sprache bestätigen",
      submitCustomLanguage: "Benutzerdefinierte Sprache bestätigen",
      toggleTranslateDropdown: "Übersetzungsmenü umschalten"
    }
  },
  notifications: {
    title: "Benachrichtigungszentrum",
    fetchFailed: "Benachrichtigungen konnten nicht abgerufen werden",
    fetchError: "Beim Abrufen der Benachrichtigungen ist ein Fehler aufgetreten",
    markReadFailed: "Benachrichtigungsstatus konnte nicht aktualisiert werden",
    markAllReadFailed: "Status der Benachrichtigungen konnte nicht aktualisiert werden",
    deleteFailed: "Benachrichtigung konnte nicht gelöscht werden",
    deleteAllFailed: "Alle Benachrichtigungen konnten nicht gelöscht werden",
    noNotifications: "Keine Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    deleteAll: "Alle löschen",
    all: "Alle",
    unread: "Ungelesen",
    read: "Gelesen",
    unreadCount: "{count} ungelesene Benachrichtigung"
  },
  employeesPending: {
    selectShiftRequired: "Bitte wählen Sie eine Schicht für den Mitarbeiter",
    invalidEmployeeId: "Ungültige Mitarbeiter-ID",
    enterAllowanceName: "Bitte Zulagenname eingeben",
    enterValidAllowanceAmount: "Bitte gültigen Zulagenbetrag eingeben",
    selectStartDate: "Bitte Startdatum wählen",
    selectEndDateOrPermanent: "Bitte Enddatum wählen oder \"Dauerhaft\" aktivieren",
    allowanceAddedToList: "Zulage zur Liste hinzugefügt",
    employeeIdMissing: "Mitarbeiter-ID nicht gefunden",
    selectWorkLocation: "Bitte Arbeitsort wählen",
    enterValidBaseSalary: "Bitte gültiges Grundgehalt eingeben",
    enterValidContractDuration: "Bitte eine gültige Vertragsdauer in Monaten eingeben (ganze Zahl größer als 0)",
    enterDailyOrders: "Bitte tägliche Bestellanzahl eingeben (mindestens 1)",
    enterRejectionReason: "Bitte Ablehnungsgrund eingeben",
    rejectionReasonMin: "Ablehnungsgrund muss mindestens 10 Zeichen lang sein",
    rejectionReasonMax: "Ablehnungsgrund ist zu lang (max. 500 Zeichen)",
    approveSuccess: "Mitarbeiter erfolgreich genehmigt",
    rejectSuccess: "Mitarbeiter erfolgreich abgelehnt",
    noEmployeesFound: "Keine Mitarbeiterdaten gefunden.",
    fetchEmployeesFailed: "Mitarbeiterdaten konnten nicht vom Server abgerufen werden. Bitte erneut versuchen.",
    notAuthorizedFetch: "Sie sind nicht berechtigt, Mitarbeiterdaten abzurufen",
    whatsappOpened: "WhatsApp Web geöffnet, um {name} eine Nachricht zu senden",
    whatsappOpenFailed: "Beim Öffnen von WhatsApp Web ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    sendWhatsAppMessage: "WhatsApp-Nachricht senden",
    sendWhatsAppTo: "WhatsApp-Nachricht an {name} senden",
    confirmApprove: "Möchten Sie diesen Mitarbeiter wirklich genehmigen?",
    approving: "Wird genehmigt...",
    approve: "Genehmigen",
    rejecting: "Wird abgelehnt...",
    reject: "Ablehnen",
    pendingApproval: "Genehmigung ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    approveFailed: "Mitarbeiter konnte nicht genehmigt werden",
    approveError: "Beim Genehmigen des Mitarbeiters ist ein Fehler aufgetreten"
  },
  companyValidation: {
    htmlInsteadOfJson: "HTML statt JSON erhalten. Dies könnte eine ngrok-Seite sein. Bitte Verbindung prüfen.",
    parseResponseFailed: "Serverantwort konnte nicht analysiert werden",
    corsError: "Serververbindungsfehler. Bitte CORS-Einstellungen auf dem Server prüfen.",
    connectionError: "Serververbindungsfehler",
    unknownError: "Unbekannter Fehler",
    enterValidCoordinates: "Bitte gültige Koordinaten eingeben",
    latitudeRange: "Breitengrad muss zwischen -90 und 90 liegen",
    longitudeRange: "Längengrad muss zwischen -180 und 180 liegen",
    browserNoGeolocation: "Browser unterstützt keine Geolokalisierung",
    getLocationFailed: "Standort konnte nicht ermittelt werden",
    enterBranchName: "Bitte Filialnamen eingeben",
    branchIdMissing: "Filial-ID nicht gefunden",
    noLocationForBranch: "Kein Standort für diese Filiale festgelegt",
    invalidOrgIdFormat: "Ungültiges Organisations-ID-Format. Muss XX-0000 sein (z. B. DE-5292). Bitte Organisationseinstellungen prüfen.",
    orgIdSavedRetry: "Organisations-ID gespeichert. Bitte erneut versuchen.",
    enterDepartmentName: "Bitte Abteilungsnamen eingeben",
    enterEquipmentName: "Bitte Vermögenswertnamen eingeben",
    enterValidPrice: "Bitte gültigen Preis eingeben",
    selectEmployeeToAssign: "Bitte Mitarbeiter zum Zuweisen wählen",
    selectNewEmployee: "Bitte neuen Mitarbeiter zum Zuweisen wählen",
    documentIdMissing: "Dokument-ID (publicId) nicht gefunden",
    selectFileToUpload: "Bitte Datei zum Hochladen wählen",
    enterToolName: "Bitte Werkzeugnamen eingeben",
    selectAtLeastOneEmployee: "Bitte mindestens einen Mitarbeiter wählen"
  },
  deductionsValidation: {
    ruleDelayMinutes: "Regel {n}: Verspätungsminuten müssen festgelegt werden",
    ruleCustomPenalty: "Regel {n}: Benutzerdefinierte Strafe erfordert Betrag oder Anzahl der Tage"
  },
  taxInsurance: {
    enterDeductionNameInRow: "Bitte Abzugsname in Zeile {n} eingeben",
    amountErrorInRow: "{error} (Zeile {n})",
    startBeforeEndInRow: "Startdatum muss vor Enddatum in Zeile {n} liegen",
    saveSuccess: "Steuer- und Versicherungseinstellungen erfolgreich gespeichert",
    saveFailed: "Daten konnten nicht gespeichert werden",
    saveError: "Beim Speichern der Daten ist ein Fehler aufgetreten",
    title: "Steuer- und Versicherungseinstellungen",
    description: "Feste Abzüge für alle Mitarbeiter verwalten",
    manageHint: "Verwalten Sie feste Abzüge wie Steuern, Sozialversicherung und Krankenversicherung",
    viewDetails: "Details anzeigen",
    hide: "Ausblenden",
    addNewDeduction: "Neuen Abzug hinzufügen",
    addFirstDeduction: "Ersten Abzug hinzufügen",
    deductionN: "Abzug #{n}",
    deductionName: "Abzugsname",
    deductionNamePlaceholder: "z. B. Steuern, Sozialversicherung",
    amount: "Betrag",
    startDate: "Startdatum",
    endDateOptional: "Enddatum (leer lassen für dauerhaften Abzug)",
    monthlyTotal: "Monatliche Gesamtabzüge",
    deductionAmountField: "Abzugsbetrag"
  },
  setup: {
    title: "Systemeinrichtung",
    subtitle: "Diese Einrichtung ist wichtig, um Ihr System korrekt zu konfigurieren. Wir empfehlen, alle Schritte für die beste Erfahrung abzuschließen.",
    skip: "Überspringen",
    skipNow: "Jetzt überspringen",
    cancel: "Abbrechen",
    stepLabel: "Schritt",
    steps: "Schritte",
    next: "Weiter",
    back: "Zurück",
    finish: "Fertig",
    saving: "Wird gespeichert...",
    yes: "Ja",
    no: "Nein",
    companyInfo: "Unternehmensinformationen",
    workDaysTimezone: "Arbeitstage & Zeitzone",
    shifts: "Schichten",
    shiftsHint: "Fügen Sie mindestens eine Arbeitsschicht hinzu (z. B. Frühschicht), damit Mitarbeiter korrekt einchecken können. Weitere Schichten können Sie später in den Einstellungen hinzufügen.",
    shiftsDescription: "Definieren Sie die Arbeitszeiten Ihres Unternehmens. Eine Schicht reicht zum Start; fügen Sie weitere hinzu, wenn Sie mehrere Schichten haben.",
    shiftsRequired: "Fügen Sie mindestens eine Schicht hinzu, um fortzufahren",
    location: "Unternehmensstandorte",
    branches: "Unternehmensfilialen",
    holidays: "Offizielle Feiertage",
    delaySettings: "Verspätungseinstellungen",
    approvalsRouting: "Genehmigungsweg",
    finishStep: "Einrichtung abgeschlossen",
    companyName: "Firmenname",
    companyNamePlaceholder: "Firmenname eingeben",
    description: "Beschreibung",
    email: "E-Mail",
    phone: "Telefon",
    website: "Website",
    address: "Adresse",
    street: "Straße",
    workDays: "Arbeitstage",
    workDaysHint: "Wählen Sie die Wochentage, an denen Ihr Unternehmen arbeitet",
    workDaysTimezoneHint: "Arbeitstage und Zeitzone beeinflussen Anwesenheit und Gehaltsabrechnung. Bitte genau einstellen.",
    timezone: "Zeitzone",
    selectTimezone: "Zeitzone auswählen",
    timezoneHint: "Wählen Sie die Zeitzone für Ihren Unternehmensstandort",
    locationName: "Standortname",
    locationNamePlaceholder: "z. B. Hauptbüro",
    latitude: "Breitengrad",
    longitude: "Längengrad",
    radius: "Radius (m)",
    useMyLocation: "Meinen Standort verwenden",
    mainOffice: "Hauptbüro",
    hasBranches: "Hat Ihr Unternehmen Filialen?",
    companyBranches: "Unternehmensfilialen",
    branchName: "Filialname",
    addBranch: "Filiale hinzufügen",
    wantHolidays: "Möchten Sie offizielle Feiertage hinzufügen?",
    officialHolidays: "Offizielle Feiertage",
    holidayName: "Feiertagsname",
    date: "Datum",
    type: "Typ",
    selectType: "Typ auswählen",
    national: "National",
    religious: "Religiös",
    regional: "Regional",
    addHoliday: "Feiertag hinzufügen",
    wantDelay: "Möchten Sie Verspätungs-/Strafeneinstellungen hinzufügen?",
    enableLatePenalties: "Verspätungsstrafen aktivieren",
    delayMinutes: "Verspätungsminuten (ab Schichtbeginn)",
    delayMinutesFromShiftStart: "Hinweis: Minuten werden ab Schichtbeginn gezählt — nicht nach der Kulanzzeit.",
    delayGraceHint: "Aktuelle Schicht-Kulanzzeit: {grace} Minuten. Vorgeschlagene erste Regel: nach {suggested} Minuten ab Schichtbeginn.",
    delayMinutesHelp: "Muss größer als die Kulanzzeit ({grace}) sein — Minimum {min}.",
    delayMustExceedGrace: "Regel {n}: Verspätungsminuten ({delay}) müssen größer als die Kulanzzeit ({grace}) sein — beides ab Schichtbeginn",
    delayMinutesRequired: "Regel {n}: Gültige Verspätungsminuten eingeben (mindestens 1)",
    penaltyType: "Strafart",
    selectPenaltyType: "Strafart auswählen",
    quarterDay: "Vierteltag",
    halfDay: "Halber Tag",
    fullDay: "Ganzer Tag",
    setupComplete: "Ihr Konto wurde erfolgreich eingerichtet",
    setupCompleteHint: "Sie können diese Einstellungen später auf der Einstellungsseite vervollständigen oder bearbeiten",
    geolocationNotSupported: "Geolokalisierung wird nicht unterstützt",
    locationSet: "Standort festgelegt",
    getLocationFailed: "Standort konnte nicht ermittelt werden",
    saveSuccess: "Erfolgreich gespeichert",
    saveFailed: "Speichern fehlgeschlagen",
    enterBranchName: "Filialnamen eingeben",
    branchAdded: "Filiale hinzugefügt",
    addBranchFailed: "Filiale konnte nicht hinzugefügt werden",
    enterNameAndDate: "Name und Datum eingeben",
    holidayAdded: "Feiertag hinzugefügt",
    addHolidayFailed: "Feiertag konnte nicht hinzugefügt werden",
    delaySaved: "Verspätungseinstellungen gespeichert",
    delaySaveFailed: "Speichern fehlgeschlagen",
    approvalsRoutingQuestion: "An wen sollen Urlaubs- und Genehmigungsanträge (z. B. früher Feierabend) gesendet werden?",
    approvalsRoutingHint: "Ohne Auswahl ist Teamleiter der Standard. Der Admin kann Anträge später bei Bedarf vom Teamleiter übernehmen.",
    approvalsToTeamLeader: "Teamleiter (empfohlen)",
    approvalsToTeamLeaderDesc: "Anträge gehen an den Abteilungs-Teamleiter. Der Admin greift erst nach Übernahme (Take Over) ein.",
    approvalsToAdmin: "Nur Admin",
    approvalsToAdminDesc: "Alle Urlaubs- und Genehmigungsanträge gehen direkt an den Admin.",
    sunday: "So",
    monday: "Mo",
    tuesday: "Di",
    wednesday: "Mi",
    thursday: "Do",
    friday: "Fr",
    saturday: "Sa"
  },
  signup: {
    title: "Neues Konto erstellen",
    subtitle: "Treten Sie dem HR-Management-System bei",
    formTitle: "Neues Konto erstellen",
    formSubtitle: "Geben Sie Ihre Daten ein, um ein Konto zu erstellen",
    username: "Benutzername",
    usernamePlaceholder: "Benutzername eingeben",
    firstName: "Vorname",
    firstNamePlaceholder: "Vorname eingeben",
    lastName: "Nachname",
    lastNamePlaceholder: "Nachname eingeben",
    email: "E-Mail",
    emailPlaceholder: "E-Mail eingeben",
    phone: "Telefonnummer",
    phonePlaceholder: "Telefonnummer eingeben",
    department: "Abteilung",
    selectDepartment: "Abteilung auswählen",
    loadingDepartments: "Abteilungen werden geladen...",
    role: "Stellenbezeichnung",
    selectRole: "Stellenbezeichnung auswählen",
    trainee: "Praktikant",
    employee: "Mitarbeiter",
    orgId: "Organisationscode",
    orgIdHint: "Geben Sie den Firmencode (XX-0000) ein, um Abteilungen zu laden",
    enterOrgIdFirst: "Zuerst den Firmencode eingeben",
    nationalId: "Nationale ID",
    nationalIdPlaceholder: "Nationale ID eingeben",
    gender: "Geschlecht",
    selectGender: "Geschlecht auswählen",
    male: "Männlich",
    female: "Weiblich",
    idFront: "Ausweis Vorderseite",
    idBack: "Ausweis Rückseite",
    password: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    confirmPassword: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Passwort erneut eingeben",
    createAccount: "Konto erstellen",
    creating: "Konto wird erstellt...",
    alreadyHaveAccount: "Bereits ein Konto?",
    login: "Anmelden",
    joinHr: "Treten Sie dem HR-Management-System bei",
    featureDataTitle: "Datenverwaltung",
    featureDataDesc: "Aktualisieren und verwalten Sie Ihre persönlichen Daten",
    featureSalaryTitle: "Gehaltsverfolgung",
    featureSalaryDesc: "Gehalt, Zulagen und Abzüge verfolgen",
    featureLeaveTitle: "Urlaubsanträge",
    featureLeaveDesc: "Urlaubsanträge einreichen und verfolgen",
    featureReportsTitle: "Berichte",
    featureReportsDesc: "Berichte und Statistiken anzeigen",
    validationUsername: "Bitte Benutzername eingeben",
    validationEmail: "Bitte E-Mail eingeben",
    validationEmailInvalid: "Bitte gültige E-Mail eingeben",
    validationPasswordLength: "Passwort ist erforderlich",
    validationPasswordMax: "Passwort darf höchstens 128 Zeichen haben",
    passwordTooCommon: "Dieses Passwort ist zu häufig. Wählen Sie ein stärkeres",
    validationOrgId: "Bitte gültigen Organisationscode eingeben (XX-0000)",
    validationPasswordMismatch: "Passwort und Bestätigung stimmen nicht überein",
    validationFirstName: "Bitte Vorname eingeben",
    validationLastName: "Bitte Nachname eingeben",
    validationPhone: "Bitte gültige Telefonnummer eingeben",
    validationDepartment: "Bitte Abteilung auswählen",
    validationRole: "Bitte Stellenbezeichnung auswählen",
    validationNationalId: "Bitte nationale ID eingeben",
    validationGender: "Bitte Geschlecht auswählen",
    validationIdFront: "Bitte Ausweis Vorderseite hochladen",
    validationIdBack: "Bitte Ausweis Rückseite hochladen",
    successFallback: "Konto erfolgreich erstellt! Warten auf Admin-Freigabe.",
    errorFallback: "Beim Erstellen des Kontos ist ein Fehler aufgetreten",
    identifierExists: "Ein Konto mit dieser E-Mail, Telefonnummer, diesem Benutzernamen oder dieser Personalausweisnummer existiert bereits",
    departmentsLoadFailed: "Abteilungen konnten nicht geladen werden",
    departmentsFetchError: "Fehler beim Laden der Abteilungen. Bitte später erneut versuchen."
  },
  payrollStats: {
    title: "Gehaltsabrechnungsstatistiken",
    fetchTitle: "Gehaltsstatistiken abrufen",
    monthOrYear: "Monat oder Jahr",
    datePlaceholder: "Jahr oder Monat und Jahr wählen",
    selectMonthYear: "Monat und Jahr wählen",
    selectYearOnly: "Nur Jahr wählen",
    dateHint: "Wählen Sie ein Jahr (z. B. 2024) oder Monat und Jahr (z. B. 2024-08). Der Monat wird immer zweistellig angezeigt (01 bis 12).",
    fetchStats: "Statistiken abrufen",
    willFetchMonth: "Statistiken für Monat {period} werden abgerufen",
    willFetchYear: "Statistiken für Jahr {period} werden abgerufen",
    selectDateError: "Bitte Jahr oder Monat und Jahr wählen",
    authError: "Ungültiges Authentifizierungstoken. Bitte erneut anmelden.",
    serverError: "Serververbindungsfehler: {status}",
    fetchFailed: "Gehaltsstatistiken konnten nicht abgerufen werden",
    invalidResponse: "Ungültige Antwortdaten",
    fetchSuccess: "Gehaltsstatistiken erfolgreich abgerufen",
    notAvailable: "Nicht verfügbar",
    unspecified: "Nicht angegeben",
    employeesInfo: "Mitarbeiterinformationen",
    totalEmployees: "Mitarbeiter gesamt:",
    withPayroll: "Mit Abrechnung:",
    withoutPayroll: "Ohne Abrechnung:",
    financialInfo: "Finanzinformationen",
    totalSalaries: "Gehälter gesamt:",
    totalPaid: "Gezahlter Betrag:",
    totalRemaining: "Restbetrag:",
    percentagePaid: "Zahlungsanteil:",
    statusSummary: "Statusübersicht",
    paid: "Bezahlt:",
    partiallyPaid: "Teilweise bezahlt:",
    pending: "Ausstehend:",
    processing: "In Bearbeitung:",
    cancelled: "Storniert:",
    noStatusData: "Keine Statusaufschlüsselung verfügbar",
    payrollPeriod: "Abrechnungszeitraum",
    selectedMonth: "Ausgewählter Monat",
    selectedYear: "Ausgewähltes Jahr",
    unspecifiedPeriod: "Zeitraum nicht angegeben",
    months: {
      "01": "Januar",
      "02": "Februar",
      "03": "März",
      "04": "April",
      "05": "Mai",
      "06": "Juni",
      "07": "Juli",
      "08": "August",
      "09": "September",
      "10": "Oktober",
      "11": "November",
      "12": "Dezember"
    }
  },
  leader: {
    employeeUpdateForm: {
      title: "Mitarbeiterdaten aktualisieren",
      name: "Name",
      namePlaceholder: "Namen eingeben",
      email: "E-Mail",
      emailPlaceholder: "E-Mail eingeben",
      phone: "Telefonnummer",
      phonePlaceholder: "Telefonnummer eingeben",
      department: "Abteilung",
      departmentPlaceholder: "Abteilung eingeben",
      position: "Position",
      positionPlaceholder: "Position eingeben",
      address: "Adresse",
      addressPlaceholder: "Adresse eingeben",
      nationalID: "Nationale ID",
      nationalIDPlaceholder: "Nationale ID eingeben",
      baseSalary: "Grundgehalt (SAR)",
      baseSalaryPlaceholder: "Grundgehalt eingeben",
      experience: "Erfahrung",
      experiencePlaceholder: "Erfahrungsdetails eingeben",
      education: "Ausbildung",
      educationPlaceholder: "Ausbildungsdetails eingeben",
      skills: "Fähigkeiten (durch Kommas getrennt)",
      skillsPlaceholder: "Fähigkeiten eingeben (z. B. js, python)",
      deductions: "Abzüge",
      socialInsurance: "Sozialversicherung (SAR)",
      socialInsurancePlaceholder: "Sozialversicherung eingeben",
      tax: "Steuer (SAR)",
      taxPlaceholder: "Steuer eingeben",
      fetchFailed: "Mitarbeiterdaten konnten nicht abgerufen werden",
      updateSuccess: "Mitarbeiterdaten erfolgreich aktualisiert",
      updateFailed: "Aktualisierung der Mitarbeiterdaten fehlgeschlagen",
      updating: "Wird aktualisiert...",
      submit: "Mitarbeiterdaten aktualisieren"
    }
  },
  phone3d: {
    title: "TeamIN in Aktion sehen",
    subtitle: "Entdecken Sie die mobile App auf einem Samsung-Gerät — Chat und Check-in",
    loading: "3D-Ansicht wird geladen...",
    dragHint: "Zum Drehen ziehen"
  }
};
